import tty from 'tty';
import os from 'os';
import deepmerge from 'deepmerge';
import axios from 'axios';
import Vue from 'vue';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = o[Symbol.iterator]();
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

/**
 * Helpers.
 */
var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

var ms = function ms(val, options) {
  options = options || {};

  var type = _typeof(val);

  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }

  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */


function parse(str) {
  str = String(str);

  if (str.length > 100) {
    return;
  }

  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);

  if (!match) {
    return;
  }

  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();

  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;

    case 'weeks':
    case 'week':
    case 'w':
      return n * w;

    case 'days':
    case 'day':
    case 'd':
      return n * d;

    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;

    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;

    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;

    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;

    default:
      return undefined;
  }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */


function fmtShort(ms) {
  var msAbs = Math.abs(ms);

  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }

  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }

  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }

  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }

  return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */


function fmtLong(ms) {
  var msAbs = Math.abs(ms);

  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }

  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }

  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }

  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }

  return ms + ' ms';
}
/**
 * Pluralization helper.
 */


function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

function setup(env) {
  createDebug.debug = createDebug;
  createDebug.default = createDebug;
  createDebug.coerce = coerce;
  createDebug.disable = disable;
  createDebug.enable = enable;
  createDebug.enabled = enabled;
  createDebug.humanize = ms;
  Object.keys(env).forEach(function (key) {
    createDebug[key] = env[key];
  });
  /**
  * Active `debug` instances.
  */

  createDebug.instances = [];
  /**
  * The currently active debug mode names, and names to skip.
  */

  createDebug.names = [];
  createDebug.skips = [];
  /**
  * Map of special "%n" handling functions, for the debug "format" argument.
  *
  * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
  */

  createDebug.formatters = {};
  /**
  * Selects a color for a debug namespace
  * @param {String} namespace The namespace string for the for the debug instance to be colored
  * @return {Number|String} An ANSI color code for the given namespace
  * @api private
  */

  function selectColor(namespace) {
    var hash = 0;

    for (var i = 0; i < namespace.length; i++) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
  }

  createDebug.selectColor = selectColor;
  /**
  * Create a debugger with the given `namespace`.
  *
  * @param {String} namespace
  * @return {Function}
  * @api public
  */

  function createDebug(namespace) {
    var prevTime;

    function debug() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      // Disabled?
      if (!debug.enabled) {
        return;
      }

      var self = debug; // Set `diff` timestamp

      var curr = Number(new Date());
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;
      args[0] = createDebug.coerce(args[0]);

      if (typeof args[0] !== 'string') {
        // Anything else let's inspect with %O
        args.unshift('%O');
      } // Apply any `formatters` transformations


      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
        // If we encounter an escaped % then don't increase the array index
        if (match === '%%') {
          return match;
        }

        index++;
        var formatter = createDebug.formatters[format];

        if (typeof formatter === 'function') {
          var val = args[index];
          match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`

          args.splice(index, 1);
          index--;
        }

        return match;
      }); // Apply env-specific formatting (colors, etc.)

      createDebug.formatArgs.call(self, args);
      var logFn = self.log || createDebug.log;
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.enabled = createDebug.enabled(namespace);
    debug.useColors = createDebug.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    debug.extend = extend; // Debug.formatArgs = formatArgs;
    // debug.rawLog = rawLog;
    // env-specific initialization logic for debug instances

    if (typeof createDebug.init === 'function') {
      createDebug.init(debug);
    }

    createDebug.instances.push(debug);
    return debug;
  }

  function destroy() {
    var index = createDebug.instances.indexOf(this);

    if (index !== -1) {
      createDebug.instances.splice(index, 1);
      return true;
    }

    return false;
  }

  function extend(namespace, delimiter) {
    var newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
    newDebug.log = this.log;
    return newDebug;
  }
  /**
  * Enables a debug mode by namespaces. This can include modes
  * separated by a colon and wildcards.
  *
  * @param {String} namespaces
  * @api public
  */


  function enable(namespaces) {
    createDebug.save(namespaces);
    createDebug.names = [];
    createDebug.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (i = 0; i < len; i++) {
      if (!split[i]) {
        // ignore empty strings
        continue;
      }

      namespaces = split[i].replace(/\*/g, '.*?');

      if (namespaces[0] === '-') {
        createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        createDebug.names.push(new RegExp('^' + namespaces + '$'));
      }
    }

    for (i = 0; i < createDebug.instances.length; i++) {
      var instance = createDebug.instances[i];
      instance.enabled = createDebug.enabled(instance.namespace);
    }
  }
  /**
  * Disable debug output.
  *
  * @return {String} namespaces
  * @api public
  */


  function disable() {
    var namespaces = [].concat(_toConsumableArray(createDebug.names.map(toNamespace)), _toConsumableArray(createDebug.skips.map(toNamespace).map(function (namespace) {
      return '-' + namespace;
    }))).join(',');
    createDebug.enable('');
    return namespaces;
  }
  /**
  * Returns true if the given mode name is enabled, false otherwise.
  *
  * @param {String} name
  * @return {Boolean}
  * @api public
  */


  function enabled(name) {
    if (name[name.length - 1] === '*') {
      return true;
    }

    var i;
    var len;

    for (i = 0, len = createDebug.skips.length; i < len; i++) {
      if (createDebug.skips[i].test(name)) {
        return false;
      }
    }

    for (i = 0, len = createDebug.names.length; i < len; i++) {
      if (createDebug.names[i].test(name)) {
        return true;
      }
    }

    return false;
  }
  /**
  * Convert regexp to namespace
  *
  * @param {RegExp} regxep
  * @return {String} namespace
  * @api private
  */


  function toNamespace(regexp) {
    return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, '*');
  }
  /**
  * Coerce `val`.
  *
  * @param {Mixed} val
  * @return {Mixed}
  * @api private
  */


  function coerce(val) {
    if (val instanceof Error) {
      return val.stack || val.message;
    }

    return val;
  }

  createDebug.enable(createDebug.load());
  return createDebug;
}

var common = setup;

var browser = createCommonjsModule(function (module, exports) {
  /* eslint-env browser */

  /**
   * This is the web browser implementation of `debug()`.
   */
  exports.log = log;
  exports.formatArgs = formatArgs;
  exports.save = save;
  exports.load = load;
  exports.useColors = useColors;
  exports.storage = localstorage();
  /**
   * Colors.
   */

  exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
  /**
   * Currently only WebKit-based Web Inspectors, Firefox >= v31,
   * and the Firebug extension (any Firefox version) are known
   * to support "%c" CSS customizations.
   *
   * TODO: add a `localStorage` variable to explicitly enable/disable colors
   */
  // eslint-disable-next-line complexity

  function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
      return true;
    } // Internet Explorer and Edge do not support colors.


    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
      return false;
    } // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  /**
   * Colorize log arguments if enabled.
   *
   * @api public
   */


  function formatArgs(args) {
    args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);

    if (!this.useColors) {
      return;
    }

    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into

    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function (match) {
      if (match === '%%') {
        return;
      }

      index++;

      if (match === '%c') {
        // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
      }
    });
    args.splice(lastC, 0, c);
  }
  /**
   * Invokes `console.log()` when available.
   * No-op when `console.log` is not a "function".
   *
   * @api public
   */


  function log() {
    var _console;

    // This hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
  }
  /**
   * Save `namespaces`.
   *
   * @param {String} namespaces
   * @api private
   */


  function save(namespaces) {
    try {
      if (namespaces) {
        exports.storage.setItem('debug', namespaces);
      } else {
        exports.storage.removeItem('debug');
      }
    } catch (error) {// Swallow
      // XXX (@Qix-) should we be logging these?
    }
  }
  /**
   * Load `namespaces`.
   *
   * @return {String} returns the previously persisted debug modes
   * @api private
   */


  function load() {
    var r;

    try {
      r = exports.storage.getItem('debug');
    } catch (error) {// Swallow
      // XXX (@Qix-) should we be logging these?
    } // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


    if (!r && typeof process !== 'undefined' && 'env' in process) {
      r = process.env.DEBUG;
    }

    return r;
  }
  /**
   * Localstorage attempts to return the localstorage.
   *
   * This is necessary because safari throws
   * when a user disables cookies/localstorage
   * and you attempt to access it.
   *
   * @return {LocalStorage}
   * @api private
   */


  function localstorage() {
    try {
      // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
      // The Browser also has localStorage in the global context.
      return localStorage;
    } catch (error) {// Swallow
      // XXX (@Qix-) should we be logging these?
    }
  }

  module.exports = common(exports);
  var formatters = module.exports.formatters;
  /**
   * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
   */

  formatters.j = function (v) {
    try {
      return JSON.stringify(v);
    } catch (error) {
      return '[UnexpectedJSONParseError]: ' + error.message;
    }
  };
});
var browser_1 = browser.log;
var browser_2 = browser.formatArgs;
var browser_3 = browser.save;
var browser_4 = browser.load;
var browser_5 = browser.useColors;
var browser_6 = browser.storage;
var browser_7 = browser.colors;

var isBuffer = function isBuffer(arg) {
  return arg instanceof Buffer;
};

var inherits_browser = createCommonjsModule(function (module) {
  if (typeof Object.create === 'function') {
    // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    };
  } else {
    // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;

      var TempCtor = function TempCtor() {};

      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    };
  }
});

var inherits = createCommonjsModule(function (module) {
  try {
    var util$1 = util;
    if (typeof util$1.inherits !== 'function') throw '';
    module.exports = util$1.inherits;
  } catch (e) {
    module.exports = inherits_browser;
  }
});

var util = createCommonjsModule(function (module, exports) {
  // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.
  var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};

    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }

    return descriptors;
  };

  var formatRegExp = /%[sdj%]/g;

  exports.format = function (f) {
    if (!isString(f)) {
      var objects = [];

      for (var i = 0; i < arguments.length; i++) {
        objects.push(inspect(arguments[i]));
      }

      return objects.join(' ');
    }

    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') return '%';
      if (i >= len) return x;

      switch (x) {
        case '%s':
          return String(args[i++]);

        case '%d':
          return Number(args[i++]);

        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }

        default:
          return x;
      }
    });

    for (var x = args[i]; i < len; x = args[++i]) {
      if (isNull(x) || !isObject(x)) {
        str += ' ' + x;
      } else {
        str += ' ' + inspect(x);
      }
    }

    return str;
  }; // Mark that a method should not be used.
  // Returns a modified function which warns once by default.
  // If --no-deprecation is set, then it is a no-op.


  exports.deprecate = function (fn, msg) {
    if (typeof process !== 'undefined' && process.noDeprecation === true) {
      return fn;
    } // Allow for deprecating things in the process of starting up.


    if (typeof process === 'undefined') {
      return function () {
        return exports.deprecate(fn, msg).apply(this, arguments);
      };
    }

    var warned = false;

    function deprecated() {
      if (!warned) {
        if (process.throwDeprecation) {
          throw new Error(msg);
        } else if (process.traceDeprecation) {
          console.trace(msg);
        } else {
          console.error(msg);
        }

        warned = true;
      }

      return fn.apply(this, arguments);
    }

    return deprecated;
  };

  var debugs = {};
  var debugEnviron;

  exports.debuglog = function (set) {
    if (isUndefined(debugEnviron)) debugEnviron = process.env.NODE_DEBUG || '';
    set = set.toUpperCase();

    if (!debugs[set]) {
      if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
        var pid = process.pid;

        debugs[set] = function () {
          var msg = exports.format.apply(exports, arguments);
          console.error('%s %d: %s', set, pid, msg);
        };
      } else {
        debugs[set] = function () {};
      }
    }

    return debugs[set];
  };
  /**
   * Echos the value of a value. Trys to print the value out
   * in the best way possible given the different types.
   *
   * @param {Object} obj The object to print out.
   * @param {Object} opts Optional options object that alters the output.
   */

  /* legacy: obj, showHidden, depth, colors*/


  function inspect(obj, opts) {
    // default options
    var ctx = {
      seen: [],
      stylize: stylizeNoColor
    }; // legacy...

    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];

    if (isBoolean(opts)) {
      // legacy...
      ctx.showHidden = opts;
    } else if (opts) {
      // got an "options" object
      exports._extend(ctx, opts);
    } // set default options


    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if (isUndefined(ctx.depth)) ctx.depth = 2;
    if (isUndefined(ctx.colors)) ctx.colors = false;
    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = stylizeWithColor;
    return formatValue(ctx, obj, ctx.depth);
  }

  exports.inspect = inspect; // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics

  inspect.colors = {
    'bold': [1, 22],
    'italic': [3, 23],
    'underline': [4, 24],
    'inverse': [7, 27],
    'white': [37, 39],
    'grey': [90, 39],
    'black': [30, 39],
    'blue': [34, 39],
    'cyan': [36, 39],
    'green': [32, 39],
    'magenta': [35, 39],
    'red': [31, 39],
    'yellow': [33, 39]
  }; // Don't use 'blue' not visible on cmd.exe

  inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
  };

  function stylizeWithColor(str, styleType) {
    var style = inspect.styles[styleType];

    if (style) {
      return "\x1B[" + inspect.colors[style][0] + 'm' + str + "\x1B[" + inspect.colors[style][1] + 'm';
    } else {
      return str;
    }
  }

  function stylizeNoColor(str, styleType) {
    return str;
  }

  function arrayToHash(array) {
    var hash = {};
    array.forEach(function (val, idx) {
      hash[val] = true;
    });
    return hash;
  }

  function formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
      var ret = value.inspect(recurseTimes, ctx);

      if (!isString(ret)) {
        ret = formatValue(ctx, ret, recurseTimes);
      }

      return ret;
    } // Primitive types cannot have properties


    var primitive = formatPrimitive(ctx, value);

    if (primitive) {
      return primitive;
    } // Look up the keys of the object.


    var keys = Object.keys(value);
    var visibleKeys = arrayToHash(keys);

    if (ctx.showHidden) {
      keys = Object.getOwnPropertyNames(value);
    } // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx


    if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
      return formatError(value);
    } // Some type of object without properties can be shortcutted.


    if (keys.length === 0) {
      if (isFunction(value)) {
        var name = value.name ? ': ' + value.name : '';
        return ctx.stylize('[Function' + name + ']', 'special');
      }

      if (isRegExp(value)) {
        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
      }

      if (isDate(value)) {
        return ctx.stylize(Date.prototype.toString.call(value), 'date');
      }

      if (isError(value)) {
        return formatError(value);
      }
    }

    var base = '',
        array = false,
        braces = ['{', '}']; // Make Array say that they are Array

    if (isArray(value)) {
      array = true;
      braces = ['[', ']'];
    } // Make functions say that they are functions


    if (isFunction(value)) {
      var n = value.name ? ': ' + value.name : '';
      base = ' [Function' + n + ']';
    } // Make RegExps say that they are RegExps


    if (isRegExp(value)) {
      base = ' ' + RegExp.prototype.toString.call(value);
    } // Make dates with properties first say the date


    if (isDate(value)) {
      base = ' ' + Date.prototype.toUTCString.call(value);
    } // Make error with message first say the error


    if (isError(value)) {
      base = ' ' + formatError(value);
    }

    if (keys.length === 0 && (!array || value.length == 0)) {
      return braces[0] + base + braces[1];
    }

    if (recurseTimes < 0) {
      if (isRegExp(value)) {
        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
      } else {
        return ctx.stylize('[Object]', 'special');
      }
    }

    ctx.seen.push(value);
    var output;

    if (array) {
      output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    } else {
      output = keys.map(function (key) {
        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
      });
    }

    ctx.seen.pop();
    return reduceToSingleString(output, base, braces);
  }

  function formatPrimitive(ctx, value) {
    if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');

    if (isString(value)) {
      var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
      return ctx.stylize(simple, 'string');
    }

    if (isNumber(value)) return ctx.stylize('' + value, 'number');
    if (isBoolean(value)) return ctx.stylize('' + value, 'boolean'); // For some reason typeof null is "object", so special case here.

    if (isNull(value)) return ctx.stylize('null', 'null');
  }

  function formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
  }

  function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];

    for (var i = 0, l = value.length; i < l; ++i) {
      if (hasOwnProperty(value, String(i))) {
        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
      } else {
        output.push('');
      }
    }

    keys.forEach(function (key) {
      if (!key.match(/^\d+$/)) {
        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
      }
    });
    return output;
  }

  function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
      value: value[key]
    };

    if (desc.get) {
      if (desc.set) {
        str = ctx.stylize('[Getter/Setter]', 'special');
      } else {
        str = ctx.stylize('[Getter]', 'special');
      }
    } else {
      if (desc.set) {
        str = ctx.stylize('[Setter]', 'special');
      }
    }

    if (!hasOwnProperty(visibleKeys, key)) {
      name = '[' + key + ']';
    }

    if (!str) {
      if (ctx.seen.indexOf(desc.value) < 0) {
        if (isNull(recurseTimes)) {
          str = formatValue(ctx, desc.value, null);
        } else {
          str = formatValue(ctx, desc.value, recurseTimes - 1);
        }

        if (str.indexOf('\n') > -1) {
          if (array) {
            str = str.split('\n').map(function (line) {
              return '  ' + line;
            }).join('\n').substr(2);
          } else {
            str = '\n' + str.split('\n').map(function (line) {
              return '   ' + line;
            }).join('\n');
          }
        }
      } else {
        str = ctx.stylize('[Circular]', 'special');
      }
    }

    if (isUndefined(name)) {
      if (array && key.match(/^\d+$/)) {
        return str;
      }

      name = JSON.stringify('' + key);

      if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
        name = name.substr(1, name.length - 2);
        name = ctx.stylize(name, 'name');
      } else {
        name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
        name = ctx.stylize(name, 'string');
      }
    }

    return name + ': ' + str;
  }

  function reduceToSingleString(output, base, braces) {
    var length = output.reduce(function (prev, cur) {
      if (cur.indexOf('\n') >= 0) ;
      return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);

    if (length > 60) {
      return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    }

    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
  } // NOTE: These type checking functions intentionally don't use `instanceof`
  // because it is fragile and can be easily faked with `Object.create()`.


  function isArray(ar) {
    return Array.isArray(ar);
  }

  exports.isArray = isArray;

  function isBoolean(arg) {
    return typeof arg === 'boolean';
  }

  exports.isBoolean = isBoolean;

  function isNull(arg) {
    return arg === null;
  }

  exports.isNull = isNull;

  function isNullOrUndefined(arg) {
    return arg == null;
  }

  exports.isNullOrUndefined = isNullOrUndefined;

  function isNumber(arg) {
    return typeof arg === 'number';
  }

  exports.isNumber = isNumber;

  function isString(arg) {
    return typeof arg === 'string';
  }

  exports.isString = isString;

  function isSymbol(arg) {
    return _typeof(arg) === 'symbol';
  }

  exports.isSymbol = isSymbol;

  function isUndefined(arg) {
    return arg === void 0;
  }

  exports.isUndefined = isUndefined;

  function isRegExp(re) {
    return isObject(re) && objectToString(re) === '[object RegExp]';
  }

  exports.isRegExp = isRegExp;

  function isObject(arg) {
    return _typeof(arg) === 'object' && arg !== null;
  }

  exports.isObject = isObject;

  function isDate(d) {
    return isObject(d) && objectToString(d) === '[object Date]';
  }

  exports.isDate = isDate;

  function isError(e) {
    return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
  }

  exports.isError = isError;

  function isFunction(arg) {
    return typeof arg === 'function';
  }

  exports.isFunction = isFunction;

  function isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || _typeof(arg) === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
  }

  exports.isPrimitive = isPrimitive;
  exports.isBuffer = isBuffer;

  function objectToString(o) {
    return Object.prototype.toString.call(o);
  }

  function pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
  }

  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']; // 26 Feb 16:19:34

  function timestamp() {
    var d = new Date();
    var time = [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
    return [d.getDate(), months[d.getMonth()], time].join(' ');
  } // log is just a thin wrapper to console.log that prepends a timestamp


  exports.log = function () {
    console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
  };
  /**
   * Inherit the prototype methods from one constructor into another.
   *
   * The Function.prototype.inherits from lang.js rewritten as a standalone
   * function (not on Function.prototype). NOTE: If this file is to be loaded
   * during bootstrapping this function needs to be rewritten using some native
   * functions as prototype setup using normal JavaScript does not work as
   * expected during bootstrapping (see mirror.js in r114903).
   *
   * @param {function} ctor Constructor function which needs to inherit the
   *     prototype.
   * @param {function} superCtor Constructor function to inherit prototype from.
   */


  exports.inherits = inherits;

  exports._extend = function (origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;

    while (i--) {
      origin[keys[i]] = add[keys[i]];
    }

    return origin;
  };

  function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }

  var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

  exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');

    if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
      var fn = original[kCustomPromisifiedSymbol];

      if (typeof fn !== 'function') {
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      }

      Object.defineProperty(fn, kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
      });
      return fn;
    }

    function fn() {
      var promiseResolve, promiseReject;
      var promise = new Promise(function (resolve, reject) {
        promiseResolve = resolve;
        promiseReject = reject;
      });
      var args = [];

      for (var i = 0; i < arguments.length; i++) {
        args.push(arguments[i]);
      }

      args.push(function (err, value) {
        if (err) {
          promiseReject(err);
        } else {
          promiseResolve(value);
        }
      });

      try {
        original.apply(this, args);
      } catch (err) {
        promiseReject(err);
      }

      return promise;
    }

    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn,
      enumerable: false,
      writable: false,
      configurable: true
    });
    return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
  };

  exports.promisify.custom = kCustomPromisifiedSymbol;

  function callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
      var newReason = new Error('Promise was rejected with a falsy value');
      newReason.reason = reason;
      reason = newReason;
    }

    return cb(reason);
  }

  function callbackify(original) {
    if (typeof original !== 'function') {
      throw new TypeError('The "original" argument must be of type Function');
    } // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.


    function callbackified() {
      var args = [];

      for (var i = 0; i < arguments.length; i++) {
        args.push(arguments[i]);
      }

      var maybeCb = args.pop();

      if (typeof maybeCb !== 'function') {
        throw new TypeError('The last argument must be of type Function');
      }

      var self = this;

      var cb = function cb() {
        return maybeCb.apply(self, arguments);
      }; // In true node style we process the callback on `nextTick` with all the
      // implications (stack, `uncaughtException`, `async_hooks`)


      original.apply(this, args).then(function (ret) {
        process.nextTick(cb, null, ret);
      }, function (rej) {
        process.nextTick(callbackifyOnRejected, rej, cb);
      });
    }

    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
    return callbackified;
  }

  exports.callbackify = callbackify;
});
var util_1 = util.format;
var util_2 = util.deprecate;
var util_3 = util.debuglog;
var util_4 = util.inspect;
var util_5 = util.isArray;
var util_6 = util.isBoolean;
var util_7 = util.isNull;
var util_8 = util.isNullOrUndefined;
var util_9 = util.isNumber;
var util_10 = util.isString;
var util_11 = util.isSymbol;
var util_12 = util.isUndefined;
var util_13 = util.isRegExp;
var util_14 = util.isObject;
var util_15 = util.isDate;
var util_16 = util.isError;
var util_17 = util.isFunction;
var util_18 = util.isPrimitive;
var util_19 = util.isBuffer;
var util_20 = util.log;
var util_21 = util.inherits;
var util_22 = util._extend;
var util_23 = util.promisify;
var util_24 = util.callbackify;

var hasFlag = function hasFlag(flag, argv) {
  argv = argv || process.argv;
  var prefix = flag.startsWith('-') ? '' : flag.length === 1 ? '-' : '--';
  var pos = argv.indexOf(prefix + flag);
  var terminatorPos = argv.indexOf('--');
  return pos !== -1 && (terminatorPos === -1 ? true : pos < terminatorPos);
};

var _process = process,
    env = _process.env;
var forceColor;

if (hasFlag('no-color') || hasFlag('no-colors') || hasFlag('color=false') || hasFlag('color=never')) {
  forceColor = 0;
} else if (hasFlag('color') || hasFlag('colors') || hasFlag('color=true') || hasFlag('color=always')) {
  forceColor = 1;
}

if ('FORCE_COLOR' in env) {
  if (env.FORCE_COLOR === true || env.FORCE_COLOR === 'true') {
    forceColor = 1;
  } else if (env.FORCE_COLOR === false || env.FORCE_COLOR === 'false') {
    forceColor = 0;
  } else {
    forceColor = env.FORCE_COLOR.length === 0 ? 1 : Math.min(parseInt(env.FORCE_COLOR, 10), 3);
  }
}

function translateLevel(level) {
  if (level === 0) {
    return false;
  }

  return {
    level: level,
    hasBasic: true,
    has256: level >= 2,
    has16m: level >= 3
  };
}

function supportsColor(stream) {
  if (forceColor === 0) {
    return 0;
  }

  if (hasFlag('color=16m') || hasFlag('color=full') || hasFlag('color=truecolor')) {
    return 3;
  }

  if (hasFlag('color=256')) {
    return 2;
  }

  if (stream && !stream.isTTY && forceColor === undefined) {
    return 0;
  }

  var min = forceColor || 0;

  if (env.TERM === 'dumb') {
    return min;
  }

  if (process.platform === 'win32') {
    // Node.js 7.5.0 is the first version of Node.js to include a patch to
    // libuv that enables 256 color output on Windows. Anything earlier and it
    // won't work. However, here we target Node.js 8 at minimum as it is an LTS
    // release, and Node.js 7 is not. Windows 10 build 10586 is the first Windows
    // release that supports 256 colors. Windows 10 build 14931 is the first release
    // that supports 16m/TrueColor.
    var osRelease = os.release().split('.');

    if (Number(process.versions.node.split('.')[0]) >= 8 && Number(osRelease[0]) >= 10 && Number(osRelease[2]) >= 10586) {
      return Number(osRelease[2]) >= 14931 ? 3 : 2;
    }

    return 1;
  }

  if ('CI' in env) {
    if (['TRAVIS', 'CIRCLECI', 'APPVEYOR', 'GITLAB_CI'].some(function (sign) {
      return sign in env;
    }) || env.CI_NAME === 'codeship') {
      return 1;
    }

    return min;
  }

  if ('TEAMCITY_VERSION' in env) {
    return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(env.TEAMCITY_VERSION) ? 1 : 0;
  }

  if (env.COLORTERM === 'truecolor') {
    return 3;
  }

  if ('TERM_PROGRAM' in env) {
    var version = parseInt((env.TERM_PROGRAM_VERSION || '').split('.')[0], 10);

    switch (env.TERM_PROGRAM) {
      case 'iTerm.app':
        return version >= 3 ? 3 : 2;

      case 'Apple_Terminal':
        return 2;
      // No default
    }
  }

  if (/-256(color)?$/i.test(env.TERM)) {
    return 2;
  }

  if (/^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(env.TERM)) {
    return 1;
  }

  if ('COLORTERM' in env) {
    return 1;
  }

  return min;
}

function getSupportLevel(stream) {
  var level = supportsColor(stream);
  return translateLevel(level);
}

var supportsColor_1 = {
  supportsColor: getSupportLevel,
  stdout: getSupportLevel(process.stdout),
  stderr: getSupportLevel(process.stderr)
};

var node = createCommonjsModule(function (module, exports) {
  /**
   * Module dependencies.
   */

  /**
   * This is the Node.js implementation of `debug()`.
   */
  exports.init = init;
  exports.log = log;
  exports.formatArgs = formatArgs;
  exports.save = save;
  exports.load = load;
  exports.useColors = useColors;
  /**
   * Colors.
   */

  exports.colors = [6, 2, 3, 4, 5, 1];

  try {
    // Optional dependency (as in, doesn't need to be installed, NOT like optionalDependencies in package.json)
    // eslint-disable-next-line import/no-extraneous-dependencies
    var supportsColor = supportsColor_1;

    if (supportsColor && (supportsColor.stderr || supportsColor).level >= 2) {
      exports.colors = [20, 21, 26, 27, 32, 33, 38, 39, 40, 41, 42, 43, 44, 45, 56, 57, 62, 63, 68, 69, 74, 75, 76, 77, 78, 79, 80, 81, 92, 93, 98, 99, 112, 113, 128, 129, 134, 135, 148, 149, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 178, 179, 184, 185, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 214, 215, 220, 221];
    }
  } catch (error) {// Swallow - we only care if `supports-color` is available; it doesn't have to be.
  }
  /**
   * Build up the default `inspectOpts` object from the environment variables.
   *
   *   $ DEBUG_COLORS=no DEBUG_DEPTH=10 DEBUG_SHOW_HIDDEN=enabled node script.js
   */


  exports.inspectOpts = Object.keys(process.env).filter(function (key) {
    return /^debug_/i.test(key);
  }).reduce(function (obj, key) {
    // Camel-case
    var prop = key.substring(6).toLowerCase().replace(/_([a-z])/g, function (_, k) {
      return k.toUpperCase();
    }); // Coerce string value into JS value

    var val = process.env[key];

    if (/^(yes|on|true|enabled)$/i.test(val)) {
      val = true;
    } else if (/^(no|off|false|disabled)$/i.test(val)) {
      val = false;
    } else if (val === 'null') {
      val = null;
    } else {
      val = Number(val);
    }

    obj[prop] = val;
    return obj;
  }, {});
  /**
   * Is stdout a TTY? Colored output is enabled when `true`.
   */

  function useColors() {
    return 'colors' in exports.inspectOpts ? Boolean(exports.inspectOpts.colors) : tty.isatty(process.stderr.fd);
  }
  /**
   * Adds ANSI color escape codes if enabled.
   *
   * @api public
   */


  function formatArgs(args) {
    var name = this.namespace,
        useColors = this.useColors;

    if (useColors) {
      var c = this.color;
      var colorCode = "\x1B[3" + (c < 8 ? c : '8;5;' + c);
      var prefix = "  ".concat(colorCode, ";1m").concat(name, " \x1B[0m");
      args[0] = prefix + args[0].split('\n').join('\n' + prefix);
      args.push(colorCode + 'm+' + module.exports.humanize(this.diff) + "\x1B[0m");
    } else {
      args[0] = getDate() + name + ' ' + args[0];
    }
  }

  function getDate() {
    if (exports.inspectOpts.hideDate) {
      return '';
    }

    return new Date().toISOString() + ' ';
  }
  /**
   * Invokes `util.format()` with the specified arguments and writes to stderr.
   */


  function log() {
    return process.stderr.write(util.format.apply(util, arguments) + '\n');
  }
  /**
   * Save `namespaces`.
   *
   * @param {String} namespaces
   * @api private
   */


  function save(namespaces) {
    if (namespaces) {
      process.env.DEBUG = namespaces;
    } else {
      // If you set a process.env field to null or undefined, it gets cast to the
      // string 'null' or 'undefined'. Just delete instead.
      delete process.env.DEBUG;
    }
  }
  /**
   * Load `namespaces`.
   *
   * @return {String} returns the previously persisted debug modes
   * @api private
   */


  function load() {
    return process.env.DEBUG;
  }
  /**
   * Init logic for `debug` instances.
   *
   * Create a new `inspectOpts` object in case `useColors` is set
   * differently for a particular `debug` instance.
   */


  function init(debug) {
    debug.inspectOpts = {};
    var keys = Object.keys(exports.inspectOpts);

    for (var i = 0; i < keys.length; i++) {
      debug.inspectOpts[keys[i]] = exports.inspectOpts[keys[i]];
    }
  }

  module.exports = common(exports);
  var formatters = module.exports.formatters;
  /**
   * Map %o to `util.inspect()`, all on a single line.
   */

  formatters.o = function (v) {
    this.inspectOpts.colors = this.useColors;
    return util.inspect(v, this.inspectOpts).replace(/\s*\n\s*/g, ' ');
  };
  /**
   * Map %O to `util.inspect()`, allowing multiple lines if needed.
   */


  formatters.O = function (v) {
    this.inspectOpts.colors = this.useColors;
    return util.inspect(v, this.inspectOpts);
  };
});
var node_1 = node.init;
var node_2 = node.log;
var node_3 = node.formatArgs;
var node_4 = node.save;
var node_5 = node.load;
var node_6 = node.useColors;
var node_7 = node.colors;
var node_8 = node.inspectOpts;

var src = createCommonjsModule(function (module) {
  /**
   * Detect Electron renderer / nwjs process, which is node, but we should
   * treat as a browser.
   */
  if (typeof process === 'undefined' || process.type === 'renderer' || process.browser === true || process.__nwjs) {
    module.exports = browser;
  } else {
    module.exports = node;
  }
});

var log = src('xpedeo-core:cart');
src.enable(process.env.VUE_APP_DEBUG);
var Cart = {
  __pages: [],
  isInCart: function isInCart(pageId) {
    // log(`isInCart(${pageId})`)
    pageId = parseInt(pageId);

    if (this.__pages) {
      return this.__pages.some(function (page) {
        return page.id === pageId;
      });
    } else {
      return false;
    }
  },
  addToCart: function addToCart(pageId, pagePath, pageTitle) {
    // log(`addToCart(${pageId}, ${pagePath}, ${pageTitle})`)
    pageId = parseInt(pageId);

    if (!this.__pages) {
      this.__pages = [];
    }

    if (!this.isInCart(pageId)) {
      this.__pages.push({
        id: pageId,
        path: pagePath,
        title: pageTitle
      });

      this.saveCart();
    } // log({ __pages: this.__pages })

  },
  removeFromCart: function removeFromCart(pageId) {
    pageId = parseInt(pageId);

    if (this.__pages && this.isInCart(pageId)) {
      for (var i = this.__pages.length - 1; i >= 0; i--) {
        if (this.__pages[i].id === pageId) {
          this.__pages.splice(i, 1);
        }
      }

      this.saveCart();
    }
  },
  saveCart: function saveCart() {
    log('Saving Cart');
    window.localStorage.setItem('cart', JSON.stringify(this.__pages));
  },
  restoreCart: function restoreCart() {
    log('Restoring cart');
    this.__pages = JSON.parse(window.localStorage.getItem('cart')); // window.localStorage.setItem('cart', '')
  },
  install: function install(Vue, opts, $xp) {
    if ($xp.cartInstalled) {
      return;
    }

    $xp.cartInstalled = true;
    Vue.util.defineReactive($xp, 'cart', this);
  }
};

var log$1 = src('xpedeo-core:history');
src.enable(process.env.VUE_APP_DEBUG);
var History = {
  __homePages: [],
  __nextPageId: null,
  __historyArray: [],
  __router: null,
  __lastPanoramaPageId: null,
  __lastPanoramaHomePageId: null,
  __lastHomePage: null,
  __$xp: null,

  // @deprecated
  get homePageId() {
    if (this.__homePages.length) {
      return this.__homePages[this.__homePages.length - 1].id;
    }

    return null;
  },

  // @deprecated
  get previousHomePageId() {
    if (this.__homePages.length > 1) {
      return this.__homePages[this.__homePages.length - 2].id;
    }

    return null;
  },

  // @deprecated
  get homePage() {
    if (this.__homePages.length) {
      return this.__homePages[this.__homePages.length - 1];
    }

    return null;
  },

  // @deprecated
  get previousHomePage() {
    if (this.__homePages.length > 1) {
      return this.__homePages[this.__homePages.length - 2];
    }

    return null;
  },

  get lastHomePage() {
    return this.__lastHomePage || undefined;
  },

  get lastHomeEntry() {
    if (this.__historyArray.length > 0) {
      var homeMenuEntries = this.__historyArray.filter(function (it) {
        return it.homeMenuEntry === true;
      });

      if (homeMenuEntries.length > 0) {
        return homeMenuEntries[homeMenuEntries.length - 1];
      } else {
        return null;
      }
    } else {
      return null;
    }
  },

  get nextPageId() {
    return this.__nextPageId || null;
  },

  get historyArray() {
    return this.__historyArray;
  },

  get historyParams() {
    return this.__historyArray.length > 0 ? this.__historyArray[this.__historyArray.length - 1].params : {};
  },

  set nextPageId(id) {
    this.__nextPageId = id;
  },

  get homepagesList() {
    var _this = this;

    var mainNavPages = this.__historyArray.filter(function (item) {
      return item.homeMenuEntry === true && item.title !== undefined;
    });

    var mainNavPagesWitoutSharedAncestors = mainNavPages.slice().reverse().filter(function (item, index, self) {
      return index === 0 || _this.sharesAncestor(self[0], item);
    }).reverse();
    return mainNavPagesWitoutSharedAncestors; // const cleanHlist = []
    // cleanHlist.push(hlist[hlist.length - 1])
    // const newHomepageIdsItem = hlist[hlist.length - 1]
    // if (hlist.length > 1 && hlist[hlist.length - 1].ancestorIds && hlist[hlist.length - 1].ancestorIds.length >= 1) {
    //   for (let index = hlist.length - 2; index >= 0; index--) {
    //     const newAncestors = hlist[index + 1]
    //     const OldElement = hlist[index]
    //     if (!this.checkHomepagesConflict(newHomepageIdsItem.ancestorIds, OldElement.ancestorIds) && !this.checkHomepagesConflict(newAncestors.ancestorIds, OldElement.ancestorIds)) {
    //       cleanHlist.push(OldElement)
    //     }
    //   }
    //   cleanHlist.reverse()
    //   log('get homepagesList', cleanHlist)
    //   return cleanHlist
    // } else {
    //   log('get homepagesList', hlist)
    //   return hlist
    // }
  },

  sharesAncestor: function sharesAncestor(mainNavPage, previousMainNavPage) {
    var ancestors = mainNavPage.ancestorIds || [];
    var ancestorsOfPrevious = previousMainNavPage.ancestorIds || [];

    if (ancestorsOfPrevious.length > ancestors.length) {
      log$1('shor', JSON.stringify(ancestorsOfPrevious), JSON.stringify(ancestors));
      return false;
    }

    for (var i = 0; i < ancestorsOfPrevious.length; i++) {
      if (ancestors[i] !== ancestorsOfPrevious[i]) {
        log$1("".concat(ancestors[i], " !== ").concat(ancestorsOfPrevious[i])); // log('not equal')

        return false;
      }
    }

    return true;
  },
  setLastPanoramaPage: function setLastPanoramaPage(panoramaPageId, homePageId) {
    this.__lastPanoramaPageId = panoramaPageId;
    this.__lastPanoramaHomePageId = homePageId;
  },
  getLastPanoramaPage: function getLastPanoramaPage(homePageId) {
    return this.__lastPanoramaHomePageId === homePageId ? this.__lastPanoramaPageId : null;
  },
  resetHistoryState: function resetHistoryState() {
    log$1('reset history state');
    this.__homePages = [];
    this.__nextPageId = null;
    this.__historyArray = [];
    this.__lastHomePage = null;
  },
  checkHomepagesConflict: function checkHomepagesConflict(hps1, hps2) {
    if (hps1 === undefined || hps2 === undefined || hps1.length === 0 || hps2.length === 0) {
      return false;
    }

    if (hps1[hps1.length - 1] === hps2[hps2.length - 1] || hps1[hps1.length - 1] === hps2[0] || hps1.length < hps2.length) {
      return true;
    } else {
      log$1('returning false', hps1, hps2);
      return false;
    }
  },
  addHomePage: function addHomePage(pageId, pagePath, pageTitle, parentId, ancestorIds) {
    var _this2 = this;

    pageId = parseInt(pageId);
    log$1("addHomePage(".concat(pageId, ", ").concat(pagePath, ", ").concat(pageTitle, ", ").concat(parentId, ", ").concat(ancestorIds, ")"));
    log$1('adding homepage, history array', this.__historyArray);

    var searchIndex = this.__historyArray.findIndex(function (item) {
      return item.pageId === parseInt(pageId);
    });

    log$1("searchIndex for homepage ".concat(searchIndex));

    if (searchIndex > -1) {
      // Seite ist bereits in der History
      if (this.__historyArray[searchIndex].parentId === undefined) {
        // page exists in history as normal page, mark as homepage
        this.__historyArray[searchIndex].parentId = parentId;
        this.__historyArray[searchIndex].title = pageTitle;
        this.__historyArray[searchIndex].ancestorIds = ancestorIds;
        this.__historyArray[searchIndex].homeMenuEntry = true;
      }

      this.__lastHomePage = this.__historyArray[searchIndex]; // }
    } else {
      // Seite hinzufügen
      // page does not exist in history, add as homepage
      log$1('should add homepage', pageId);

      this.__historyArray.push({
        pageId: pageId,
        path: pagePath,
        title: pageTitle,
        parentId: parentId,
        ancestorIds: ancestorIds,
        homeMenuEntry: true
      });

      var tempArray = this.__historyArray.map(function (a) {
        return Object.assign({}, a);
      });

      tempArray.reverse();
      var lastToAssign = null;
      tempArray.every(function (element) {
        if (_this2.__$xp.content.pageData.ID !== element.pageId && element.title !== null && (_this2.__$xp.content.pageData.Homepage === undefined || _this2.__$xp.content.pageData.Homepage === null || _this2.__$xp.content.pageData.Homepage.ID && _this2.__$xp.content.pageData.Homepage.ID !== element.pageId)) {
          lastToAssign = element;
          return false;
        } else {
          return true;
        }
      });

      if (lastToAssign) {
        this.__lastHomePage = lastToAssign;
      }
    }

    log$1('added homepage, history array', this.__historyArray);
  },
  push: function push(newPageId, newPath) {
    var homeMenuEntry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var title = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    var savedHistory = JSON.parse(window.localStorage.getItem('history'));

    var searchIndex = this.__historyArray.findIndex(function (item) {
      return item.pageId === parseInt(newPageId);
    });

    this.__historyArray.forEach(function (item) {
      log$1('\n', item.pageId, item.path);
    });

    if (this.__$xp && !this.__$xp.device.isLoan && savedHistory && this.__historyArray.length === 0 && savedHistory.length > 1 && savedHistory[savedHistory.length - 1].pageId === newPageId) {
      // History ist leer und in Storage ist eine History der aktuellen Seite (Seite neu geladen)
      this.__historyArray = savedHistory;
    } else if (searchIndex >= 0) {
      // Seite ist bereits in der History
      if (this.__historyArray[searchIndex].path !== newPath) {
        // Pfad hat sich geändert, e.g sprache
        this.__historyArray[searchIndex].path = newPath;
      }

      if (searchIndex < this.__historyArray.length) {
        // Seite ist bereits in der History, aber nicht die letzte
        this.__historyArray = this.__historyArray.slice(0, searchIndex + 1);
      }
    } else {
      // Seite hinzufügen
      this.__historyArray.push({
        pageId: parseInt(newPageId),
        path: newPath,
        params: {},
        homeMenuEntry: homeMenuEntry,
        title: title
      });
    }

    log$1('pushed to history array', this.__historyArray);
    window.localStorage.setItem('history', JSON.stringify(this.__historyArray)); // window.localStorage.setItem('homepages', JSON.stringify(this.__homePages))
  },
  replace: function replace(newPageId, newPath) {
    this.__historyArray.splice(-1, 1);

    this.push(newPageId, newPath);
    log$1('replaced in history array', this.__historyArray);
  },
  setHistoryParam: function setHistoryParam(pageId, key, value) {
    pageId = parseInt(pageId);

    if (this.__historyArray.length > 0) {
      if (this.__historyArray[this.__historyArray.length - 1].pageId === pageId) {
        this.__historyArray[this.__historyArray.length - 1].params = Object.assign({}, this.__historyArray[this.__historyArray.length - 1].params, _defineProperty({}, key, value));
      } else {
        console.warn("setHistoryParam: ".concat(key, " = ").concat(value, ". pageId does not match the last element in the history array \n ").concat(pageId, " was passed and ").concat(this.__historyArray[this.__historyArray.length - 1].pageId, " was found"));
      }
    }
  },
  back: function back(replace) {
    if (this.__historyArray.length > 1) {
      // const tempArray = this.__historyArray.map(a => Object.assign({}, a))
      // tempArray.reverse()
      // get last non-homepage entry
      var lastPageIndex = 0;

      for (var index = this.__historyArray.length - 2; index >= 0; index--) {
        if (this.__historyArray[index].parentId === undefined) {
          lastPageIndex = index;
          break;
        }
      }

      var lastPagePath = this.__historyArray[lastPageIndex].path; // commit('BACK')

      this.__historyArray.splice(-1, this.__historyArray.length - 1 - lastPageIndex);

      this.__router.push({
        path: lastPagePath,
        query: {
          back: true
        },
        replace: replace
      });
    }
  },
  goHome: function goHome(replace) {
    if (this.lastHomePage) {
      log$1('GO HOME: (previous)' + this.lastHomePage.path);

      this.__router.push({
        path: this.lastHomePage.path,
        replace: replace
      });
    } else {
      log$1('GO START');

      this.__router.push({
        path: '/',
        replace: replace
      });
    }
  },
  saveHistoryState: function saveHistoryState() {
    log$1('Saving history state'); // window.localStorage.setItem('HomePages', JSON.stringify(this.__homePages))

    window.localStorage.setItem('nextPageId', this.__nextPageId);
    window.localStorage.setItem('historyArray', JSON.stringify(this.__historyArray));
  },
  restoreHistoryState: function restoreHistoryState() {
    log$1('Restoring history state');
    var storedNextPageId = window.localStorage.getItem('nextPageId');
    this.__nextPageId = storedNextPageId ? Number(storedNextPageId) : null;
    window.localStorage.setItem('nextPageId', '');
    this.__historyArray = JSON.parse(window.localStorage.getItem('historyArray'));
    window.localStorage.setItem('historyArray', '');
  },
  install: function install(Vue, opts, $xp) {
    if ($xp.historyInstalled) {
      return;
    }

    this.__$xp = $xp;

    if (!opts.router) {
      throw new Error('History plugin needs router to initialize');
    }

    this.__router = opts.router;
    $xp.historyInstalled = true;
    Vue.util.defineReactive($xp, 'history', this);
  }
};

var Polyglot = {
  __$xp: null,
  __locale: 'de_DE',
  __urlPath: '_/',
  __defaultLocale: null,
  __i18n: null,

  get locale() {
    return this.__locale;
  },

  get urlPath() {
    return this.__urlPath;
  },

  get rtl() {
    return this.__locale.startsWith('ar_') || this.__locale.startsWith('fa_') || this.__locale.startsWith('he_');
  },

  get apiLangPath() {
    return this.__urlPath === '_/' ? '' : this.__urlPath;
  },

  set locale(locale) {
    this.__locale = locale;
  },

  set urlPath(urlPath) {
    this.__urlPath = urlPath || '_/';
  },

  setLanguage: function setLanguage(locale, urlPath) {
    this.__locale = locale;
    this.__urlPath = urlPath || '_/';
    this.setI18nLanguage(locale);

    this.__$xp.settings.reloadSettings(urlPath);
  },
  setI18nLanguage: function setI18nLanguage(lang) {
    lang = lang || this.__defaultLocale;
    this.__i18n.locale = lang;
    var langParts = lang.split('_');

    if (langParts.length !== 2) {
      throw new Error("setI18nLanguage: invalid locale ".concat(lang));
    }

    document.querySelector('html').setAttribute('lang', langParts[1].toLowerCase());
  },
  install: function install(Vue, opts, $xp, cfg) {
    if ($xp.polyglotInstalled) {
      return;
    }

    this.__defaultLocale = cfg.defaultLocale;
    this.__i18n = cfg.i18n;
    $xp.polyglotInstalled = true;
    this.__$xp = $xp;
    this.setI18nLanguage();
    Vue.util.defineReactive($xp, 'polyglot', this); // $xp.polyglot = this
  }
};

var runtime_1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }

    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function define(obj, key, value) {
        return obj[key] = value;
      };
    }

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports );

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});

var regenerator = runtime_1;

var goToAdminActivity = function goToAdminActivity() {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.goToAdminActivity(function () {
        resolve();
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    }
  });
};

var getDeviceTimeOffset = function getDeviceTimeOffset() {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.getTimeOffset(function (offset) {
        resolve(offset);
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    }
  });
};

var getRemappedUrl = function getRemappedUrl(url) {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE || window.XpedeoPreloader && process.env.VUE_APP_PLATFORM.toLowerCase() === 'android') {
      // if (window.device.platform !== 'browser' && window.device.platform !== 'ios') {
      window.XpedeoPreloader.getRemappedUrl(url, function (remappedUrl) {
        resolve(remappedUrl);
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else {
      resolve(url);
    }
  });
};

var checkPermissions = function checkPermissions() {
  var permissions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolve, reject) {
    console.log('checkPermissions', process.env.VUE_APP_PLATFORM.toLowerCase());

    if (process.env.VUE_APP_PLATFORM.toLowerCase() === 'android') {
      var diagnostic = window.cordova.plugins.diagnostic;

      if (process.env.VUE_APP_IS_LOAN_DEVICE) {
        permissions = [diagnostic.permission.WRITE_EXTERNAL_STORAGE, diagnostic.permission.READ_EXTERNAL_STORAGE, diagnostic.permission.ACCESS_FINE_LOCATION, diagnostic.permission.ACCESS_COARSE_LOCATION];

        if (window.XpedeoAR) {
          permissions.push(diagnostic.permission.CAMERA);
        }
      } else {
        permissions = permissions.map(function (item) {
          return diagnostic.permission[item];
        }); // const addPermissions = [
        //   diagnostic.permission.WRITE_EXTERNAL_STORAGE,
        //   diagnostic.permission.READ_EXTERNAL_STORAGE
        // ]
        // addPermissions.forEach(element => {
        //   if (!(element in permissions)) {
        //     permissions.push(element)
        //   }
        // })
      }

      console.log('Checking permissions', permissions);
      permissions.length === 0 && resolve();
      permissions.length && diagnostic.requestRuntimePermissions(function (statuses) {
        var grantedCounter = 0;

        for (var permission in statuses) {
          switch (statuses[permission]) {
            case diagnostic.permissionStatus.GRANTED:
              console.log('Permission granted to use ' + permission);
              grantedCounter += 1;
              break;

            case diagnostic.permissionStatus.NOT_REQUESTED:
              console.log('Permission to use ' + permission + ' has not been requested yet');
              break;

            case diagnostic.permissionStatus.DENIED:
              console.log('Permission denied to use ' + permission + ' - ask again?');
              break;

            case diagnostic.permissionStatus.DENIED_ALWAYS:
              console.log('Permission permanently denied to use ' + permission + ' - guess we won\'t be using it then!');
              break;
          }
        }

        if (grantedCounter === Object.keys(statuses).length) {
          resolve(true);
        } else {
          reject(new Error("Permissions were not granted. ".concat(Object.keys(statuses).length, " were requested but ").concat(grantedCounter, " were granted.")));
        }
      }, function (error) {
        reject(new Error(error));
      }, permissions);
    } else {
      resolve(false);
    }
  });
};

var checkLoanLocationSettings = function checkLoanLocationSettings() {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.checkLocationSettings(function () {
        resolve();
      }, function () {
        reject(new Error('location settings are not valid'));
      });
    } else {
      resolve();
    }
  });
};

var writeEvaRecord = function writeEvaRecord(jsonString) {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_PLATFORM.toLowerCase() === 'android') {
      window.XpedeoPreloader.writeEvaRecord(jsonString ? [jsonString] : [], function () {
        console.log('mediaRecord Written');
        resolve();
      }, function () {
        reject(new Error('Evaluation record not written'));
      });
    } else {
      resolve();
    }
  });
};

var fingerprint = createCommonjsModule(function (module) {
  /* based on https://github.com/Valve/fingerprintjs2 */

  /*
  * This software contains code from open-source projects:
  * MurmurHash3 by Karan Lyons (https://github.com/karanlyons/murmurHash3.js)
  */

  /* global define */
  (function (name, context, definition) {

    if (typeof window !== 'undefined' && typeof undefined === 'function' && undefined.amd) {
      undefined(definition);
    } else if ( module.exports) {
      module.exports = definition();
    } else if (context.exports) {
      context.exports = definition();
    } else {
      context[name] = definition();
    }
  })('Fingerprint2', commonjsGlobal, function () {
    // only implement if no native implementation is available

    if (typeof Array.isArray === 'undefined') {
      Array.isArray = function (obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
      };
    }
    //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // added together as a 64bit int (as an array of two 32bit ints).
    //

    var x64Add = function x64Add(m, n) {
      m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
      n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
      var o = [0, 0, 0, 0];
      o[3] += m[3] + n[3];
      o[2] += o[3] >>> 16;
      o[3] &= 0xffff;
      o[2] += m[2] + n[2];
      o[1] += o[2] >>> 16;
      o[2] &= 0xffff;
      o[1] += m[1] + n[1];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[0] += m[0] + n[0];
      o[0] &= 0xffff;
      return [o[0] << 16 | o[1], o[2] << 16 | o[3]];
    }; //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // multiplied together as a 64bit int (as an array of two 32bit ints).
    //


    var x64Multiply = function x64Multiply(m, n) {
      m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
      n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
      var o = [0, 0, 0, 0];
      o[3] += m[3] * n[3];
      o[2] += o[3] >>> 16;
      o[3] &= 0xffff;
      o[2] += m[2] * n[3];
      o[1] += o[2] >>> 16;
      o[2] &= 0xffff;
      o[2] += m[3] * n[2];
      o[1] += o[2] >>> 16;
      o[2] &= 0xffff;
      o[1] += m[1] * n[3];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[1] += m[2] * n[2];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[1] += m[3] * n[1];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
      o[0] &= 0xffff;
      return [o[0] << 16 | o[1], o[2] << 16 | o[3]];
    }; //
    // Given a 64bit int (as an array of two 32bit ints) and an int
    // representing a number of bit positions, returns the 64bit int (as an
    // array of two 32bit ints) rotated left by that number of positions.
    //


    var x64Rotl = function x64Rotl(m, n) {
      n %= 64;

      if (n === 32) {
        return [m[1], m[0]];
      } else if (n < 32) {
        return [m[0] << n | m[1] >>> 32 - n, m[1] << n | m[0] >>> 32 - n];
      } else {
        n -= 32;
        return [m[1] << n | m[0] >>> 32 - n, m[0] << n | m[1] >>> 32 - n];
      }
    }; //
    // Given a 64bit int (as an array of two 32bit ints) and an int
    // representing a number of bit positions, returns the 64bit int (as an
    // array of two 32bit ints) shifted left by that number of positions.
    //


    var x64LeftShift = function x64LeftShift(m, n) {
      n %= 64;

      if (n === 0) {
        return m;
      } else if (n < 32) {
        return [m[0] << n | m[1] >>> 32 - n, m[1] << n];
      } else {
        return [m[1] << n - 32, 0];
      }
    }; //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // xored together as a 64bit int (as an array of two 32bit ints).
    //


    var x64Xor = function x64Xor(m, n) {
      return [m[0] ^ n[0], m[1] ^ n[1]];
    }; //
    // Given a block, returns murmurHash3's final x64 mix of that block.
    // (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
    // only place where we need to right shift 64bit ints.)
    //


    var x64Fmix = function x64Fmix(h) {
      h = x64Xor(h, [0, h[0] >>> 1]);
      h = x64Multiply(h, [0xff51afd7, 0xed558ccd]);
      h = x64Xor(h, [0, h[0] >>> 1]);
      h = x64Multiply(h, [0xc4ceb9fe, 0x1a85ec53]);
      h = x64Xor(h, [0, h[0] >>> 1]);
      return h;
    }; //
    // Given a string and an optional seed as an int, returns a 128 bit
    // hash using the x64 flavor of MurmurHash3, as an unsigned hex.
    //


    var x64hash128 = function x64hash128(key, seed) {
      key = key || '';
      seed = seed || 0;
      var remainder = key.length % 16;
      var bytes = key.length - remainder;
      var h1 = [0, seed];
      var h2 = [0, seed];
      var k1 = [0, 0];
      var k2 = [0, 0];
      var c1 = [0x87c37b91, 0x114253d5];
      var c2 = [0x4cf5ad43, 0x2745937f];
      var i;

      for (i = 0; i < bytes; i = i + 16) {
        k1 = [key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24, key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24];
        k2 = [key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24, key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24];
        k1 = x64Multiply(k1, c1);
        k1 = x64Rotl(k1, 31);
        k1 = x64Multiply(k1, c2);
        h1 = x64Xor(h1, k1);
        h1 = x64Rotl(h1, 27);
        h1 = x64Add(h1, h2);
        h1 = x64Add(x64Multiply(h1, [0, 5]), [0, 0x52dce729]);
        k2 = x64Multiply(k2, c2);
        k2 = x64Rotl(k2, 33);
        k2 = x64Multiply(k2, c1);
        h2 = x64Xor(h2, k2);
        h2 = x64Rotl(h2, 31);
        h2 = x64Add(h2, h1);
        h2 = x64Add(x64Multiply(h2, [0, 5]), [0, 0x38495ab5]);
      }

      k1 = [0, 0];
      k2 = [0, 0];

      switch (remainder) {
        case 15:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 14)], 48));
        // fallthrough

        case 14:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 13)], 40));
        // fallthrough

        case 13:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 12)], 32));
        // fallthrough

        case 12:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 11)], 24));
        // fallthrough

        case 11:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 10)], 16));
        // fallthrough

        case 10:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 9)], 8));
        // fallthrough

        case 9:
          k2 = x64Xor(k2, [0, key.charCodeAt(i + 8)]);
          k2 = x64Multiply(k2, c2);
          k2 = x64Rotl(k2, 33);
          k2 = x64Multiply(k2, c1);
          h2 = x64Xor(h2, k2);
        // fallthrough

        case 8:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 7)], 56));
        // fallthrough

        case 7:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 6)], 48));
        // fallthrough

        case 6:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 5)], 40));
        // fallthrough

        case 5:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 4)], 32));
        // fallthrough

        case 4:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 3)], 24));
        // fallthrough

        case 3:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 2)], 16));
        // fallthrough

        case 2:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 1)], 8));
        // fallthrough

        case 1:
          k1 = x64Xor(k1, [0, key.charCodeAt(i)]);
          k1 = x64Multiply(k1, c1);
          k1 = x64Rotl(k1, 31);
          k1 = x64Multiply(k1, c2);
          h1 = x64Xor(h1, k1);
        // fallthrough
      }

      h1 = x64Xor(h1, [0, key.length]);
      h2 = x64Xor(h2, [0, key.length]);
      h1 = x64Add(h1, h2);
      h2 = x64Add(h2, h1);
      h1 = x64Fmix(h1);
      h2 = x64Fmix(h2);
      h1 = x64Add(h1, h2);
      h2 = x64Add(h2, h1);
      return ('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8);
    };

    var defaultOptions = {
      preprocessor: null,
      audio: {
        timeout: 1000,
        // On iOS 11, audio context can only be used in response to user interaction.
        // We require users to explicitly enable audio fingerprinting on iOS 11.
        // See https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
        excludeIOS11: true
      },
      fonts: {
        swfContainerId: 'fingerprintjs2',
        swfPath: 'flash/compiled/FontList.swf',
        userDefinedFonts: [],
        extendedJsFonts: false
      },
      screen: {
        // To ensure consistent fingerprints when users rotate their mobile devices
        detectScreenOrientation: true
      },
      plugins: {
        sortPluginsFor: [/palemoon/i],
        excludeIE: false
      },
      extraComponents: [],
      excludes: {
        // Unreliable on Windows, see https://github.com/Valve/fingerprintjs2/issues/375
        enumerateDevices: true,
        // devicePixelRatio depends on browser zoom, and it's impossible to detect browser zoom
        pixelRatio: true,
        // DNT depends on incognito mode for some browsers (Chrome) and it's impossible to detect incognito mode
        doNotTrack: true,
        // uses js fonts already
        fontsFlash: true
      },
      NOT_AVAILABLE: 'not available',
      ERROR: 'error',
      EXCLUDED: 'excluded'
    };

    var each = function each(obj, iterator) {
      if (Array.prototype.forEach && obj.forEach === Array.prototype.forEach) {
        obj.forEach(iterator);
      } else if (obj.length === +obj.length) {
        for (var i = 0, l = obj.length; i < l; i++) {
          iterator(obj[i], i, obj);
        }
      } else {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            iterator(obj[key], key, obj);
          }
        }
      }
    };

    var map = function map(obj, iterator) {
      var results = []; // Not using strict equality so that this acts as a
      // shortcut to checking for `null` and `undefined`.

      if (obj == null) {
        return results;
      }

      if (Array.prototype.map && obj.map === Array.prototype.map) {
        return obj.map(iterator);
      }

      each(obj, function (value, index, list) {
        results.push(iterator(value, index, list));
      });
      return results;
    };

    var extendSoft = function extendSoft(target, source) {
      if (source == null) {
        return target;
      }

      var value;
      var key;

      for (key in source) {
        value = source[key];

        if (value != null && !Object.prototype.hasOwnProperty.call(target, key)) {
          target[key] = value;
        }
      }

      return target;
    };

    var getCanvasFp = function getCanvasFp(options) {
      var result = []; // Very simple now, need to make it more complex (geo shapes etc)

      var canvas = document.createElement('canvas');
      canvas.width = 2000;
      canvas.height = 200;
      canvas.style.display = 'inline';
      var ctx = canvas.getContext('2d'); // detect browser support of canvas winding
      // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
      // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js

      ctx.rect(0, 0, 10, 10);
      ctx.rect(2, 2, 6, 6);
      result.push('canvas winding:' + (ctx.isPointInPath(5, 5, 'evenodd') === false ? 'yes' : 'no'));
      ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = '#f60';
      ctx.fillRect(125, 1, 62, 20);
      ctx.fillStyle = '#069'; // https://github.com/Valve/fingerprintjs2/issues/66

      if (options.dontUseFakeFontInCanvas) {
        ctx.font = '11pt Arial';
      } else {
        ctx.font = '11pt no-real-font-123';
      }

      ctx.fillText("Cwm fjordbank glyphs vext quiz, \uD83D\uDE03", 2, 15);
      ctx.fillStyle = 'rgba(102, 204, 0, 0.2)';
      ctx.font = '18pt Arial';
      ctx.fillText("Cwm fjordbank glyphs vext quiz, \uD83D\uDE03", 4, 45); // canvas blending
      // http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
      // http://jsfiddle.net/NDYV8/16/

      ctx.globalCompositeOperation = 'multiply';
      ctx.fillStyle = 'rgb(255,0,255)';
      ctx.beginPath();
      ctx.arc(50, 50, 50, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = 'rgb(0,255,255)';
      ctx.beginPath();
      ctx.arc(100, 50, 50, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = 'rgb(255,255,0)';
      ctx.beginPath();
      ctx.arc(75, 100, 50, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = 'rgb(255,0,255)'; // canvas winding
      // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
      // http://jsfiddle.net/NDYV8/19/

      ctx.arc(75, 75, 75, 0, Math.PI * 2, true);
      ctx.arc(75, 75, 25, 0, Math.PI * 2, true);
      ctx.fill('evenodd');

      if (canvas.toDataURL) {
        result.push('canvas fp:' + canvas.toDataURL());
      }

      return result;
    };

    var getTouchSupport = function getTouchSupport() {
      var maxTouchPoints = 0;
      var touchEvent;

      if (typeof navigator.maxTouchPoints !== 'undefined') {
        maxTouchPoints = navigator.maxTouchPoints;
      } else if (typeof navigator.msMaxTouchPoints !== 'undefined') {
        maxTouchPoints = navigator.msMaxTouchPoints;
      }

      try {
        document.createEvent('TouchEvent');
        touchEvent = true;
      } catch (_) {
        touchEvent = false;
      }

      var touchStart = ('ontouchstart' in window);
      return [maxTouchPoints, touchEvent, touchStart];
    };

    var getAdBlock = function getAdBlock() {
      var ads = document.createElement('div');
      ads.innerHTML = '&nbsp;';
      ads.className = 'adsbox';
      var result = false;

      try {
        // body may not exist, that's why we need try/catch
        document.body.appendChild(ads);
        result = document.getElementsByClassName('adsbox')[0].offsetHeight === 0;
        document.body.removeChild(ads);
      } catch (e) {
        result = false;
      }

      return result;
    };

    var getHasLiedLanguages = function getHasLiedLanguages() {
      // We check if navigator.language is equal to the first language of navigator.languages
      // navigator.languages is undefined on IE11 (and potentially older IEs)
      if (typeof navigator.languages !== 'undefined') {
        try {
          var firstLanguages = navigator.languages[0].substr(0, 2);

          if (firstLanguages !== navigator.language.substr(0, 2)) {
            return true;
          }
        } catch (err) {
          return true;
        }
      }

      return false;
    };

    var getHasLiedResolution = function getHasLiedResolution() {
      return window.screen.width < window.screen.availWidth || window.screen.height < window.screen.availHeight;
    };

    var getHasLiedOs = function getHasLiedOs() {
      var userAgent = navigator.userAgent.toLowerCase();
      var oscpu = navigator.oscpu;
      var platform = navigator.platform.toLowerCase();
      var os; // We extract the OS from the user agent (respect the order of the if else if statement)

      if (userAgent.indexOf('windows phone') >= 0) {
        os = 'Windows Phone';
      } else if (userAgent.indexOf('windows') >= 0 || userAgent.indexOf('win16') >= 0 || userAgent.indexOf('win32') >= 0 || userAgent.indexOf('win64') >= 0 || userAgent.indexOf('win95') >= 0 || userAgent.indexOf('win98') >= 0 || userAgent.indexOf('winnt') >= 0 || userAgent.indexOf('wow64') >= 0) {
        os = 'Windows';
      } else if (userAgent.indexOf('android') >= 0) {
        os = 'Android';
      } else if (userAgent.indexOf('linux') >= 0 || userAgent.indexOf('cros') >= 0 || userAgent.indexOf('x11') >= 0) {
        os = 'Linux';
      } else if (userAgent.indexOf('iphone') >= 0 || userAgent.indexOf('ipad') >= 0 || userAgent.indexOf('ipod') >= 0 || userAgent.indexOf('crios') >= 0 || userAgent.indexOf('fxios') >= 0) {
        os = 'iOS';
      } else if (userAgent.indexOf('macintosh') >= 0 || userAgent.indexOf('mac_powerpc)') >= 0) {
        os = 'Mac';
      } else {
        os = 'Other';
      } // We detect if the person uses a touch device


      var mobileDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

      if (mobileDevice && os !== 'Windows' && os !== 'Windows Phone' && os !== 'Android' && os !== 'iOS' && os !== 'Other' && userAgent.indexOf('cros') === -1) {
        return true;
      } // We compare oscpu with the OS extracted from the UA


      if (typeof oscpu !== 'undefined') {
        oscpu = oscpu.toLowerCase();

        if (oscpu.indexOf('win') >= 0 && os !== 'Windows' && os !== 'Windows Phone') {
          return true;
        } else if (oscpu.indexOf('linux') >= 0 && os !== 'Linux' && os !== 'Android') {
          return true;
        } else if (oscpu.indexOf('mac') >= 0 && os !== 'Mac' && os !== 'iOS') {
          return true;
        } else if ((oscpu.indexOf('win') === -1 && oscpu.indexOf('linux') === -1 && oscpu.indexOf('mac') === -1) !== (os === 'Other')) {
          return true;
        }
      } // We compare platform with the OS extracted from the UA


      if (platform.indexOf('win') >= 0 && os !== 'Windows' && os !== 'Windows Phone') {
        return true;
      } else if ((platform.indexOf('linux') >= 0 || platform.indexOf('android') >= 0 || platform.indexOf('pike') >= 0) && os !== 'Linux' && os !== 'Android') {
        return true;
      } else if ((platform.indexOf('mac') >= 0 || platform.indexOf('ipad') >= 0 || platform.indexOf('ipod') >= 0 || platform.indexOf('iphone') >= 0) && os !== 'Mac' && os !== 'iOS') {
        return true;
      } else if (platform.indexOf('arm') >= 0 && os === 'Windows Phone') {
        return false;
      } else if (platform.indexOf('pike') >= 0 && userAgent.indexOf('opera mini') >= 0) {
        return false;
      } else {
        var platformIsOther = platform.indexOf('win') < 0 && platform.indexOf('linux') < 0 && platform.indexOf('mac') < 0 && platform.indexOf('iphone') < 0 && platform.indexOf('ipad') < 0 && platform.indexOf('ipod') < 0;

        if (platformIsOther !== (os === 'Other')) {
          return true;
        }
      }

      return typeof navigator.plugins === 'undefined' && os !== 'Windows' && os !== 'Windows Phone';
    };

    var getHasLiedBrowser = function getHasLiedBrowser() {
      var userAgent = navigator.userAgent.toLowerCase();
      var productSub = navigator.productSub; // we extract the browser from the user agent (respect the order of the tests)

      var browser;

      if (userAgent.indexOf('edge/') >= 0 || userAgent.indexOf('iemobile/') >= 0) {
        // Unreliable, different versions use EdgeHTML, Webkit, Blink, etc.
        return false;
      } else if (userAgent.indexOf('opera mini') >= 0) {
        // Unreliable, different modes use Presto, WebView, Webkit, etc.
        return false;
      } else if (userAgent.indexOf('firefox/') >= 0) {
        browser = 'Firefox';
      } else if (userAgent.indexOf('opera/') >= 0 || userAgent.indexOf(' opr/') >= 0) {
        browser = 'Opera';
      } else if (userAgent.indexOf('chrome/') >= 0) {
        browser = 'Chrome';
      } else if (userAgent.indexOf('safari/') >= 0) {
        if (userAgent.indexOf('android 1.') >= 0 || userAgent.indexOf('android 2.') >= 0 || userAgent.indexOf('android 3.') >= 0 || userAgent.indexOf('android 4.') >= 0) {
          browser = 'AOSP';
        } else {
          browser = 'Safari';
        }
      } else if (userAgent.indexOf('trident/') >= 0) {
        browser = 'Internet Explorer';
      } else {
        browser = 'Other';
      }

      if ((browser === 'Chrome' || browser === 'Safari' || browser === 'Opera') && productSub !== '20030107') {
        return true;
      } // eslint-disable-next-line no-eval


      var tempRes = eval.toString().length;

      if (tempRes === 37 && browser !== 'Safari' && browser !== 'Firefox' && browser !== 'Other') {
        return true;
      } else if (tempRes === 39 && browser !== 'Internet Explorer' && browser !== 'Other') {
        return true;
      } else if (tempRes === 33 && browser !== 'Chrome' && browser !== 'AOSP' && browser !== 'Opera' && browser !== 'Other') {
        return true;
      } // We create an error to see how it is handled


      var errFirefox;

      try {
        // eslint-disable-next-line no-throw-literal
        throw 'a';
      } catch (err) {
        try {
          err.toSource();
          errFirefox = true;
        } catch (errOfErr) {
          errFirefox = false;
        }
      }

      return errFirefox && browser !== 'Firefox' && browser !== 'Other';
    };

    var isCanvasSupported = function isCanvasSupported() {
      var elem = document.createElement('canvas');
      return !!(elem.getContext && elem.getContext('2d'));
    };

    var getWebglCanvas = function getWebglCanvas() {
      var canvas = document.createElement('canvas');
      var gl = null;

      try {
        gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      } catch (e) {
        /* squelch */
      }

      if (!gl) {
        gl = null;
      }

      return gl;
    };

    var loseWebglContext = function loseWebglContext(context) {
      var loseContextExtension = context.getExtension('WEBGL_lose_context');

      if (loseContextExtension != null) {
        loseContextExtension.loseContext();
      }
    };

    var canvasKey = function canvasKey(done, options) {
      if (isCanvasSupported()) {
        done(getCanvasFp(options));
        return;
      }

      done(options.NOT_AVAILABLE);
    };

    var isWebGlSupported = function isWebGlSupported() {
      // code taken from Modernizr
      if (!isCanvasSupported()) {
        return false;
      }

      var glContext = getWebglCanvas();
      var isSupported = !!window.WebGLRenderingContext && !!glContext;
      loseWebglContext(glContext);
      return isSupported;
    };

    var getWebglVendorAndRenderer = function getWebglVendorAndRenderer() {
      /* This a subset of the WebGL fingerprint with a lot of entropy, while being reasonably browser-independent */
      try {
        var glContext = getWebglCanvas();
        var extensionDebugRendererInfo = glContext.getExtension('WEBGL_debug_renderer_info');
        var params = glContext.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL) + '~' + glContext.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL);
        loseWebglContext(glContext);
        return params;
      } catch (e) {
        return null;
      }
    };

    var getWebglFp = function getWebglFp() {
      var gl = getWebglCanvas();

      var fa2s = function fa2s(fa) {
        gl.clearColor(0.0, 0.0, 0.0, 1.0);
        gl.enable(gl.DEPTH_TEST);
        gl.depthFunc(gl.LEQUAL);
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        return '[' + fa[0] + ', ' + fa[1] + ']';
      };

      var maxAnisotropy = function maxAnisotropy(gl) {
        var ext = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic');

        if (ext) {
          var anisotropy = gl.getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT);

          if (anisotropy === 0) {
            anisotropy = 2;
          }

          return anisotropy;
        } else {
          return null;
        }
      };

      if (!gl) {
        return null;
      } // WebGL fingerprinting is a combination of techniques, found in MaxMind antifraud script & Augur fingerprinting.
      // First it draws a gradient object with shaders and convers the image to the Base64 string.
      // Then it enumerates all WebGL extensions & capabilities and appends them to the Base64 string, resulting in a huge WebGL string, potentially very unique on each device
      // Since iOS supports webgl starting from version 8.1 and 8.1 runs on several graphics chips, the results may be different across ios devices, but we need to verify it.


      var result = [];
      var vShaderTemplate = 'attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}';
      var fShaderTemplate = 'precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}';
      var vertexPosBuffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, vertexPosBuffer);
      var vertices = new Float32Array([-0.2, -0.9, 0, 0.4, -0.26, 0, 0, 0.732134444, 0]);
      gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);
      vertexPosBuffer.itemSize = 3;
      vertexPosBuffer.numItems = 3;
      var program = gl.createProgram();
      var vshader = gl.createShader(gl.VERTEX_SHADER);
      gl.shaderSource(vshader, vShaderTemplate);
      gl.compileShader(vshader);
      var fshader = gl.createShader(gl.FRAGMENT_SHADER);
      gl.shaderSource(fshader, fShaderTemplate);
      gl.compileShader(fshader);
      gl.attachShader(program, vshader);
      gl.attachShader(program, fshader);
      gl.linkProgram(program);
      gl.useProgram(program);
      program.vertexPosAttrib = gl.getAttribLocation(program, 'attrVertex');
      program.offsetUniform = gl.getUniformLocation(program, 'uniformOffset');
      gl.enableVertexAttribArray(program.vertexPosArray);
      gl.vertexAttribPointer(program.vertexPosAttrib, vertexPosBuffer.itemSize, gl.FLOAT, !1, 0, 0);
      gl.uniform2f(program.offsetUniform, 1, 1);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertexPosBuffer.numItems);

      try {
        result.push(gl.canvas.toDataURL());
      } catch (e) {
        /* .toDataURL may be absent or broken (blocked by extension) */
      }

      result.push('extensions:' + (gl.getSupportedExtensions() || []).join(';'));
      result.push('webgl aliased line width range:' + fa2s(gl.getParameter(gl.ALIASED_LINE_WIDTH_RANGE)));
      result.push('webgl aliased point size range:' + fa2s(gl.getParameter(gl.ALIASED_POINT_SIZE_RANGE)));
      result.push('webgl alpha bits:' + gl.getParameter(gl.ALPHA_BITS));
      result.push('webgl antialiasing:' + (gl.getContextAttributes().antialias ? 'yes' : 'no'));
      result.push('webgl blue bits:' + gl.getParameter(gl.BLUE_BITS));
      result.push('webgl depth bits:' + gl.getParameter(gl.DEPTH_BITS));
      result.push('webgl green bits:' + gl.getParameter(gl.GREEN_BITS));
      result.push('webgl max anisotropy:' + maxAnisotropy(gl));
      result.push('webgl max combined texture image units:' + gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS));
      result.push('webgl max cube map texture size:' + gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE));
      result.push('webgl max fragment uniform vectors:' + gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS));
      result.push('webgl max render buffer size:' + gl.getParameter(gl.MAX_RENDERBUFFER_SIZE));
      result.push('webgl max texture image units:' + gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS));
      result.push('webgl max texture size:' + gl.getParameter(gl.MAX_TEXTURE_SIZE));
      result.push('webgl max varying vectors:' + gl.getParameter(gl.MAX_VARYING_VECTORS));
      result.push('webgl max vertex attribs:' + gl.getParameter(gl.MAX_VERTEX_ATTRIBS));
      result.push('webgl max vertex texture image units:' + gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS));
      result.push('webgl max vertex uniform vectors:' + gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS));
      result.push('webgl max viewport dims:' + fa2s(gl.getParameter(gl.MAX_VIEWPORT_DIMS)));
      result.push('webgl red bits:' + gl.getParameter(gl.RED_BITS));
      result.push('webgl renderer:' + gl.getParameter(gl.RENDERER));
      result.push('webgl shading language version:' + gl.getParameter(gl.SHADING_LANGUAGE_VERSION));
      result.push('webgl stencil bits:' + gl.getParameter(gl.STENCIL_BITS));
      result.push('webgl vendor:' + gl.getParameter(gl.VENDOR));
      result.push('webgl version:' + gl.getParameter(gl.VERSION));

      try {
        // Add the unmasked vendor and unmasked renderer if the debug_renderer_info extension is available
        var extensionDebugRendererInfo = gl.getExtension('WEBGL_debug_renderer_info');

        if (extensionDebugRendererInfo) {
          result.push('webgl unmasked vendor:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL));
          result.push('webgl unmasked renderer:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL));
        }
      } catch (e) {
        /* squelch */
      }

      if (!gl.getShaderPrecisionFormat) {
        loseWebglContext(gl);
        return result;
      }

      each(['FLOAT', 'INT'], function (numType) {
        each(['VERTEX', 'FRAGMENT'], function (shader) {
          each(['HIGH', 'MEDIUM', 'LOW'], function (numSize) {
            each(['precision', 'rangeMin', 'rangeMax'], function (key) {
              var format = gl.getShaderPrecisionFormat(gl[shader + '_SHADER'], gl[numSize + '_' + numType])[key];

              if (key !== 'precision') {
                key = 'precision ' + key;
              }

              var line = ['webgl ', shader.toLowerCase(), ' shader ', numSize.toLowerCase(), ' ', numType.toLowerCase(), ' ', key, ':', format].join('');
              result.push(line);
            });
          });
        });
      });
      loseWebglContext(gl);
      return result;
    };

    var webglKey = function webglKey(done, options) {
      if (isWebGlSupported()) {
        done(getWebglFp());
        return;
      }

      done(options.NOT_AVAILABLE);
    };

    var adBlockKey = function adBlockKey(done) {
      done(getAdBlock());
    };

    var hasLiedLanguagesKey = function hasLiedLanguagesKey(done) {
      done(getHasLiedLanguages());
    };

    var hasLiedResolutionKey = function hasLiedResolutionKey(done) {
      done(getHasLiedResolution());
    };

    var hasLiedOsKey = function hasLiedOsKey(done) {
      done(getHasLiedOs());
    };

    var hasLiedBrowserKey = function hasLiedBrowserKey(done) {
      done(getHasLiedBrowser());
    };

    var touchSupportKey = function touchSupportKey(done) {
      done(getTouchSupport());
    };

    var webglVendorAndRendererKey = function webglVendorAndRendererKey(done) {
      if (isWebGlSupported()) {
        done(getWebglVendorAndRenderer());
        return;
      }

      done();
    };

    var components = [{
      key: 'canvas',
      getData: canvasKey
    }, {
      key: 'webgl',
      getData: webglKey
    }, {
      key: 'webglVendorAndRenderer',
      getData: webglVendorAndRendererKey
    }, {
      key: 'adBlock',
      getData: adBlockKey
    }, {
      key: 'hasLiedLanguages',
      getData: hasLiedLanguagesKey
    }, {
      key: 'hasLiedResolution',
      getData: hasLiedResolutionKey
    }, {
      key: 'hasLiedOs',
      getData: hasLiedOsKey
    }, {
      key: 'hasLiedBrowser',
      getData: hasLiedBrowserKey
    }, {
      key: 'touchSupport',
      getData: touchSupportKey
    }];

    var Fingerprint2 = function Fingerprint2() {
      throw new Error("'new Fingerprint()' is deprecated, see https://github.com/Valve/fingerprintjs2#upgrade-guide-from-182-to-200");
    };

    Fingerprint2.get = function (options, callback) {
      if (!callback) {
        callback = options;
        options = {};
      } else if (!options) {
        options = {};
      }

      extendSoft(options, defaultOptions);
      options.components = options.extraComponents.concat(components);
      var keys = {
        data: [],
        addPreprocessedComponent: function addPreprocessedComponent(key, value) {
          if (typeof options.preprocessor === 'function') {
            value = options.preprocessor(key, value);
          }

          keys.data.push({
            key: key,
            value: value
          });
        }
      };
      var i = -1;

      var chainComponents = function chainComponents(alreadyWaited) {
        i += 1;

        if (i >= options.components.length) {
          // on finish
          callback(keys.data);
          return;
        }

        var component = options.components[i];

        if (options.excludes[component.key]) {
          chainComponents(false); // skip

          return;
        }

        if (!alreadyWaited && component.pauseBefore) {
          i -= 1;
          setTimeout(function () {
            chainComponents(true);
          }, 1);
          return;
        }

        try {
          component.getData(function (value) {
            keys.addPreprocessedComponent(component.key, value);
            chainComponents(false);
          }, options);
        } catch (error) {
          // main body error
          keys.addPreprocessedComponent(component.key, String(error));
          chainComponents(false);
        }
      };

      chainComponents(false);
    };

    Fingerprint2.getPromise = function (options) {
      return new Promise(function (resolve, reject) {
        try {
          Fingerprint2.get(options, resolve);
        } catch (error) {
          reject(error);
        }
      });
    };

    Fingerprint2.getV18 = function (options, callback) {
      if (callback == null) {
        callback = options;
        options = {};
      }

      return Fingerprint2.get(options, function (components) {
        var newComponents = [];

        for (var i = 0; i < components.length; i++) {
          var component = components[i];

          if (component.value === (options.NOT_AVAILABLE || 'not available')) {
            newComponents.push({
              key: component.key,
              value: 'unknown'
            });
          } else if (component.key === 'plugins') {
            newComponents.push({
              key: 'plugins',
              value: map(component.value, function (p) {
                var mimeTypes = map(p[2], function (mt) {
                  if (mt.join) {
                    return mt.join('~');
                  }

                  return mt;
                }).join(',');
                return [p[0], p[1], mimeTypes].join('::');
              })
            });
          } else if (['canvas', 'webgl'].indexOf(component.key) !== -1 && Array.isArray(component.value)) {
            // sometimes WebGL returns error in headless browsers (during CI testing for example)
            // so we need to join only if the values are array
            newComponents.push({
              key: component.key,
              value: component.value.join('~')
            });
          } else if (['sessionStorage', 'localStorage', 'indexedDb', 'addBehavior', 'openDatabase'].indexOf(component.key) !== -1) {
            if (component.value) {
              newComponents.push({
                key: component.key,
                value: 1
              });
            } else {
              // skip
              continue;
            }
          } else {
            if (component.value) {
              newComponents.push(component.value.join ? {
                key: component.key,
                value: component.value.join(';')
              } : component);
            } else {
              newComponents.push({
                key: component.key,
                value: component.value
              });
            }
          }
        }

        var murmur = x64hash128(map(newComponents, function (component) {
          return component.value;
        }).join('~~~'), 31);
        callback(murmur, newComponents);
      });
    };

    Fingerprint2.x64hash128 = x64hash128;
    Fingerprint2.VERSION = '2.1.0';
    return Fingerprint2;
  });
});

var log$2 = src('xpedeo-core:device');
src.enable(process.env.VUE_APP_DEBUG);
var Device = {
  __platform: process.env.VUE_APP_PLATFORM,
  __isLoan: process.env.VUE_APP_IS_LOAN_DEVICE,
  __deviceId: null,
  __$xp: null,

  get platform() {
    return this.__platform;
  },

  get isLoan() {
    return this.__isLoan;
  },

  get deviceId() {
    log$2('deviceId', this.__deviceId);
    return this.__deviceId;
  },

  get isIPhoneOrPad() {
    var UA = window.navigator.userAgent.toLowerCase();
    return UA && /iphone|ipad/.test(UA);
  },

  get isTouchDevice() {
    return 'ontouchstart' in document.documentElement;
  },

  get isWindows() {
    var UA = window.navigator.userAgent.toLowerCase();
    return UA && /windows/.test(UA);
  },

  get isFirefox() {
    var UA = window.navigator.userAgent.toLowerCase();
    return UA && /firefox/.test(UA);
  },

  get isSafari() {
    var UA = window.navigator.userAgent.toLowerCase();
    return UA && /safari/.test(UA) && !(UA && /chrome/.test(UA));
  },

  getUuid: function getUuid() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.__deviceId) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", _this.__deviceId);

            case 4:
              _this.__deviceId = window.localStorage.getItem('deviceId');

              if (!(_this.__deviceId !== null)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", _this.__deviceId);

            case 9:
              _context.next = 11;
              return _this.generateFingerprint();

            case 11:
              log$2('generated deviceId', _this.__deviceId);
              return _context.abrupt("return", _this.__deviceId);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  goToAdminActivity: function goToAdminActivity$1() {
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              log$2('goToAdminActivity()');
              _context2.next = 3;
              return goToAdminActivity();

            case 3:
              log$2('goToAdminActivity() success');

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  isLocationEnabled: function isLocationEnabled() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(_this2.__platform === 'browser')) {
                _context3.next = 6;
                break;
              }

              _context3.next = 3;
              return _this2.checkBrowserLocationPermission();

            case 3:
              return _context3.abrupt("return", _context3.sent);

            case 6:
              if (!process.env.VUE_APP_IS_LOAN_DEVICE) {
                _context3.next = 11;
                break;
              }

              _context3.next = 9;
              return checkLoanLocationSettings();

            case 9:
              _context3.next = 15;
              break;

            case 11:
              if (!(_this2.__platform === 'android' || _this2.__platform === 'ios')) {
                _context3.next = 15;
                break;
              }

              _context3.next = 14;
              return _this2.checkMobileLocationEnabled();

            case 14:
              return _context3.abrupt("return", _context3.sent);

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  checkLocationSettings: function checkLocationSettings() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              log$2('checkLocationSettings()');
              log$2("checkLocationSettings ".concat(_this3.__platform === 'browser'));
              _context4.prev = 2;

              if (!(_this3.__platform === 'browser')) {
                _context4.next = 7;
                break;
              }

              return _context4.abrupt("return", _this3.checkBrowserLocationPermission());

            case 7:
              if (!process.env.VUE_APP_IS_LOAN_DEVICE) {
                _context4.next = 13;
                break;
              }

              _context4.next = 10;
              return checkLoanLocationSettings();

            case 10:
              return _context4.abrupt("return", _context4.sent);

            case 13:
              if (!(_this3.__platform === 'android')) {
                _context4.next = 19;
                break;
              }

              _context4.next = 16;
              return _this3.checkAndroidLocationPermission();

            case 16:
              return _context4.abrupt("return", _context4.sent);

            case 19:
              if (!(_this3.__platform === 'ios')) {
                _context4.next = 23;
                break;
              }

              _context4.next = 22;
              return _this3.checkiOSLocationSettings();

            case 22:
              return _context4.abrupt("return", _context4.sent);

            case 23:
              _context4.next = 29;
              break;

            case 25:
              _context4.prev = 25;
              _context4.t0 = _context4["catch"](2);
              console.error(_context4.t0);
              return _context4.abrupt("return", false);

            case 29:
              log$2('checkLocationSettings() success');
              return _context4.abrupt("return", true);

            case 31:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 25]]);
    }))();
  },
  checkBrowserLocationPermission: function checkBrowserLocationPermission() {
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
      var result;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              console.log('querrying browser location permission');
              _context5.next = 3;
              return navigator.permissions.query({
                name: 'geolocation'
              });

            case 3:
              result = _context5.sent;
              console.log('browser location permission', result);

              if (!(result.state === 'granted')) {
                _context5.next = 9;
                break;
              }

              return _context5.abrupt("return", true);

            case 9:
              if (!(result.state === 'prompt')) {
                _context5.next = 13;
                break;
              }

              /** handle prompt */
              log$2('prompt for location permission');
              _context5.next = 15;
              break;

            case 13:
              if (!(result.state === 'denied')) {
                _context5.next = 15;
                break;
              }

              return _context5.abrupt("return", false);

            case 15:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  checkAndroidLocationPermission: function checkAndroidLocationPermission() {
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6() {
      var diagnostic, permissions;
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              diagnostic = window.cordova.plugins.diagnostic;
              permissions = [// diagnostic.permission.WRITE_EXTERNAL_STORAGE,
              // diagnostic.permission.READ_EXTERNAL_STORAGE,
              diagnostic.permission.ACCESS_FINE_LOCATION, diagnostic.permission.ACCESS_COARSE_LOCATION];
              _context6.next = 5;
              return checkPermissions(permissions);

            case 5:
              return _context6.abrupt("return", _context6.sent);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);
              console.error(_context6.t0);
              return _context6.abrupt("return", false);

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 8]]);
    }))();
  },
  checkiOSLocationSettings: function checkiOSLocationSettings() {
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7() {
      return regenerator.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", new Promise(function (resolve, reject) {
                var diagnostic = window.cordova.plugins.diagnostic;
                diagnostic.isLocationAvailable(function (available) {
                  if (available) {
                    resolve(true);
                  } else {
                    diagnostic.requestLocationAuthorization(function (result) {
                      console.log(result);
                      resolve(true);
                    }, function (e) {
                      console.log(e);
                      resolve(false);
                    }, diagnostic.locationAuthorizationMode.ALWAYS);
                  }
                }, function (error) {
                  console.error(error);
                  reject(error);
                  return false;
                });
              }));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  checkMobileLocationEnabled: function checkMobileLocationEnabled() {
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8() {
      var diagnostic;
      return regenerator.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              diagnostic = window.cordova.plugins.diagnostic;
              diagnostic.isLocationAvailable(function (available) {
                console.log('Location is ' + (available ? 'available' : 'not available'));
                return true;
              }, function (error) {
                console.error('The following error occurred: ' + error);
                return false;
              });
              _context8.next = 9;
              break;

            case 5:
              _context8.prev = 5;
              _context8.t0 = _context8["catch"](0);
              console.error(_context8.t0);
              return _context8.abrupt("return", false);

            case 9:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[0, 5]]);
    }))();
  },
  getRemappedUrl: function getRemappedUrl$1(url) {
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee9() {
      var remappedUrl;
      return regenerator.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              log$2('getRemappedUrl()');
              _context9.next = 3;
              return getRemappedUrl(url);

            case 3:
              remappedUrl = _context9.sent;
              log$2('getRemappedUrl() success');
              return _context9.abrupt("return", remappedUrl);

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }))();
  },
  checkPermissions: function checkPermissions$1() {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee10() {
      var permissions;
      return regenerator.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              permissions = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : [];
              log$2('checkPermissions()');
              _context10.next = 4;
              return checkPermissions(permissions);

            case 4:
              log$2('checkPermissions() success');

            case 5:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }))();
  },
  generateFingerprint: function generateFingerprint() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee11() {
      var getFingerprint;
      return regenerator.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              getFingerprint = function getFingerprint() {
                fingerprint.get(function (components) {
                  var values = components.map(function (component) {
                    return component.value;
                  });
                  var murmur = fingerprint.x64hash128(values.join(''), 31);
                  log$2('murmur hash(DeviceId):', murmur);
                  _this4.__deviceId = murmur;
                  window.localStorage.setItem('deviceId', murmur);
                });
              };

              if (window.requestIdleCallback) {
                requestIdleCallback(getFingerprint);
              } else {
                setTimeout(getFingerprint, 500);
              }

            case 2:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }))();
  },
  getDeviceTimeOffset: function getDeviceTimeOffset$1() {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      getDeviceTimeOffset().then(function (deviceTimeOffset) {
        return deviceTimeOffset;
      });
    } else {
      log$2('getDeviceTimeOffset() NOT A LOAN DEVICE');
      return 0;
    }
  },
  install: function install(Vue, opts, $xp) {
    if ($xp.deviceInstalled) {
      return;
    }

    this.__$xp = $xp;
    $xp.deviceInstalled = true;
    Vue.util.defineReactive($xp, 'device', this);
  }
};

/**
 * Throttling enforces a maximum number of times a function can be called over time. As in “execute this function at most once every X milliseconds.”.
 * see http://demo.nimius.net/debounce_throttle/
 *
 * @param {function} fn throttled function
 * @param {integer} limit in milliseconds
 */
function throttle (fn) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var wait = false;
  var result;
  return function
    /* ...args */
  () {
    if (wait === false) {
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
      result = fn.apply(this, arguments); // eslint-disable-line
    }

    return result;
  };
}

var log$3 = src('xpedeo-core:navigation');
src.enable(process.env.VUE_APP_DEBUG);
var Navigation = {
  __isNavHidden: false,
  __isAutoHideAllowed: false,
  __isChildPagesMenuHidden: true,
  __isHomeMenuHidden: true,
  __$xp: null,
  _isScreenReader: false,
  isEventConsumerEnabled: false,
  // __isAudioControlAutoHideAllowed: true,
  isFullScreen: false,
  entriesIdList: [],
  currentEntryIndex: 0,
  isAudioSynced: false,
  bManualSlideshow: false,
  // AudioPlayer manual slideshow
  entryNavDirection: '',
  __tabs: [],
  __activeTabId: null,
  __childPagesMenuItems: [],
  __childPagesHaveIcons: false,
  showNavCounter: 0,

  get isNavHidden() {
    return this.__isNavHidden && !this.isScreenReader;
  },

  get isAutoHideAllowed() {
    return this.__isAutoHideAllowed && !this.isScreenReader;
  },

  get isChildPagesMenuHidden() {
    return this.__isChildPagesMenuHidden;
  },

  get isHomeMenuHidden() {
    return this.__isHomeMenuHidden;
  },

  get hasPreviousEntry() {
    return this.currentEntryIndex > 0;
  },

  get hasNextEntry() {
    return this.currentEntryIndex < this.entriesIdList.length - 1;
  },

  // get isAudioControlAutoHideAllowed () {
  //   return this.__isAudioControlAutoHideAllowed
  // },
  get currentEntry() {
    return this.entriesIdList[this.currentEntryIndex];
  },

  get isEntryNavVisible() {
    return !this.isAudioSynced && this.entriesIdList.length > 1 && this.isFullScreen;
  },

  // set autoHideAudioControl (value) {
  //   this.__isAudioControlAutoHideAllowed = value
  // },
  get tabs() {
    return this.__tabs;
  },

  get activeTabId() {
    return this.__activeTabId;
  },

  get childPagesMenuItems() {
    return this.__childPagesMenuItems;
  },

  get childPagesHaveIcons() {
    return this.__childPagesHaveIcons;
  },

  get isScreenReader() {
    return this._isScreenReader;
  },

  checkScreenReader: function checkScreenReader() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.__$xp.device.platform !== 'browser')) {
                _context.next = 10;
                break;
              }

              if (!(window.cordova.plugins.diagnostic && typeof window.cordova.plugins.diagnostic.isAccessibilityModeEnabled === 'function')) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return window.cordova.plugins.diagnostic.isAccessibilityModeEnabled(function (success) {
                _this._isScreenReader = success;
                return success;
              }, function (error) {
                log$3('checking accessibility mode failed, error: ', error);
              });

            case 4:
              _this._isScreenReader = _context.sent;
              _context.next = 8;
              break;

            case 7:
              return _context.abrupt("return", _this._isScreenReader);

            case 8:
              _context.next = 11;
              break;

            case 10:
              return _context.abrupt("return", _this._isScreenReader);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  toggleChildPagesMenu: function toggleChildPagesMenu() {
    this.__isChildPagesMenuHidden = !this.__isChildPagesMenuHidden;
  },
  toggleHomeMenu: function toggleHomeMenu() {
    this.__isHomeMenuHidden = !this.__isHomeMenuHidden;
  },
  allowAutoHide: function allowAutoHide() {
    log$3('allow auto hide');
    this.__isAutoHideAllowed = true;
  },
  preventAutoHide: function preventAutoHide() {
    log$3('prevent auto hide');
    this.__isAutoHideAllowed = false;
  },
  // allowAudioControlAutoHide () {
  //   this.__isAudioControlAutoHideAllowed = true
  // },
  preventAudioControlAutoHide: function preventAudioControlAutoHide() {
    this.__isAudioControlAutoHideAllowed = false;
  },
  initEntriesIdList: function initEntriesIdList(list) {
    this.entriesIdList = list;
    this.entryNavDirection = null;
    this.currentEntryIndex = 0;
  },
  goToNextEntry: function goToNextEntry() {
    this.entryNavDirection = 'next';
    this.currentEntryIndex = Math.abs((this.currentEntryIndex + 1) % this.entriesIdList.length);
    console.log('currentEntryIndex', this.currentEntryIndex);
  },
  goToPreviousEntry: function goToPreviousEntry() {
    this.entryNavDirection = 'previous';
    var index = (this.currentEntryIndex - 1) % this.entriesIdList.length;

    if (index < 0) {
      index += this.entriesIdList.length;
    }

    this.currentEntryIndex = index;
    console.log('currentEntryIndex', this.currentEntryIndex);
  },
  goToEntry: function goToEntry(entryId) {
    console.log('goto', entryId);
    this.currentEntryIndex = this.entriesIdList.indexOf(entryId);
    console.log('currentEntryIndex', this.currentEntryIndex);
  },

  /**
   * show Navigation
   * @param duration: (undefined: do not autohide, number: autohide after milliseconds, true: autohide after default autoHideNavDuration)
   */
  showNav: function showNav(duration) {
    var _this2 = this;

    duration = duration === true ? this.__$xp.settings.mergedSettings.navigation.autoHideNavDuration : duration; // Ausnahme SplashScreen:

    if (this.__$xp.content && this.__$xp.content.pageData && this.__$xp.content.pageData.Class === 'XpSplashScreen') {
      this.__isNavHidden = true;
      this.preventAutoHide();
      return;
    }

    clearTimeout(this.showNavCounter);
    this.__isNavHidden = false;

    if (duration && this.isAutoHideAllowed) {
      this.showNavCounter = setTimeout(function () {
        _this2.__isNavHidden = true;
      }, duration);
    }
  },
  hideNav: function hideNav() {
    clearTimeout(this.showNavCounter);
    this.__isNavHidden = true;
  },
  setTabs: function setTabs(tabs) {
    this.__tabs = tabs;
  },
  resetTabs: function resetTabs() {
    this.__tabs = [];
    this.__activeTabId = null;
  },
  setActiveTabId: function setActiveTabId(tabId) {
    if (this.__activeTabId !== parseInt(tabId)) {
      this.__activeTabId = parseInt(tabId);
    }
  },
  setChildPagesMenuItems: function setChildPagesMenuItems(items) {
    var _iterator = _createForOfIteratorHelper(items),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;

        if (item.icon && (item.icon.Type !== 'icon' || item.icon.Name !== 0)) {
          this.__childPagesHaveIcons = true;
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    this.__childPagesMenuItems = items;
  },
  resetChildPagesMenuItems: function resetChildPagesMenuItems() {
    this.__childPagesHaveIcons = false;
    this.__childPagesMenuItems = [];
  },
  initializeTouchEvents: function initializeTouchEvents() {
    var _this3 = this;

    var onTouchStart = function onTouchStart(e) {
      // console.log('onTouchStart()', e)
      if (_this3.__$xp.navigation.isAutoHideAllowed) {
        _this3.__$xp.navigation.showNav();
      }

      _this3.__$xp.screen.postponeDim();
      /*
        iPhones starting with iOS10 ignore "user-scalable=no" "to improve accessibility"
        To prevent pinch zooming the whole site, we ignore multi-touch-events if the event is not handled before.
       */


      if (_this3.__$xp.device.isIPhoneOrPad) {
        if (!e.handled && e.touches && e.touches.length > 1) {
          e.preventDefault();
        }
      }
    };

    var onTouchEnd = function onTouchEnd(e) {
      // console.log('onTouchEnd()', e)
      if (_this3.__$xp.device.platform === 'browser' && !(_this3.__$xp.device.isIPhoneOrPad && !_this3.__$xp.device.isSafari)) {
        _this3.__$xp.screen.requestFullscreen();
      }

      if (_this3.__$xp.navigation.isAutoHideAllowed) {
        _this3.__$xp.navigation.showNav(true);
      }
      /*
        iPhones starting with iOS10 ignore "user-scalable=no" "to improve accessibility"
        To prevent zooming the whole site on double click, we ignore double clicks.
       */


      if (_this3.__$xp.device.isIPhoneOrPad) {
        var now = new Date().getTime();

        if (now - _this3.lastTouchEnd <= 300) {
          e.preventDefault();
        }

        _this3.lastTouchEnd = now;
      }
    };

    var onTouchEndHandler = throttle(onTouchEnd, 100);
    var onTouchStartHandler = throttle(onTouchStart, 100);
    window.addEventListener('pointerdown', onTouchStartHandler, false);
    window.addEventListener('pointerup', onTouchEndHandler, false);
  },
  getUniqueSelector: function getUniqueSelector(node) {
    var selector = '';

    while (node.parentElement) {
      if (node.id) {
        return '#' + node.id + "".concat(selector ? ' > ' : '').concat(selector);
      }

      var nodeName = node.tagName.toLowerCase();
      var siblings = Array.from(node.parentElement.children).filter(function (e) {
        return e.tagName === node.tagName;
      });
      selector = nodeName + (siblings.indexOf(node) ? ":nth-of-type(".concat(siblings.indexOf(node) + 1, ")") : '') + "".concat(selector ? ' > ' : '').concat(selector);
      node = node.parentElement;
    }

    return selector;
  },
  install: function install(Vue, opts, $xp) {
    if ($xp.navigationInstalled) {
      return;
    }

    $xp.navigationInstalled = true;
    this.__$xp = $xp;
    this.initializeTouchEvents();
    Vue.util.defineReactive($xp, 'navigation', this);
  }
};

var Battery = {
  __isPlugged: null,
  __level: 0,
  __$xp: null,
  __$router: null,

  get level() {
    return this.__level;
  },

  get isPlugged() {
    return this.__isPlugged;
  },

  setBatteryStatus: function setBatteryStatus(status) {
    this.__isPlugged = status.isPlugged;
    this.__level = status.level;
  },
  startListening: function startListening(handler) {
    window.addEventListener('batterystatus', handler, false);
  },
  stopListening: function stopListening(handler) {
    window.removeEventListener('batterystatus', handler, false);
  },
  init: function init() {
    this.__$xp.device.isLoan && this.startListening(this.onBatteryStatus.bind(this));
  },
  onBatteryStatus: function onBatteryStatus(status) {
    if (this.__$xp.device.platform === 'android') {
      if (this.isPlugged !== null) {
        if (!this.isPlugged && status.isPlugged) {
          this.__$router.replace('/dock');
        } else if (this.isPlugged && !status.isPlugged && this.__$router.currentRoute.path === '/dock') {
          this.__$router.push('/');
        }
      }

      this.setBatteryStatus({
        isPlugged: status.isPlugged,
        level: status.level
      });
    }
  },
  install: function install(Vue, opts, $xp) {
    if ($xp.batteryInstalled) {
      return;
    }

    $xp.batteryInstalled = true;
    this.__$xp = $xp;
    this.__$router = opts.router;
    Vue.util.defineReactive($xp, 'battery', this);
  }
};

var lockWifiOn = function lockWifiOn(lockId) {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.lockWifiOn(lockId, function (locks) {
        resolve(locks);
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else {
      resolve([]);
    }
  });
};

var releaseWifiOn = function releaseWifiOn(lockId) {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.releaseWifiOn(lockId, function (locks) {
        resolve(locks);
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else {
      resolve([]);
    }
  });
};

var lockWifiConnectionOn = function lockWifiConnectionOn(lockId) {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.lockWifiConnectionOn(lockId, function (locks) {
        resolve(locks);
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else {
      resolve([]);
    }
  });
};

var releaseWifiConnectionOn = function releaseWifiConnectionOn(lockId) {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.releaseWifiConnectionOn(lockId, function (locks) {
        resolve(locks);
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else {
      resolve([]);
    }
  });
};

var isWifiEnabled = function isWifiEnabled() {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.isWifiEnabled(function () {
        resolve();
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else {
      resolve();
    }
  });
};

var getConnectedSSID = function getConnectedSSID() {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.getConnectedSSID(function (ssid) {
        resolve(ssid);
      }, function (errorMsg) {
        reject(new Error(errorMsg));
      });
    } else {
      resolve();
    }
  });
};

var wifiFacad = {
  lockWifiOn: lockWifiOn,
  releaseWifiOn: releaseWifiOn,
  lockWifiConnectionOn: lockWifiConnectionOn,
  releaseWifiConnectionOn: releaseWifiConnectionOn,
  isWifiEnabled: isWifiEnabled,
  getConnectedSSID: getConnectedSSID
};

var log$4 = src('xpedeo-core:wifi');
src.enable(process.env.VUE_APP_DEBUG);
var Wifi = {
  __locks: [],

  get locks() {
    return this.__locks;
  },

  lockWifiOn: function lockWifiOn(callerLockId) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              log$4("lockWifiOn(".concat(callerLockId, ")"));
              _context.prev = 1;
              _context.next = 4;
              return wifiFacad.lockWifiOn(callerLockId);

            case 4:
              _this.__locks = _context.sent;
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              log$4('lockWifiOn error', _context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }))();
  },
  releaseWifiOn: function releaseWifiOn(callerLockId) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              log$4("releaseWifiOn(".concat(callerLockId, ")"));
              _context2.prev = 1;
              _context2.next = 4;
              return wifiFacad.releaseWifiOn(callerLockId);

            case 4:
              _this2.__locks = _context2.sent;
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);
              log$4('releaseWifiOn error', _context2.t0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 7]]);
    }))();
  },
  lockWifiConnectionOn: function lockWifiConnectionOn(callerLockId) {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              log$4("lockWifiConnectionOn(".concat(callerLockId, ")"));
              _context3.prev = 1;
              _context3.next = 4;
              return wifiFacad.lockWifiConnectionOn(callerLockId);

            case 4:
              _this3.__locks = _context3.sent;
              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](1);
              log$4('lockWifiConnectionOn error', _context3.t0);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 7]]);
    }))();
  },
  releaseWifiConnectionOn: function releaseWifiConnectionOn(callerLockId) {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              log$4("releaseWifiConnectionOn(".concat(callerLockId, ")"));
              _context4.prev = 1;
              _context4.next = 4;
              return wifiFacad.releaseWifiConnectionOn(callerLockId);

            case 4:
              _this4.__locks = _context4.sent;
              _context4.next = 10;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](1);
              log$4('releaseWifiConnectionOn error', _context4.t0);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 7]]);
    }))();
  },
  isWifiEnabled: function isWifiEnabled() {
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
      var isEnabled;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              log$4('isWifiEnabled()');
              _context5.prev = 1;
              _context5.next = 4;
              return wifiFacad.isWifiEnabled();

            case 4:
              isEnabled = _context5.sent;
              log$4('isWifiEnabled() success');
              return _context5.abrupt("return", isEnabled);

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](1);
              log$4('releaseWifiConnectionOn error', _context5.t0);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 9]]);
    }))();
  },
  waitForWifi: function waitForWifi() {
    var _this5 = this;

    var timeoutMilliseconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
    log$4("waitForWifi(".concat(timeoutMilliseconds, ")"));
    return new Promise(function (resolve, reject) {
      if (_this5.isWifiEnabled) {
        resolve();
      } else {
        var interval = null;
        var timeout = setTimeout(function () {
          clearInterval(interval);
          reject(new Error('wait for wifi timeout.'));
        }, timeoutMilliseconds);
        interval = setInterval(function () {
          if (_this5.isWifiEnabled) {
            clearTimeout(timeout);
            resolve();
          }
        }, 1000);
      }
    });
  },
  getConnectedSSID: function getConnectedSSID() {
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6() {
      var ssid;
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              log$4('getConnectedSSID');
              _context6.prev = 1;
              _context6.next = 4;
              return wifiFacad.getConnectedSSID();

            case 4:
              ssid = _context6.sent;
              log$4('getConnectedSSID() success');
              return _context6.abrupt("return", ssid);

            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6["catch"](1);
              log$4('releaseWifiConnectionOn error', _context6.t0);

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[1, 9]]);
    }))();
  },
  install: function install(Vue, opts, $xp) {
    if ($xp.wifiInstalled) {
      return;
    }

    $xp.wifiInstalled = true;
    Vue.util.defineReactive($xp, 'wifi', this);
  }
};

var vm = new Vue();

var getSettings = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
    var langCode,
        _args2 = arguments;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            langCode = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : null;
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              if (process.env.VUE_APP_IS_LOAN_DEVICE) {
                if (langCode === null || langCode === '_') {
                  window.XpedeoPreloader.getSettings(function (settings) {
                    resolve(settings);
                  }, function (errMsg) {
                    reject(new Error(errMsg));
                  });
                } else {
                  window.XpedeoPreloader.getSettingsLang(langCode, function (settings) {
                    resolve(settings);
                  }, function (errMsg) {
                    reject(new Error(errMsg));
                  });
                }
              } else {
                var getRemappedUrl = /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(url) {
                    return regenerator.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            return _context.abrupt("return", new Promise(function (resolve, reject) {
                              window.XpedeoPreloader.getRemappedUrl(url, function (remappedUrl) {
                                resolve(remappedUrl);
                              }, function (errMsg) {
                                reject(new Error(errMsg));
                              });
                            }));

                          case 1:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function getRemappedUrl(_x) {
                    return _ref2.apply(this, arguments);
                  };
                }();

                var configPageID = window.XPEDEO_SETTINGS.content.configPageID || 37;
                var remoteUrl = window.XPEDEO_SETTINGS.content.remoteUrl;
                var useStaticPageFiles = typeof window.XPEDEO_SETTINGS.content.useStaticPageFiles !== 'undefined' && window.XPEDEO_SETTINGS.content.useStaticPageFiles;
                var url = ''; // case of lang link (see router guards), [null || _] means de ( default )

                if (langCode === null || langCode === '_' || langCode === ' ' || langCode === '') {
                  url = remoteUrl + 'xpedeo/' + (useStaticPageFiles ? "P".concat(configPageID, ".json") : "api/v1/pages/".concat(configPageID));
                } else {
                  url = remoteUrl + 'xpedeo/' + (langCode.includes('/') ? langCode : langCode + '/') + (useStaticPageFiles ? "P".concat(configPageID, ".json") : "api/v1/pages/".concat(configPageID));
                }

                console.log('vm.$xp.device.platform', vm.$xp.device.platform);

                if (vm.$xp.device.platform === 'android' && window.XpedeoPreloader) {
                  var remappedUrl = getRemappedUrl(url).then(function (remappedUrl) {
                    console.log('getSettings remappedUrl', remappedUrl); // } else {

                    if (remappedUrl === url) {
                      axios.get(remappedUrl).then(function (response) {
                        console.log(response.data.Settings);
                        resolve(response.data.Settings); // settingsObject = response.data.Settings
                      }).catch(function (e) {
                        return reject(e);
                      });
                    } else {
                      window.XpedeoPreloader.getSettings(remappedUrl, function (settings) {
                        console.log(settings);
                        var jsonParsed = JSON.parse(settings);
                        console.log('jsonParsed', jsonParsed.Settings);
                        resolve(jsonParsed.Settings);
                      }, function (errMsg) {
                        reject(new Error(errMsg));
                      });
                    }
                  });
                } else {
                  if (vm.$xp.device.platform === 'ios') {
                    if (window.XpedeoPreloader) {
                      url = window.XpedeoPreloader.convertProxyUrl(url);
                    }
                  }

                  console.log('vm.$xp.device.platform', url);
                  axios.get(url).then(function (response) {
                    resolve(response.data.Settings);
                  }).catch(function (e) {
                    return reject(e);
                  });
                }
              }
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getSettings() {
    return _ref.apply(this, arguments);
  };
}();

var setSettings = function setSettings(jsonString) {
  return new Promise(function (resolve, reject) {
    if (window.device.platform.toLowerCase() === 'android') {
      window.XpedeoPreloader.setSettings(jsonString, function () {
        resolve(JSON.parse(jsonString));
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else {
      resolve(JSON.parse(jsonString));
    }
  });
};

var settingsFacade = {
  getSettings: getSettings,
  setSettings: setSettings
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
var isArray_1 = isArray;

/** Detect free variable `global` from Node.js. */

var freeGlobal = _typeof(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */

var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = _freeGlobal || freeSelf || Function('return this')();
var _root = root;

/** Built-in value references. */

var _Symbol2 = _root.Symbol;
var _Symbol = _Symbol2;

/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto.toString;
/** Built-in value references. */

var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }

  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag$1 && symToStringTag$1 in Object(value) ? _getRawTag(value) : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && _typeof(value) == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */

var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike_1(value) && _baseGetTag(value) == symbolTag;
}

var isSymbol_1 = isSymbol;

/** Used to match property names within property paths. */

var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */

function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }

  var type = _typeof(value);

  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol_1(value)) {
    return true;
  }

  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

var _isKey = isKey;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);

  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */

var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */

var coreJsData = _root['__core-js_shared__'];
var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$1 = funcProto$1.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }

  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */

function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */

var nativeCreate = _getNative(Object, 'create');
var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */

function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$3 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet(key) {
  var data = this.__data__;

  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }

  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */

var objectProto$4 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? data[key] !== undefined : hasOwnProperty$3.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = _nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;
var _Hash = Hash;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */

var arrayProto = Array.prototype;
/** Built-in value references. */

var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */

function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;
var _ListCache = ListCache;

/* Built-in method references that are verified to be native. */

var Map$1 = _getNative(_root, 'Map');
var _Map = Map$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash(),
    'map': new (_Map || _ListCache)(),
    'string': new _Hash()
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = _typeof(value);

  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */

function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */

function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;
var _MapCache = MapCache;

/** Error message constants. */

var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */

function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };

  memoized.cache = new (memoize.Cache || _MapCache)();
  return memoized;
} // Expose `MapCache`.


memoize.Cache = _MapCache;
var memoize_1 = memoize;

/** Used as the maximum memoize cache size. */

var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */

function memoizeCapped(func) {
  var result = memoize_1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }

    return key;
  });
  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */

var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */

var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath = _memoizeCapped(function (string) {
  var result = [];

  if (string.charCodeAt(0) === 46
  /* . */
  ) {
    result.push('');
  }

  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
var _stringToPath = stringToPath;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}

var _arrayMap = arrayMap;

/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */

var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }

  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */

function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */

function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }

  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;

/** Used as references for various `Number` constants. */

var INFINITY$1 = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

var _toKey = toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */

function baseGet(object, path) {
  path = _castPath(path, object);
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }

  return index && index == length ? object : undefined;
}

var _baseGet = baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */

function get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get;

var defaultSettings = {
  content: {
    startPageId: null,
    remoteUrl: '',
    useStaticPageFiles: false,
    welcomeScreenId: null,
    nfcPageId: null,
    langCode: 'de_DE'
  },
  radio: {
    wifi: {
      APs: null,

      /* Example:            [
      {
      SSID: 'xpedeo',
      authType: 'WPA',
      password: 'abcDEF123',
      hidden: false
      }
      ]
      */
      alwaysOn: false
    },
    nfcActive: false
  },
  screen: {
    brightness: 200,
    standbySeconds: 120,
    halfDimMilliseconds: 120 * 1000,
    fullDimMilliseconds: 180 * 1000,
    halfDimValue: 100,
    fullDimValue: 0
  },
  battery: {
    warningIntervalSeconds: 600,
    dockSleepLevel: 95,
    isPlugged: false
  },
  navigation: {
    backOnAudioEnd: true,
    backOnVideoEnd: true,
    nextPageOnMediaEnd: true,
    resolveBeaconWhilePlaying: false,
    autoPlayPageAudio: true,
    playBeepOnResolvedBeacon: true,
    vibrateOnResolvedBeacon: true,
    numpadInputExtraButtons: [],
    showWelcomeScreen: false,
    autoHideNavDuration: 2000,
    showChildPagesMenu: true,
    mediaIgnoresContextMenu: false
  },
  theme: 't-clear',
  showDeviceName: false,
  exitAppNow: null,
  evaluationEnabled: null,
  allowHardwareVolumeControl: false,
  showLocationSettingsWarning: false,
  showSubtitlesDefault: false,
  zoomRatio: null,
  maxLipsyncLatency: {
    audio: 40,
    video: 1500
  },
  isPanoramaDeviceOrientationEnabled: true
};

var log$5 = src('xpedeo-core:settings');
src.enable(process.env.VUE_APP_DEBUG);
var Settings = {
  __loadedSettings: defaultSettings,
  __pageSettingsArray: [],
  __mergedSettings: {},
  __$xp: null,

  get pageSettingsArray() {
    return this.__pageSettingsArray;
  },

  set pageSettingsArray(value) {
    var mergedPageSettings = value.length >= 2 ? deepmerge.all(Object.values(value)) : value.length === 1 ? value[0] : {};
    this.__mergedSettings = deepmerge(Object.assign({}, this.__loadedSettings), mergedPageSettings);
    this.__pageSettingsArray = value;
  },

  get mergedSettings() {
    return this.__mergedSettings;
  },

  get remoteUrl() {
    return get_1(this.mergedSettings, 'content.remoteUrl') ? get_1(this.mergedSettings, 'content.remoteUrl') : '';
  },

  get baseUrl() {
    if (this.remoteUrl === '') {
      return window.XPEDEO_SETTINGS.content.remoteUrl;
    } else {
      return this.mergedSettings.content.remoteUrl;
    }
  },

  get useStaticPageFiles() {
    if (window.XPEDEO_SETTINGS && window.XPEDEO_SETTINGS.content && typeof window.XPEDEO_SETTINGS.content.useStaticPageFiles !== 'undefined') {
      return window.XPEDEO_SETTINGS.content.useStaticPageFiles;
    } else {
      return this.mergedSettings.content.useStaticPageFiles;
    }
  },

  getValue: function getValue(valuePath) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    return get_1(this.mergedSettings, valuePath, defaultValue);
  },
  saveSettingsState: function saveSettingsState() {
    log$5('Saving settings state');
    window.localStorage.setItem('pageSettingsArray', JSON.stringify(this.__pageSettingsArray));
    window.localStorage.setItem('mergedSettings', JSON.stringify(this.__mergedSettings));
  },
  restoreSettingsState: function restoreSettingsState() {
    log$5('Restoring settings state');
    this.__pageSettingsArray = JSON.parse(window.localStorage.getItem('pageSettingsArray'));
    window.localStorage.setItem('pageSettingsArray', '');
    this.__mergedSettings = JSON.parse(window.localStorage.getItem('mergedSettings'));
    window.localStorage.setItem('mergedSettings', '');
  },
  resetSettingsState: function resetSettingsState() {
    this.pageSettingsArray = [];
  },
  initSettings: function initSettings() {
    var _arguments = arguments,
        _this = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var langPath, settings;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              langPath = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : null;
              log$5('initSettings', langPath);
              _context.next = 4;
              return settingsFacade.getSettings(langPath);

            case 4:
              settings = _context.sent;

              if (langPath !== null) {
                log$5('settings init should reset settings ', langPath);
                _this.__loadedSettings = defaultSettings;
              }

              if (settings.theme) {
                settings.theme = _this.__$xp.device.isLoan && settings.loanTheme ? settings.loanTheme : (_this.__$xp.device.platform === 'android' || _this.__$xp.device.platform === 'ios') && settings.mobileTheme ? settings.mobileTheme : settings.theme ? settings.theme : window.XPEDEO_SETTINGS.theme || 't-clear';
                delete window.XPEDEO_SETTINGS.theme;
              }

              if (!_this.__$xp.device.isLoan && window.XPEDEO_SETTINGS) {
                settings = deepmerge(settings, window.XPEDEO_SETTINGS);
              }

              _this.__loadedSettings = deepmerge(_this.__loadedSettings, settings);
              _this.pageSettingsArray = [];
              log$5('settings initialized successfully.', _this.__loadedSettings);

              if (!_this.__$xp.device.isLoan || settings.allowHardwareVolumeControl) {
                _this.__$xp.media.setGlobalVolume(1);

                _this.__$xp.media.setAllowUIVolumeControl(false);
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  reloadSettings: function reloadSettings() {
    var _arguments2 = arguments,
        _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      var langPath, settings;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              langPath = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : null;
              console.log('reloadSettings', langPath);
              _context2.next = 4;
              return settingsFacade.getSettings(langPath);

            case 4:
              settings = _context2.sent;

              if (!_this2.__$xp.device.isLoan && window.XPEDEO_SETTINGS) {
                settings = deepmerge(settings, window.XPEDEO_SETTINGS);
              }

              _this2.__loadedSettings = deepmerge(defaultSettings, settings);
              log$5('settings reloaded successfully.', _this2.__loadedSettings); // eslint-disable-next-line no-self-assign

              _this2.pageSettingsArray = _this2.pageSettingsArray;

              if (!_this2.__$xp.device.isLoan || settings.allowHardwareVolumeControl) {
                _this2.__$xp.media.setGlobalVolume(1);

                _this2.__$xp.media.setAllowUIVolumeControl(false);
              }

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  addPageSettings: function addPageSettings(pageId, pageSettings) {
    var _this3 = this;

    // @TODO xpedeo-core there could be a performance enhancement here.
    // could the array be mutated?
    log$5('addPageSettings', {
      pageId: pageId,
      pageSettings: pageSettings
    });
    var newPageSettingsArray = [];

    this.__$xp.history.historyArray.forEach(function (item, index) {
      if (item.pageId === pageId) {
        newPageSettingsArray[index] = pageSettings;
      } else {
        if (_this3.pageSettingsArray[index]) {
          newPageSettingsArray[index] = _this3.pageSettingsArray[index];
        }
      }
    });

    this.pageSettingsArray = newPageSettingsArray;
    log$5('addPageSettings success', this.pageSettingsArray);
  },
  install: function install(Vue, opts, $xp) {
    if ($xp.settingsInstalled) {
      return;
    }

    this.__$xp = $xp;
    $xp.settingsInstalled = true;
    this.__mergedSettings = Object.assign({}, defaultSettings);
    Vue.util.defineReactive($xp, 'settings', this);
  }
};

var preventSleep = function preventSleep() {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.preventSleep(function () {
        resolve();
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else resolve();
  });
};

var allowSleep = function allowSleep() {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.allowSleep(function () {
        resolve();
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else resolve();
  });
};

var setBrightness = function setBrightness(brightness) {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.setScreenBrightness(brightness ? [brightness] : [], function () {
        resolve();
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else resolve(brightness);
  });
};

var setOrientation = function setOrientation(orientation) {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.setScreenOrientation(orientation ? [orientation] : [], function () {
        resolve();
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else if (['ios', 'android'].includes(process.env.VUE_APP_PLATFORM)) {
      orientation ? window.screen.orientation.lock(orientation) : window.screen.orientation.unlock();
      resolve();
    }
  });
};

var getOrientation = function getOrientation() {
  return window.screen.orientation;
};

var screenFacade = {
  preventSleep: preventSleep,
  allowSleep: allowSleep,
  setBrightness: setBrightness,
  setOrientation: setOrientation,
  getOrientation: getOrientation
};

var listenOpts = {
  hasPassive: false,
  passiveCapture: true,
  notPassiveCapture: true
}; // feature detection for event listener options

try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      Object.assign(listenOpts, {
        hasPassive: true,
        passive: {
          passive: true
        },
        notPassive: {
          passive: false
        },
        passiveCapture: {
          passive: true,
          capture: true
        },
        notPassiveCapture: {
          passive: false,
          capture: true
        }
      });
    }
  });
  window.addEventListener('xptest', null, opts);
  window.removeEventListener('xptest', null, opts);
} catch (e) {}
function position(e) {
  if (e.touches && e.touches[0]) {
    e = e.touches[0];
  } else if (e.changedTouches && e.changedTouches[0]) {
    e = e.changedTouches[0];
  } else if (e.targetTouches && e.targetTouches[0]) {
    e = e.targetTouches[0];
  }

  return {
    top: e.clientY,
    left: e.clientX
  };
}

/**
 * Debouncing enforces that a function not be called again until a certain amount of time has passed without it being called.
 * see http://demo.nimius.net/debounce_throttle/
 *
 * @param {function} fn function to debounce
 * @param {integer} wait in milliseconds
 * @param {boolean} immediate whether to execute immediately
 */
function debounce (fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var immediate = arguments.length > 2 ? arguments[2] : undefined;
  var timeout;

  function
    /* ...args */
  debounced() {
    var _this = this;

    var args = arguments; // eslint-disable-line

    var later = function later() {
      timeout = null;

      if (!immediate) {
        fn.apply(_this, args);
      }
    };

    clearTimeout(timeout);

    if (immediate && !timeout) {
      fn.apply(this, args);
    }

    timeout = setTimeout(later, wait);
  }

  debounced.cancel = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

var passive = listenOpts.passive;
var log$6 = src('xpedeo-core:screen');
src.enable(process.env.VUE_APP_DEBUG);
var prefixes = {}; // needed for consistency across browsers,
// including IE11 which does not return anything

function promisify(target, fn) {
  try {
    var res = target[fn]();
    return res === undefined ? Promise.resolve() : res;
  } catch (err) {
    return Promise.reject(err);
  }
}

var dimTimeout = 0;
/**
 * This plugin require cordova-plugin-screen-orientation
 */

var Screen = {
  __brightness: null,
  __isDimPrevented: false,
  __isHalfDim: false,
  __isFullDim: false,
  __isIdle: false,
  __isFullscreenActive: false,
  __canFullscreen: false,
  __orientation: null,
  __isBrowserNavBarVisible: false,
  __$xp: null,
  __width: 0,
  __height: 0,
  __sleepTimeout: null,

  get isFullscreenActive() {
    return this.__isFullscreenActive;
  },

  get orientation() {
    return this.__orientation;
  },

  get isBrowserNavBarVisible() {
    return this.__isBrowserNavBarVisible;
  },

  get defaultBrightness() {
    return this.__$xp.settings.getValue('screen.brightness');
  },

  get halfDimMilliseconds() {
    return this.__$xp.settings.getValue('screen.halfDimMilliseconds');
  },

  get fullDimMilliseconds() {
    return this.__$xp.settings.getValue('screen.fullDimMilliseconds');
  },

  get halfDimValue() {
    return this.__$xp.settings.getValue('screen.halfDimValue');
  },

  get fullDimValue() {
    return this.__$xp.settings.getValue('screen.fullDimValue');
  },

  get isIdle() {
    return this.__isIdle;
  },

  get width() {
    return this.__width;
  },

  get height() {
    return this.__height;
  },

  setBrightness: function setBrightness(brightness) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              log$6("setBrightness(".concat(brightness, ")"));
              _context.prev = 1;
              _context.next = 4;
              return screenFacade.setBrightness(Number.isInteger(brightness) ? brightness : _this.defaultBrightness);

            case 4:
              _this.__brightness = _context.sent;
              log$6('setBrightness success');
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              log$6('setBrightness error', _context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }))();
  },
  preventDim: function preventDim() {
    log$6('preventDim()');
    clearTimeout(dimTimeout);
    this.__isDimPrevented = true;
  },
  allowDim: function allowDim() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              log$6('allowDim()');
              _this2.__isDimPrevented = false;
              _context2.next = 4;
              return _this2.postponeDim();

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  postponeDim: function postponeDim() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              log$6('postponeDim()');
              clearTimeout(dimTimeout);
              _context3.next = 4;
              return _this3.setBrightness();

            case 4:
              _this3.__isHalfDim = false;
              _this3.__isFullDim = false;
              _this3.__isIdle = false;

              if (!_this3.__isDimPrevented) {
                dimTimeout = setTimeout(function () {
                  _this3.setBrightness(_this3.halfDimValue);

                  _this3.__isHalfDim = true;
                  _this3.__isIdle = true;
                  clearTimeout(dimTimeout);
                  dimTimeout = setTimeout(function () {
                    _this3.setBrightness(_this3.fullDimValue);

                    _this3.__isHalfDim = false;
                    _this3.__isFullDim = true;
                  }, _this3.fullDimMilliseconds - _this3.halfDimMilliseconds);
                }, _this3.halfDimMilliseconds);
              }

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  cancelDimTimer: function cancelDimTimer() {
    log$6('cancelDimTimer()');
    clearTimeout(dimTimeout);
  },
  preventSleep: function preventSleep() {
    log$6('preventSleep()');
    screenFacade.preventSleep();

    if (this.__sleepTimeout !== null) {
      clearTimeout(this.__sleepTimeout);
      this.__sleepTimeout = null;
    }
  },
  allowSleep: function allowSleep() {
    log$6('allowSleep()');
    screenFacade.allowSleep();
  },
  setSleepTimeOut: function setSleepTimeOut(timeout) {
    var _this4 = this;

    if (this.__sleepTimeout !== null) {
      clearTimeout(this.__sleepTimeout);
    }

    log$6('setSleepTimeOut()');
    this.__sleepTimeout = setTimeout(function () {
      _this4.allowSleep();
    }, timeout);
  },
  setOrientation: function setOrientation(orientation) {
    log$6('setOrientation()');
    screenFacade.setOrientation(orientation);

    this.__$xp.navigation.showNav(true);
  },
  requestFullscreen: function requestFullscreen(target, evenOnNonMobile) {
    return !this.__$xp.navigation.isScreenReader && (evenOnNonMobile || this.__$xp.device.isTouchDevice) && this.__canFullscreen && !this.__isFullscreenActive ? promisify(target || document.documentElement, prefixes.request) : this.__getErr();
  },
  exitFullscreen: function exitFullscreen() {
    return this.__canFullscreen && this.__isFullscreenActive ? promisify(document, prefixes.exit) : this.__getErr();
  },
  toggleFullscreen: function toggleFullscreen(target, evenOnNonMobile) {
    return this.isFullscreenActive ? this.exitFullscreen() : this.requestFullscreen(target, evenOnNonMobile);
  },
  initFullscreen: function initFullscreen() {
    var _this5 = this;

    this.__getErr = function () {
      return Promise.resolve();
    };

    prefixes.request = ['requestFullscreen', 'msRequestFullscreen', 'mozRequestFullScreen', 'webkitRequestFullscreen'].find(function (request) {
      return document.documentElement[request];
    });
    this.__canFullscreen = prefixes.request !== undefined;

    if (this.__canFullscreen === false) {
      // it means the browser does NOT support it
      this.__getErr = function () {
        return Promise.reject(new Error('Not capable to request fullscreen'));
      };

      return;
    }

    this.__getErr = function () {
      return Promise.resolve();
    };

    prefixes.exit = ['exitFullscreen', 'msExitFullscreen', 'mozCancelFullScreen', 'webkitExitFullscreen'].find(function (exit) {
      return document[exit];
    });
    this.__isFullscreenActive = !!(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement);
    ['onfullscreenchange', 'onmsfullscreenchange', 'onwebkitfullscreenchange'].forEach(function (event) {
      document[event] = function () {
        _this5.__isFullscreenActive = !_this5.__isFullscreenActive;
      };
    });
  },
  initOrientation: function initOrientation() {
    var _this6 = this;

    if (this.__$xp.device.platform === 'ios' || this.__$xp.device.platform === 'browser' && this.__$xp.device.isIPhoneOrPad) {
      this.__orientation = this.getIosOrientation();
    } else if (window.screen.orientation) {
      this.__orientation = window.screen.orientation ? window.screen.orientation.type : 'undefined';
    }

    window.addEventListener('orientationchange', function () {
      if (_this6.__$xp.device.platform === 'ios' || _this6.__$xp.device.platform === 'browser' && _this6.__$xp.device.isIPhoneOrPad) {
        _this6.__orientation = _this6.getIosOrientation();
        var event = new Event('resize');
        var target = window.visualViewport !== undefined ? window.visualViewport : window;
        target.dispatchEvent(event);
      } else {
        _this6.__orientation = screen.orientation ? screen.orientation.type : 'undefined';

        if (_this6.__$xp.device.platform === 'android') {
          // should wait till rotate finishes before getting the orientation
          setTimeout(function () {
            _this6.__orientation = screen.orientation ? screen.orientation.type : 'undefined';
          }, 300);
        }
      }

      _this6.__$xp.navigation.showNav(true);
    }, true);
  },
  getIosOrientation: function getIosOrientation() {
    log$6('getIosOrientation()');
    log$6('window.orientation', window.orientation);
    log$6('window.screen.orientation', window.screen.orientation); // return window.screen.orientation.type

    if (window.orientation !== undefined) {
      switch (window.orientation) {
        case 0:
          return 'portrait-primary';

        case 180:
          return 'portrait-secondary';

        case -90:
          return 'landscape-primary';

        case 90:
          return 'landscape-secondary';
      }
    } else return 'undefined';
  },
  initResizeHandler: function initResizeHandler() {
    var _this7 = this;

    var target = window.visualViewport !== undefined ? window.visualViewport : window;

    var update = function update() {
      log$6('window resize update handler');

      if (window.innerHeight !== _this7.__height) {
        _this7.__height = window.innerHeight;
      }

      if (window.innerWidth !== _this7.__width) {
        _this7.__width = window.innerWidth;
      }

      log$6('orientation', _this7.getIosOrientation());
      var outerHeight = window.outerHeight;
      var windowHeight = window.innerHeight;
      log$6('outerHeight', outerHeight, windowHeight, _this7.__orientation);

      if (_this7.__orientation && _this7.__orientation.includes('portrait')) {
        _this7.__isBrowserNavBarVisible = false;
      }

      var shouldShowNav = windowHeight < outerHeight;

      if (shouldShowNav) {
        _this7.__$xp.navigation.showNav();
      }
    };

    var updateHandler = debounce(update, 500);
    target.addEventListener('resize', updateHandler, passive);
  },
  install: function install(Vue, opts, $xp) {
    if ($xp.screenInstalled) {
      return;
    }

    $xp.screenInstalled = true;
    this.__$xp = $xp;
    this.initFullscreen();
    this.initOrientation();
    this.initResizeHandler();
    Vue.util.defineReactive($xp, 'screen', this);
  }
};

var log$7 = src('xpedeo-core:network');
src.enable(process.env.VUE_APP_DEBUG);
var Network = {
  __isOnline: true,
  __onlineObservers: [],
  __offlineObservers: [],

  get isOnline() {
    return this.__isOnline;
  },

  subscribe: function subscribe(eventType, cb) {
    log$7("subscribe(".concat(eventType, ", ").concat(cb, ")"));

    if (eventType === 'online') {
      this.__onlineObservers.push(cb);
    } else if (eventType === 'offline') {
      this.__offlineObservers.push(cb);
    } else {
      throw new Error("xpedeo-core:network unknown event type ".concat(eventType));
    }
  },
  unsubscribe: function unsubscribe(eventType, cb) {
    log$7("unsubscribe(".concat(eventType, ", ").concat(cb, ")"));

    if (eventType === 'online') {
      this.__onlineObservers = this.__onlineObservers.filter(function (subscriber) {
        return subscriber !== cb;
      });
    } else if (eventType === 'offline') {
      this.__offlineObservers = this.__offlineObservers.filter(function (subscriber) {
        return subscriber !== cb;
      });
    } else {
      throw new Error("xpedeo-core:network unknown event type ".concat(eventType));
    }
  },
  notify: function notify(eventType) {
    log$7("notify(".concat(eventType, ")"));

    if (eventType === 'online') {
      this.__onlineObservers.forEach(function (observer) {
        return observer();
      });
    } else if (eventType === 'offline') {
      this.__offlineObservers.forEach(function (observer) {
        return observer();
      });
    } else {
      throw new Error("xpedeo-core:network unknown event type ".concat(eventType));
    }
  },
  startListening: function startListening() {
    log$7('startListening()');
    this.__isOnline = navigator.onLine;
    window.addEventListener('offline', this.onOffline.bind(this), false);
    window.addEventListener('online', this.onOnline.bind(this), false);
  },
  stopListening: function stopListening() {
    log$7('stopListening()');
    window.removeEventListener('offline', this.onOffline, false);
    window.removeEventListener('online', this.onOnline, false);
  },
  onOffline: function onOffline() {
    log$7('onOffline()');
    this.__isOnline = false;
    this.notify('offline');
  },
  onOnline: function onOnline() {
    log$7('onOnline()', this);
    this.__isOnline = true;
    this.notify('online');
  },
  waitForOnline: function waitForOnline() {
    var _this = this;

    var timeoutMilliseconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
    log$7("waitForOnline(".concat(timeoutMilliseconds, ")"));
    return new Promise(function (resolve, reject) {
      if (_this.__isOnline) {
        resolve();
      } else {
        var interval = null;
        var timeout = setTimeout(function () {
          clearInterval(interval);
          reject(new Error('wait for online timeout.'));
        }, timeoutMilliseconds);
        interval = setInterval(function () {
          if (_this.__isOnline) {
            clearTimeout(timeout);
            resolve();
          }
        }, 500);
      }
    });
  },
  recheckIsOnline: function recheckIsOnline() {
    log$7('recheckIsOnline()');

    if (navigator.onLine) {
      this.onOnline();
    } else {
      this.onOffline();
    }

    return this.__isOnline;
  },
  install: function install(Vue, opts, $xp) {
    if ($xp.networkInstalled) {
      return;
    }

    $xp.networkInstalled = true;
    Vue.util.defineReactive($xp, 'network', this);
  }
};

var log$8 = src('xpedeo-core:media');
src.enable(process.env.VUE_APP_DEBUG);
var Media = {
  __volume: 0.5,
  __allowUIVolumeControl: true,
  __isMediaPlaying: false,
  __showSubtitles: false,
  __isImageZoomDialogActive: false,

  get volume() {
    return this.__volume;
  },

  get allowUIVolumeControl() {
    return this.__allowUIVolumeControl;
  },

  get isMediaPlaying() {
    return this.__isMediaPlaying;
  },

  get showSubtitles() {
    return this.__showSubtitles;
  },

  get isImageZoomDialogActive() {
    return this.__isImageZoomDialogActive;
  },

  setGlobalVolume: function setGlobalVolume(value) {
    log$8("setGlobalVolume(".concat(value, ")"));
    this.__volume = value;
    window.localStorage.setItem('globalVolume', value);
  },
  setIsMediaPlaying: function setIsMediaPlaying(value) {
    log$8("setIsMediaPlaying(".concat(value, ")"));
    this.__isMediaPlaying = value;
  },
  setAllowUIVolumeControl: function setAllowUIVolumeControl(value) {
    log$8("setAllowUIVolumeControl(".concat(value, ")"));
    this.__allowUIVolumeControl = value;
  },
  setShowSubtitles: function setShowSubtitles(value) {
    log$8("setShowSubtitles(".concat(value, ")"));
    this.__showSubtitles = value;
  },
  setIsImageZoomDialogActive: function setIsImageZoomDialogActive(value) {
    log$8("setIsImageZoomDialogActive(".concat(value, ")"));
    this.__isImageZoomDialogActive = value;
  },
  install: function install(Vue, opts, $xp) {
    if ($xp.mediaInstalled) {
      return;
    }

    $xp.mediaInstalled = true;
    window.localStorage.setItem('globalVolume', this.__volume);
    Vue.util.defineReactive($xp, 'media', this);
  }
};

var log$9 = src('xpedeo-core:content');
src.enable(process.env.VUE_APP_DEBUG);
var Content = {
  __$xp: null,
  __pageData: {},
  __liked: false,
  __glRenderer: null,
  __showPreloadModal: false,
  __preloadPath: '',

  get preloadPath() {
    return this.__preloadPath;
  },

  set preloadPath(v) {
    this.__preloadPath = v;
  },

  get showPreloadModal() {
    return this.__showPreloadModal;
  },

  set showPreloadModal(v) {
    this.__showPreloadModal = v;
  },

  get pageData() {
    return this.__pageData;
  },

  get pageTitle() {
    return this.__pageData.Title;
  },

  get liked() {
    return this.__liked;
  },

  set liked(bLiked) {
    this.__liked = bLiked;
  },

  get glRenderer() {
    return this.__glRenderer;
  },

  set glRenderer(renderer) {
    this.__glRenderer = renderer;
  },

  get blockedBeaconsPageIds() {
    return this.__pageData.BlockedBeaconPageIDs;
  },

  get allowedBeaconsPageIds() {
    return this.__pageData.AllowedBeaconPageIDs;
  },

  setPageData: function setPageData(value) {
    this.__pageData = {};
    this.__pageData = value;
    this.__liked = this.__$xp.cart.isInCart(this.__pageData.ID);
  },
  getContentPreloaded: function getContentPreloaded() {
    var preloadState = window.localStorage.getItem('ContentPreloaded');

    if (preloadState === null) {
      return false;
    } else {
      if (preloadState === 'true') {
        return true;
      } else {
        return false;
      }
    }
  },
  setContentPreloaded: function setContentPreloaded(value) {
    if (value) {
      window.localStorage.setItem('ContentPreloaded', 'true');
    } else {
      window.localStorage.setItem('ContentPreloaded', 'false');
    }
  },
  install: function install(Vue, opts, $xp) {
    if ($xp.contentInstalled) {
      return;
    }

    this.__$xp = $xp;
    $xp.contentInstalled = true;
    Vue.util.defineReactive($xp, 'content', this);
  },

  /**
   * Liefert die benötigte Breite eines Vollbild-Bildes abhängig von den verfügbaren Größen auf dem Server
   * @param binaryJson Json-Datenstruktur des Binaries
   * @returns {number}
   */
  getRequiredImageWidth: function getRequiredImageWidth(binaryJson) {
    log$9('getRequiredImageWidth');
    var width = (window.innerWidth || document.documentElement.clientWidth) * window.devicePixelRatio;

    var _iterator = _createForOfIteratorHelper(this.__$xp.settings.mergedSettings.content.imageResolutions),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var w = _step.value;

        if (w >= width) {
          width = w;
          break;
        }
      } // console.log('getRequiredImageWidth() binaryJson:', binaryJson, ' ==', Math.min(binaryJson.Width, width))

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return Math.min(Number(binaryJson.Width), width);
  },

  /**
   * Liefert die URL zum Laden eines Bildes
   * @param binaryJson Json-Datenstruktur des Binaries
   * @param requiredImageWidth Gewünschte Breite; 0: Maximalgröße; null: anhand der Bildschirmbreite berechnen
   * @returns {string} URL des Bildes
   */
  getImageUrl: function getImageUrl(binaryJson, requiredImageWidth) {
    var url = this.__$xp.settings.baseUrl + 'xpedeo/' + binaryJson.Url;
    var shouldGetCustomWidth = !this.__$xp.device.isLoan && !((this.__$xp.device.platform === 'ios' || this.__$xp.device.platform === 'android') && window.XpedeoPreloader);

    if (shouldGetCustomWidth) {
      if (typeof requiredImageWidth === 'undefined') {
        requiredImageWidth = this.getRequiredImageWidth(binaryJson);
      }

      if (requiredImageWidth !== 0 && requiredImageWidth !== Number(binaryJson.Width)) {
        url = url.replace(/(\.[a-z]{3,4})$/, '.' + Math.round(requiredImageWidth) + '$1');
      }
    }

    return url;
  }
};

var timeout = createCommonjsModule(function (module, exports) {
  (function (exports) {
    var MAX_INT = 2147483647;
    var timeouts = {};
    var index = 1; // Set new timeout

    var set = function set(callback, timeout) {
      var id = index++;

      if (timeout > MAX_INT) {
        timeouts[id] = setTimeout(set.bind(undefined, callback, timeout - MAX_INT), MAX_INT);
      } else {
        if (timeout < 0) timeout = 0;
        timeouts[id] = setTimeout(function () {
          delete timeouts[id];
          callback();
        }, timeout);
      }

      return id;
    }; // Clear existing timeout


    var clear = function clear(id) {
      if (timeouts.hasOwnProperty(id)) {
        clearTimeout(timeouts[id]);
        delete timeouts[id];
      }
    }; // Expose public interface


    exports.set = set;
    exports.clear = clear;
    exports._timeouts = timeouts;
  })( exports);
});

var infiniteTimeout = timeout;

var backboneEventsStandalone = createCommonjsModule(function (module, exports) {
  /**
   * Standalone extraction of Backbone.Events, no external dependency required.
   * Degrades nicely when Backone/underscore are already available in the current
   * global context.
   *
   * Note that docs suggest to use underscore's `_.extend()` method to add Events
   * support to some given object. A `mixin()` method has been added to the Events
   * prototype to avoid using underscore for that sole purpose:
   *
   *     var myEventEmitter = BackboneEvents.mixin({});
   *
   * Or for a function constructor:
   *
   *     function MyConstructor(){}
   *     MyConstructor.prototype.foo = function(){}
   *     BackboneEvents.mixin(MyConstructor.prototype);
   *
   * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
   * (c) 2013 Nicolas Perriault
   */

  /* global exports:true, define, module */
  (function () {
    var nativeForEach = Array.prototype.forEach,
        hasOwnProperty = Object.prototype.hasOwnProperty,
        slice = Array.prototype.slice,
        idCounter = 0; // Returns a partial implementation matching the minimal API subset required
    // by Backbone.Events

    function miniscore() {
      return {
        keys: Object.keys || function (obj) {
          if (_typeof(obj) !== "object" && typeof obj !== "function" || obj === null) {
            throw new TypeError("keys() called on a non-object");
          }

          var key,
              keys = [];

          for (key in obj) {
            if (obj.hasOwnProperty(key)) {
              keys[keys.length] = key;
            }
          }

          return keys;
        },
        uniqueId: function uniqueId(prefix) {
          var id = ++idCounter + '';
          return prefix ? prefix + id : id;
        },
        has: function has(obj, key) {
          return hasOwnProperty.call(obj, key);
        },
        each: function each(obj, iterator, context) {
          if (obj == null) return;

          if (nativeForEach && obj.forEach === nativeForEach) {
            obj.forEach(iterator, context);
          } else if (obj.length === +obj.length) {
            for (var i = 0, l = obj.length; i < l; i++) {
              iterator.call(context, obj[i], i, obj);
            }
          } else {
            for (var key in obj) {
              if (this.has(obj, key)) {
                iterator.call(context, obj[key], key, obj);
              }
            }
          }
        },
        once: function once(func) {
          var ran = false,
              memo;
          return function () {
            if (ran) return memo;
            ran = true;
            memo = func.apply(this, arguments);
            func = null;
            return memo;
          };
        }
      };
    }

    var _ = miniscore(),
        Events; // Backbone.Events
    // ---------------
    // A module that can be mixed in to *any object* in order to provide it with
    // custom events. You may bind with `on` or remove with `off` callback
    // functions to an event; `trigger`-ing an event fires all callbacks in
    // succession.
    //
    //     var object = {};
    //     _.extend(object, Backbone.Events);
    //     object.on('expand', function(){ alert('expanded'); });
    //     object.trigger('expand');
    //


    Events = {
      // Bind an event to a `callback` function. Passing `"all"` will bind
      // the callback to all events fired.
      on: function on(name, callback, context) {
        if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
        this._events || (this._events = {});
        var events = this._events[name] || (this._events[name] = []);
        events.push({
          callback: callback,
          context: context,
          ctx: context || this
        });
        return this;
      },
      // Bind an event to only be triggered a single time. After the first time
      // the callback is invoked, it will be removed.
      once: function once(name, callback, context) {
        if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
        var self = this;

        var once = _.once(function () {
          self.off(name, once);
          callback.apply(this, arguments);
        });

        once._callback = callback;
        return this.on(name, once, context);
      },
      // Remove one or many callbacks. If `context` is null, removes all
      // callbacks with that function. If `callback` is null, removes all
      // callbacks for the event. If `name` is null, removes all bound
      // callbacks for all events.
      off: function off(name, callback, context) {
        var retain, ev, events, names, i, l, j, k;
        if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;

        if (!name && !callback && !context) {
          this._events = {};
          return this;
        }

        names = name ? [name] : _.keys(this._events);

        for (i = 0, l = names.length; i < l; i++) {
          name = names[i];

          if (events = this._events[name]) {
            this._events[name] = retain = [];

            if (callback || context) {
              for (j = 0, k = events.length; j < k; j++) {
                ev = events[j];

                if (callback && callback !== ev.callback && callback !== ev.callback._callback || context && context !== ev.context) {
                  retain.push(ev);
                }
              }
            }

            if (!retain.length) delete this._events[name];
          }
        }

        return this;
      },
      // Trigger one or many events, firing all bound callbacks. Callbacks are
      // passed the same arguments as `trigger` is, apart from the event name
      // (unless you're listening on `"all"`, which will cause your callback to
      // receive the true name of the event as the first argument).
      trigger: function trigger(name) {
        if (!this._events) return this;
        var args = slice.call(arguments, 1);
        if (!eventsApi(this, 'trigger', name, args)) return this;
        var events = this._events[name];
        var allEvents = this._events.all;
        if (events) triggerEvents(events, args);
        if (allEvents) triggerEvents(allEvents, arguments);
        return this;
      },
      // Tell this object to stop listening to either specific events ... or
      // to every object it's currently listening to.
      stopListening: function stopListening(obj, name, callback) {
        var listeners = this._listeners;
        if (!listeners) return this;
        var deleteListener = !name && !callback;
        if (_typeof(name) === 'object') callback = this;
        if (obj) (listeners = {})[obj._listenerId] = obj;

        for (var id in listeners) {
          listeners[id].off(name, callback, this);
          if (deleteListener) delete this._listeners[id];
        }

        return this;
      }
    }; // Regular expression used to split event strings.

    var eventSplitter = /\s+/; // Implement fancy features of the Events API such as multiple event
    // names `"change blur"` and jQuery-style event maps `{change: action}`
    // in terms of the existing API.

    var eventsApi = function eventsApi(obj, action, name, rest) {
      if (!name) return true; // Handle event maps.

      if (_typeof(name) === 'object') {
        for (var key in name) {
          obj[action].apply(obj, [key, name[key]].concat(rest));
        }

        return false;
      } // Handle space separated event names.


      if (eventSplitter.test(name)) {
        var names = name.split(eventSplitter);

        for (var i = 0, l = names.length; i < l; i++) {
          obj[action].apply(obj, [names[i]].concat(rest));
        }

        return false;
      }

      return true;
    }; // A difficult-to-believe, but optimized internal dispatch function for
    // triggering events. Tries to keep the usual cases speedy (most internal
    // Backbone events have 3 arguments).


    var triggerEvents = function triggerEvents(events, args) {
      var ev,
          i = -1,
          l = events.length,
          a1 = args[0],
          a2 = args[1],
          a3 = args[2];

      switch (args.length) {
        case 0:
          while (++i < l) {
            (ev = events[i]).callback.call(ev.ctx);
          }

          return;

        case 1:
          while (++i < l) {
            (ev = events[i]).callback.call(ev.ctx, a1);
          }

          return;

        case 2:
          while (++i < l) {
            (ev = events[i]).callback.call(ev.ctx, a1, a2);
          }

          return;

        case 3:
          while (++i < l) {
            (ev = events[i]).callback.call(ev.ctx, a1, a2, a3);
          }

          return;

        default:
          while (++i < l) {
            (ev = events[i]).callback.apply(ev.ctx, args);
          }

      }
    };

    var listenMethods = {
      listenTo: 'on',
      listenToOnce: 'once'
    }; // Inversion-of-control versions of `on` and `once`. Tell *this* object to
    // listen to an event in another object ... keeping track of what it's
    // listening to.

    _.each(listenMethods, function (implementation, method) {
      Events[method] = function (obj, name, callback) {
        var listeners = this._listeners || (this._listeners = {});

        var id = obj._listenerId || (obj._listenerId = _.uniqueId('l'));

        listeners[id] = obj;
        if (_typeof(name) === 'object') callback = this;
        obj[implementation](name, callback, this);
        return this;
      };
    }); // Aliases for backwards compatibility.


    Events.bind = Events.on;
    Events.unbind = Events.off; // Mixin utility

    Events.mixin = function (proto) {
      var exports = ['on', 'once', 'off', 'trigger', 'stopListening', 'listenTo', 'listenToOnce', 'bind', 'unbind'];

      _.each(exports, function (name) {
        proto[name] = this[name];
      }, this);

      return proto;
    }; // Export Events as BackboneEvents depending on current context


    {
      if ( module.exports) {
        exports = module.exports = Events;
      }

      exports.BackboneEvents = Events;
    }
  })();
});
var backboneEventsStandalone_1 = backboneEventsStandalone.BackboneEvents;

var backboneEventsStandalone$1 = backboneEventsStandalone;

/**
 * Find out if an object has a certain property
 *
 * @param {object} object
 * @param {string} key
 */

function has(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}
/**
 * Cache class
 */


function Cache() {
  this.initialize.apply(this, arguments);
}

var _ = Cache.prototype;
backboneEventsStandalone$1.mixin(_);
/**
 * Constructor
 *
 * @param {object} external Forward set, get, clear and del commands to an external handler (optional)
 */

_.initialize = function (external) {
  this.store = {};
  this.external = external;
};
/**
 * Insert or overwrite data
 *
 * @param {string} key
 * @param {mixed} value
 * @param {number} ttl   Time to live in milliseconds (optional)
 */


_.set = function (key, value, ttl) {
  if (typeof key === 'undefined') throw new Error('Required argument key is undefined'); // Clear timeout on existing record

  var oldRecord = has(this.store, key) ? this.store[key] : undefined;

  if (oldRecord && oldRecord.timeout) {
    infiniteTimeout.clear(oldRecord.timeout);
  } // Set value + timeout on new record


  var record = {
    value: value
  };

  if (typeof ttl === 'number') {
    record.timeout = infiniteTimeout.set(this.delInternal.bind(this, key), ttl);
  }

  this.store[key] = record; // Call external handler

  if (this.external && typeof this.external.set === 'function') {
    this.external.set(key, value, ttl);
  } // Emit update/set events


  var action = oldRecord ? 'update' : 'set';
  this.trigger(action, key, value, ttl);
  this.trigger(action + ':' + key, value, ttl);
};
/**
 * Get cached data
 *
 * @param {string} key
 * @param {function} callback  Return value in callback if records exists locally or on external resource (optional)
 * @return {mixed} value Only returned if callback is undefined
 */


_.get = function (key, callback) {
  if (typeof key === 'undefined') throw new Error('Required argument key is undefined');

  if (has(this.store, key)) {
    if (typeof callback === 'function') {
      process.nextTick(callback.bind(null, this.store[key].value));
    } else {
      return this.store[key].value;
    }
  } else if (typeof callback === 'function' && this.external && typeof this.external.get === 'function') {
    this.external.get(key, callback);
  }
};
/**
 * Delete cached data
 *
 * @param {string} key
 * @return {boolean} Returns true if record existed
 */


_.del = function (key) {
  if (typeof key === 'undefined') throw new Error('Required argument key is undefined');

  if (this.external && typeof this.external.del === 'function') {
    this.external.del(key);
  }

  return this.delInternal(key);
};

_.delInternal = function (key) {
  if (has(this.store, key)) {
    // Clear timeout
    if (this.store[key].timeout) {
      infiniteTimeout.clear(this.store[key].timeout);
    } // Delete record


    delete this.store[key]; // Emit del events

    this.trigger('del', key);
    this.trigger('del:' + key);
    return true;
  } else {
    return false;
  }
};
/**
 * Clear cached data
 *
 * @return {number} Returns number of cleared records
 */


_.clear = function () {
  var size = this.size();
  this.store = {};

  if (this.external && typeof this.external.clear === 'function') {
    this.external.clear();
  }

  this.trigger('clear', size);
  return size;
};
/**
 * Retrieve number of records
 *
 * @return {number}
 */


_.size = function () {
  var size = 0;

  for (var key in this.store) {
    if (has(this.store, key)) size++;
  }

  return size;
};
/**
 * Retrieve internal store
 *
 * @return {object}
 */


_.debug = function () {
  return this.store;
};
/**
 * Retrieve list of keys
 *
 * @return {string[]}
 */


_.keys = function () {
  return Object.keys(this.store);
};
/**
 * Export a combined instance and constructor
 */


var instance = new Cache();

var constructor = function constructor() {
  return new Cache(arguments[0]);
};

constructor.Cache = Cache;

for (var key in _) {
  if (has(_, key) && typeof _[key] === 'function') {
    constructor[key] = _[key].bind(instance);
  }
}

var cache = constructor;

var jsCache = cache;

var cacheMaxAge = 15 * 60 * 1000;
var log$a = src('xpedeo-core:http');
src.enable(process.env.VUE_APP_DEBUG || '');
var httpPlugin = {
  __$router: null,
  __$xp: null,
  __axiosInstance: null,
  __requests: [],
  __progressValue: 0,
  __lastFailedRoute: undefined,

  get isLoading() {
    return this.__requests.length > 0;
  },

  get isLoadingPageJson() {
    var loadingJsons = this.__requests.filter(function (request) {
      return request.key.includes('api/v1/pages/');
    });

    return loadingJsons.length > 0;
  },

  get progressValue() {
    return this.__progressValue;
  },

  __calculateProgressValue: function __calculateProgressValue() {
    if (this.__requests.length === 0) {
      this.__progressValue = 0;
      return;
    }

    var sum = 0;

    this.__requests.forEach(function (request) {
      sum += request.progress;
    });

    this.__progressValue = sum / this.__requests.length;
  },
  __setProgress: function __setProgress(key, value) {
    if (value === 100) {
      this.__requests = this.__requests.filter(function (request) {
        return request.key !== key;
      });
    } else {
      this.__requests = this.__requests.map(function (request) {
        return {
          key: request.key,
          progress: request.key === key ? value : request.progress,
          cancelToken: request.cancelToken
        };
      });
    }

    this.__calculateProgressValue();
  },
  retryLastFailedRoute: function retryLastFailedRoute() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.__lastFailedRoute) {
                _context.next = 2;
                break;
              }

              throw new Error('There is no failed route to retry');

            case 2:
              return _context.abrupt("return", _this.loadPage(_this.__lastFailedRoute));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  loadPage: function loadPage(to) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      var pageId, pageData, skipThisRoute, entriesList, msg;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this2.__$xp) {
                _context2.next = 2;
                break;
              }

              throw new Error('Cannot load page before installing content plugin');

            case 2:
              // THIS IS IMPORTANT to avoid render the same section in the new page (this can happen loading the new page takes a while)
              // this.__$xp.content.setPageData({})
              _this2.__$xp.polyglot.urlPath = to.params.lang + '/';
              pageId = parseInt(to.params.id);
              _context2.next = 6;
              return _this2.getPageData(pageId);

            case 6:
              pageData = _context2.sent;

              if (!(pageData.Class === 'XpHome')) {
                _context2.next = 14;
                break;
              }

              log$a('in http page is home page');

              _this2.setHomePage(pageData, to);

              skipThisRoute = {
                ID: 0,
                Title: 'SkipPage',
                Class: 'XpHomePage',
                IsFullScreen: false,
                Sections: []
              };
              return _context2.abrupt("return", skipThisRoute);

            case 14:
              if (pageData.Class === 'XpError') {
                _this2.__lastFailedRoute = to;

                _this2.__$xp.content.setPageData(pageData);
              } else {
                _this2.__lastFailedRoute = undefined;
                _this2.__$xp.navigation.isFullScreen = pageData.IsFullScreen;
                _this2.__$xp.navigation.isAudioSynced = !!pageData.Audio && !!pageData.Audio.Url && pageData.Audio.Url.length > 0;
                entriesList = [];
                pageData.Sections.forEach(function (section) {
                  entriesList = entriesList.concat(section.entries.map(function (entry) {
                    return 'entry-' + entry.ID;
                  }));
                });

                _this2.__$xp.navigation.initEntriesIdList(entriesList);

                document.title = pageData.Title;

                if (_this2.__$xp.device.platform === 'browser' && window.parent && window.self !== window.top) {
                  msg = {
                    name: 'pageLoaded',
                    data: {
                      pageID: pageData.ID,
                      pageClass: pageData.Class,
                      langCode: _this2.__$xp.polyglot.locale
                    }
                  };
                  window.parent.postMessage(msg, '*');
                }
                /**
                 * @TODO test again after releasing this pull request
                 * https://github.com/vuejs/vue-router/pull/1906
                 * this is needed to check the replace property
                 * for now it is always false
                 */


                if (to.replace || to.query.replace) {
                  log$a('in http replace in history for page', pageData);

                  _this2.__$xp.history.replace(parseInt(to.params.id), to.path); //, pageData.ParentID)

                } else {
                  if (pageData.Class === 'XpNfc' && to.query.nfcCode) {
                    log$a('nfc redirect, not saving to history');
                  } else {
                    if (pageData.Class === 'XpSplashScreen') {
                      _this2.__$xp.history.push(parseInt(to.params.id), to.path, true, pageData.Title);
                    } else {
                      log$a('in http push in history for page', pageData);

                      _this2.__$xp.history.push(parseInt(to.params.id), to.path, false, undefined);
                    }
                  }
                }

                _this2.__$xp.settings.addPageSettings(pageData.ID, Object.assign({}, pageData.Settings));

                _this2.__$xp.content.setPageData(pageData);
              }

            case 15:
              log$a('loaded pagedata', pageData);
              return _context2.abrupt("return", pageData);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  getPageData: function getPageData(id) {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      var baseUrl, useStaticPageFiles, url, cancelToken, response;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!_this3.__$xp || !_this3.__axiosInstance)) {
                _context3.next = 2;
                break;
              }

              throw new Error('cannot get page without installing http plugin page');

            case 2:
              baseUrl = _this3.__$xp.settings.baseUrl;
              useStaticPageFiles = _this3.__$xp.settings.useStaticPageFiles;
              url = '';

              if (useStaticPageFiles) {
                url = "".concat(baseUrl, "xpedeo/").concat(_this3.__$xp.polyglot.apiLangPath, "P").concat(id, ".json");
              } else {
                url = "".concat(baseUrl, "xpedeo/").concat(_this3.__$xp.polyglot.apiLangPath, "api/v1/pages/").concat(id, "?expand=children");
              }

              if (_this3.__$xp.device.platform === 'ios') {
                if (window.XpedeoPreloader) {
                  url = window.XpedeoPreloader.convertProxyUrl(url);
                }
              }

              _this3.cancelRequestsQueue();

              cancelToken = axios.CancelToken.source();

              _this3.__requests.push({
                key: url,
                progress: 0,
                cancelToken: cancelToken
              });

              _context3.prev = 10;
              _context3.next = 13;
              return _this3.__axiosInstance.get(url, {
                cancelToken: cancelToken.token,
                onDownloadProgress: function onDownloadProgress(e) {
                  return _this3.__setProgress(url, e.total ? Math.round(e.loaded / e.total * 100) : 100);
                }
              });

            case 13:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 17:
              _context3.prev = 17;
              _context3.t0 = _context3["catch"](10);

              _this3.__setProgress(url, 100);

              return _context3.abrupt("return", {
                Title: 'Error',
                Class: 'XpError',
                Error: _context3.t0,
                // these properties are to avoid js errors while rendering the page
                ID: -1,
                Sections: []
              });

            case 21:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[10, 17]]);
    }))();
  },
  getFileUrl: function getFileUrl(url, type) {
    var _arguments = arguments,
        _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      var addToProgress, dataUri, cancelToken, response, arrayBufferView, blob, imageUrl;
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              addToProgress = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : true;

              if (_this4.__axiosInstance) {
                _context4.next = 3;
                break;
              }

              throw new Error('cannot get image uri without installing http plugin page');

            case 3:
              if (_this4.__$xp && _this4.__$xp.device.platform === 'ios') {
                if (window.XpedeoPreloader) {
                  url = window.XpedeoPreloader.convertProxyUrl(url);
                }
              }

              dataUri = jsCache.get(url);

              if (!dataUri) {
                _context4.next = 7;
                break;
              }

              return _context4.abrupt("return", jsCache.get(url));

            case 7:
              cancelToken = axios.CancelToken.source();
              addToProgress && _this4.__requests.push({
                key: url,
                progress: 0,
                cancelToken: cancelToken
              });
              _context4.prev = 9;

              if (_this4.__$xp && _this4.__$xp.device.platform === 'ios') {
                if (window.XpedeoPreloader) {
                  url = window.XpedeoPreloader.convertProxyUrl(url);
                }
              }

              _context4.next = 13;
              return _this4.__axiosInstance.get(url, _objectSpread2({
                cancelToken: cancelToken.token,
                responseType: 'arraybuffer'
              }, addToProgress ? {
                onDownloadProgress: function onDownloadProgress(e) {
                  return _this4.__setProgress(url, e.total ? Math.round(e.loaded / e.total * 100) : 100);
                }
              } : {}));

            case 13:
              response = _context4.sent;
              arrayBufferView = new Uint8Array(response.data);
              blob = new Blob([arrayBufferView], {
                type: type
              });
              imageUrl = URL.createObjectURL(blob);
              jsCache.set(url, imageUrl, cacheMaxAge);
              return _context4.abrupt("return", imageUrl);

            case 21:
              _context4.prev = 21;
              _context4.t0 = _context4["catch"](9);

              _this4.__setProgress(url, 100);

              throw _context4.t0;

            case 25:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[9, 21]]);
    }))();
  },
  cancelRequest: function cancelRequest(key) {
    var request = this.__requests.find(function (request) {
      return request.key === key;
    });

    if (request) {
      request.cancelToken.cancel();
    } else {
      log$a('cannot find request to cancel it');
    }
  },
  cancelRequestsQueue: function cancelRequestsQueue() {
    log$a('cancel requests queue');

    this.__requests.forEach(function (request) {
      request.cancelToken.cancel();
    });
  },
  setHomePage: function setHomePage(pageData, to) {
    var _this5 = this;

    log$a('In SetHome Page http'); // log('in setHomePage this.$route.params.id', this.$route.params.id)

    if (this.__$xp === null) {
      return;
    }

    if (pageData.NfcPageId) {
      log$a('in pageMixin, Homepage, set NfcPageID=', pageData.NfcPageId);
      window.localStorage.setItem('nfcPageId', pageData.NfcPageId);
    }

    this.__$xp.history.addHomePage(pageData.ID, "/page/".concat(pageData.ID), pageData.Title, pageData.Homepage ? pageData.Homepage.ParentID : 0, pageData.Homepage && pageData.Homepage.AncestorIDs ? pageData.Homepage.AncestorIDs : []);

    var childrenPageData = JSON.parse(JSON.stringify(pageData.children)); // if (childrenPageData.length > 0) {
    //   // show nav only when tab items > 0
    //   this.__$xp.navigation.preventAutoHide()
    //   this.__$xp.navigation.showNav()
    // } else if (childrenPageData.length === 1 && childrenPageData[0].Class === 'XpSplashScreen') {
    //   // hide navigation (splash screen is used for example)
    //   this.__$xp.navigation.preventAutoHide()
    //   this.__$xp.navigation.hideNav()
    // }
    // this.__$xp.navigation.setTabs(this.childrenPageData)

    if (childrenPageData.length > 1 && to.query.activeTabId) {
      this.__$xp.navigation.setActiveTabId(parseInt(to.query.activeTabId));
    } else if (this.__$xp.history.historyParams && this.__$xp.history.historyParams["homeActiveTab".concat(to.params.id)]) {
      this.__$xp.navigation.setActiveTabId(parseInt(this.__$xp.history.historyParams["homeActiveTab".concat(to.params.id)]));
    } else if (childrenPageData.length && !this.__$xp.navigation.activeTab) {
      this.__$xp.navigation.setActiveTabId(childrenPageData[0].ID);
    }

    log$a("XpHomePage redirecting to /page/".concat(this.__$xp.navigation.activeTabId));
    var tabClass = '';
    childrenPageData.every(function (element) {
      if (_this5.__$xp && element.ID === _this5.__$xp.navigation.activeTabId) {
        tabClass = _this5.getPageClass(element.Class);
        return false;
      }

      return true;
    });
    log$a("XpHomePage in DynamicPage redirecting to ".concat(tabClass)); // this.__$xp.history.replace(this.__$xp.navigation.activeTabId, `/page/${this.__$xp.navigation.activeTabId}`)

    this.__$xp.history.push(this.__$xp.navigation.activeTabId, "/page/".concat(this.__$xp.navigation.activeTabId), false, undefined);

    this.__$router.replace("/page/".concat(this.__$xp.navigation.activeTabId));

    log$a('in https page returning value', tabClass);
    return tabClass;
  },
  getPageClass: function getPageClass(pageClass) {
    switch (pageClass) {
      case 'XpSplashScreen':
        return 'XpSplashScreenPage';

      case 'XpSelectLanguage':
        return 'XpSelectLanguagePage';

      case 'XpHome':
        return 'XpHomePage';

      case 'XpMenu':
        return 'XpMenuPage';

      case 'XpMap':
        return 'XpMapPage';

      case 'XpMultipleChoice':
        return 'XpMultipleChoicePage';

      case 'XpNfc':
        return 'XpNfcPage';

      case 'XpNumericInput':
        return 'XpNumericInputPage';

      case 'XpError':
        return 'XpErrorPage';

      case 'XpFlipbook':
        return 'XpFlipbookPage';

      case 'XpClientSettings':
        return 'XpClientSettingsPage';

      default:
        return 'XpPage';
    }
  },
  install: function install(Vue, opts, $xp) {
    log$a('installing http plugin');

    if ($xp.httpInstalled) {
      return;
    }

    $xp.httpInstalled = true;
    this.__$xp = $xp;
    this.__$router = opts.router;
    this.__axiosInstance = axios.create({
      headers: {
        'Cache-Control': 'no-cache'
      } // adapter: cache.adapter\

    });
    Vue.util.defineReactive($xp, 'http', this);
  }
};

var log$b = src('xpedeo-core:clientsettings');
src.enable(process.env.VUE_APP_DEBUG);
var ClientSettings = {
  __available: ['fontsize', 'outlines'],
  __fontsizes: [100, 150, 200],
  __$xp: null,

  get available() {
    return this.__available;
  },

  get fontsizes() {
    return this.__fontsizes;
  },

  saveClientSetting: function saveClientSetting(name, value) {
    log$b('Saving ClientSetting', name, value);
    window.localStorage.setItem('clientsettings-' + name, value);
  },
  getClientSetting: function getClientSetting(name) {
    log$b('Get ClientSetting', name);
    return window.localStorage.getItem('clientsettings-' + name);
  },
  removeClientSetting: function removeClientSetting(name) {
    log$b('Remove ClientSetting', name);
    return window.localStorage.removeItem('clientsettings-' + name);
  },
  applyClientSettings: function applyClientSettings(aSelected) {
    log$b('Apply ClientSettings', aSelected);

    var _iterator = _createForOfIteratorHelper(this.available),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var cSetting = _step.value;

        if ((!aSelected || aSelected.some(cSetting)) && cSetting === 'fontsize') {
          if (this.getClientSetting('fontsize')) {
            var _iterator2 = _createForOfIteratorHelper(this.fontsizes),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var cSize = _step2.value;
                document.querySelector('html').classList.remove('fontsize' + cSize);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            document.querySelector('html').classList.add('fontsize' + this.getClientSetting('fontsize'));
          }
        }

        if ((!aSelected || aSelected.some(cSetting)) && cSetting === 'outlines') {
          if (this.getClientSetting('outlines')) {
            document.querySelector('html').classList.add('outlines');
          } else {
            document.querySelector('html').classList.remove('outlines');
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  initEvents: function initEvents() {
    var _this = this;

    window.addEventListener('keyup', function (e) {
      console.log('ClientSettings KEY CHECK', e);
      var nKey = e.key;

      switch (nKey) {
        case 'Tab':
          if (!parseInt(_this.__$xp.clientsettings.getClientSetting('outlines'))) {
            console.log('Enabling OUTLINES');

            _this.__$xp.clientsettings.saveClientSetting('outlines', 1);

            _this.__$xp.clientsettings.applyClientSettings();
          }

          break;
      }
    });
  },
  install: function install(Vue, opts, $xp) {
    if ($xp.clientsettingsInstalled) {
      return;
    }

    $xp.clientsettingsInstalled = true;
    this.__$xp = $xp;
    this.initEvents();
    Vue.util.defineReactive($xp, 'clientsettings', this);
  }
};

var localPageData = {
  props: {
    localPageData: {
      type: Object,
      required: false
    }
  },
  computed: {
    pageData: function pageData() {
      return this.localPageData || this.$xp.content.pageData;
    }
  }
};

var log$c = src('xpedeo-core:PageMixin');
src.enable(process.env.VUE_APP_DEBUG);
var page = {
  mixins: [localPageData],
  computed: {
    pageData: function pageData() {
      return this.localPageData || this.$xp.content.pageData;
    }
  },
  created: function created() {
    // console.log(this.$xp.history.__historyArray)
    log$c('pageMixin created', this.pageData, this.pageData.Homepage); // eslint-disable-next-line no-prototype-builtins

    if (!this.hasOwnProperty('isFirstFocus')) this.isFirstFocus = true;
    this.$xp.history.nextPageId = this.$xp.content.pageData.NextPageID;
    /**
     * this condition is important to avoid tabs flickering
     * - on router change pageData will be set to {} till loading the new page or error happen
     * - ignore XpHome tabs, only children tabs are important
     */
    // if (this.pageData !== {} && this.pageData.Class !== 'XpHome') {

    if (this.pageData.Homepage) {
      if (this.pageData.NfcPageId) {
        log$c('in pageMixin, Homepage, set NfcPageID=', this.pageData.NfcPageId);
        window.localStorage.setItem('nfcPageId', this.pageData.NfcPageId);
      } // console.log('in pagejs addHomePage', `/page/${this.$route.params.id}`, this.pageData.Title, this.pageData.Homepage.ParentID, this.pageData)
      // this.$xp.history.addHomePage(this.pageData.Homepage.ID, `/page/${this.$route.params.id}`, this.pageData.Title, this.pageData.Homepage.ParentID)


      this.$xp.navigation.setTabs(this.pageData.Homepage.Tabs);
      this.$xp.navigation.setActiveTabId(this.pageData.ID);
    } else {
      this.$xp.navigation.resetTabs();
    } // }
    // Set language and thereby rtl


    if (this.pageData.Language && this.pageData.Language.Code && this.pageData.Language.Code !== this.$xp.polyglot.locale) {
      this.$xp.polyglot.setLanguage(this.pageData.Language.Code, this.pageData.Language.Path);
    }

    if (this.pageData.children && this.pageData.children.length && this.pageData.Class !== 'XpMenu') {
      this.$xp.navigation.setChildPagesMenuItems(this.pageData.children.map(function (item) {
        return {
          id: item.ID,
          title: item.Title,
          class: item.Class,
          icon: item.Icon
        };
      }));
    } else {
      this.$xp.navigation.resetChildPagesMenuItems();
    }
  },
  methods: {
    setScrollFromHistory: function setScrollFromHistory() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var key, scrollableElement, lastScrollTop;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                key = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : undefined;

                // get last scroll value from history array and set it
                if (!key) {
                  key = 'lastScrollTop';
                }

                scrollableElement = document.querySelector('div.js-page-content');
                lastScrollTop = NaN;

                if (_this.$xp.history.historyParams && _this.$xp.history.historyParams[key]) {
                  lastScrollTop = _this.$xp.history.historyParams[key];
                }

                if (scrollableElement && !isNaN(lastScrollTop)) {
                  log$c('set scroll from history: ' + lastScrollTop);
                  scrollableElement.scrollTop = lastScrollTop; // set again for delayed render

                  setTimeout(function () {
                    scrollableElement.scrollTop = lastScrollTop;
                  }, 0);
                } else {
                  log$c('set scroll to 0');
                  scrollableElement.scrollTop = 0;
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    setFocusFromHistory: function setFocusFromHistory() {
      var _this2 = this;

      /**
       * todo: check if screen reader is active and set focus accordingly ( for screenreader only on pagetitle )
       * ask ralph about the current implementation
       */
      if (!this.firstFocus) {
        setTimeout(function () {
          var element = null; // eslint-disable-next-line dot-notation

          var selector = null; // eslint-disable-next-line dot-notation

          if (_this2.$xp.history.historyParams && _this2.$xp.history.historyParams['focus']) {
            // eslint-disable-next-line dot-notation
            selector = _this2.$xp.history.historyParams['focus'];
          }

          if (selector) element = document.querySelector(selector);
          if (!element) element = document.querySelector('#pageTitle');
          console.log('setFocusFromHistory() "', selector, '", element:', element);

          if (element) {
            element.focus();
          } else {
            var pageTitle = document.querySelector('#pageTitle');
            pageTitle.focus();
          }
        }, 100);
      } else {
        this.firstFocus = false;
      }
    },
    setChildPagesHiddenFromHistory: function setChildPagesHiddenFromHistory() {
      // get last child pages value from history array and set it
      if (this.$xp.navigation.childPagesMenuItems.length) {
        var lastChildPagesState = this.$xp.history.historyParams.lastChildPagesState;

        if (lastChildPagesState !== undefined && lastChildPagesState !== this.$xp.navigation.isChildPagesMenuHidden) {
          this.$xp.navigation.toggleChildPagesMenu();
        }
      }
    }
  },
  mounted: function mounted() {
    console.log('pageMixin mounted', this.pageData, this.pageData.Homepage);
    this.$xp.clientsettings.applyClientSettings();
    this.setScrollFromHistory();
    this.setChildPagesHiddenFromHistory();
    this.setFocusFromHistory();
  },
  watch: {
    '$xp.navigation.currentEntry': {
      handler: function handler(newVal) {
        if (!this.$xp.navigation.isFullScreen && this.$xp.navigation.isAudioSynced) {
          this.$scrollTo('#' + newVal);
        }
      }
    }
  }
};

var XpErrorPage = Vue.extend({
  name: 'XpErrorPage',
  mixins: [page],
  computed: {
    errorMessage: function errorMessage() {
      if (!this.$xp.network.isOnline) {
        return this.$t('global.errorOffline');
      }

      if (this.pageData.Error) {
        if (this.pageData.Error.response) {
          switch (this.pageData.Error.response.status) {
            case 404:
              return this.$t('global.error404');

            case 500:
              return this.$t('global.error500');
          }

          if (process.env.NODE_ENV === 'development' && this.pageData.Error.response && this.pageData.Error.response.data && this.pageData.Error.response.data.message) {
            return this.pageData.Error.response.data.message;
          }
        }

        if (process.env.NODE_ENV === 'development') return this.pageData.Error.message;
      }

      return this.$t('global.errorUnknown');
    }
  },
  mounted: function mounted() {
    document.title = this.$t('global.error');
  },
  watch: {
    '$xp.network.isOnline': {
      handler: function handler(newValue) {
        if (newValue) {
          this.$xp.http.retryLastFailedRoute();
        }
      }
    }
  },
  render: function render(h) {
    return h('div', {
      class: 'c-error-page'
    }, [h('span', {
      staticClass: 'xp xp--huge',
      class: {
        'xp-no-wlan': !this.$xp.network.isOnline,
        'xp-connection-error': this.$xp.network.isOnline
      }
    }), h('p', {}, this.errorMessage)]);
  }
});

var dateString = function dateString(isoDateString) {
  var date = new Date(isoDateString);
  return "".concat(date.getDate().toString().padStart(2, '0'), "-").concat((date.getMonth() + 1).toString().padStart(2, '0'), "-").concat(date.getFullYear());
};
var timeString = function timeString(isoDateString) {
  var date = new Date(isoDateString);
  return "".concat(date.getHours().toString().padStart(2, '0'), ":").concat(date.getMinutes().toString().padStart(2, '0'));
};
var formatPlayTime = function formatPlayTime(time) {
  if (time > 0) {
    var minutes = Math.floor(time / 60);
    var seconds = (time % 60).toFixed(0).padStart(2, '0');
    return minutes + ':' + seconds;
  }

  if (time < 0) {
    time *= -1;

    var _minutes = Math.floor(time / 60);

    var _seconds = (time % 60).toFixed(0).padStart(2, '0');

    return '-' + _minutes + ':' + _seconds;
  }

  return '0:00';
};

var log$d = src('xpedeo-core:install');
src.enable(process.env.VUE_APP_DEBUG);
var version = '__VERSION__';
var $xp = {
  version: version
};
var coreComponents = {
  'preload-modal': function preloadModal() {
    return import('./XpPreloadModal.js');
  },
  'audio-player': function audioPlayer() {
    return import('./AudioPlayer.js');
  },
  NetworkErrorScreen: function NetworkErrorScreen() {
    return import('./NetworkErrorScreen.js');
  },
  NumpadInput: function NumpadInput() {
    return import('./NumpadInput.js');
  },
  Panorama: function Panorama() {
    return import('./Panorama.js');
  },
  PanzoomMap: function PanzoomMap() {
    return import('./PanzoomMap.js');
  },
  XpSection: function XpSection() {
    return import('./Section.js');
  },
  Slider: function Slider() {
    return import('./Slider.js');
  },
  VideoPlayer: function VideoPlayer() {
    return import('./VideoPlayer.js');
  },
  ArEntry: function ArEntry() {
    return import('./ArEntry.js');
  },
  ContactEntry: function ContactEntry() {
    return import('./ContactEntry.js');
  },
  EntityEntry: function EntityEntry() {
    return import('./EntityEntry.js');
  },
  HtmlEntry: function HtmlEntry() {
    return import('./HtmlEntry.js');
  },
  ImageEntry: function ImageEntry() {
    return import('./ImageEntry.js');
  },
  MenuEntry: function MenuEntry() {
    return import('./MenuEntry.js');
  },
  PanoramaEntry: function PanoramaEntry() {
    return import('./PanoramaEntry.js');
  },
  TextEntry: function TextEntry() {
    return import('./TextEntry.js');
  },
  VideoEntry: function VideoEntry() {
    return import('./VideoEntry.js');
  },
  EventEntity: function EventEntity() {
    return import('./EventEntity.js');
  },
  NewsEntity: function NewsEntity() {
    return import('./NewsEntity.js');
  },
  ThreeDeeModelEntry: function ThreeDeeModelEntry() {
    return import('./ThreeDeeModelEntry.js');
  },
  XpMapPage: function XpMapPage() {
    return import('./XpMapPage.js');
  },
  XpMenuPage: function XpMenuPage() {
    return import('./XpMenuPage.js');
  },
  XpMultipleChoicePage: function XpMultipleChoicePage() {
    return import('./XpMultipleChoicePage.js');
  },
  XpClientSettingsPage: function XpClientSettingsPage() {
    return import('./XpClientSettingsPage.js');
  },
  XpNfcPage: function XpNfcPage() {
    return import('./XpNfcPage.js');
  },
  XpNumericInputPage: function XpNumericInputPage() {
    return import('./XpNumericInputPage.js');
  },
  XpPage: function XpPage() {
    return import('./XpPage.js');
  },
  XpSelectLanguagePage: function XpSelectLanguagePage() {
    return import('./XpSelectLanguagePage.js');
  },
  XpSplashScreenPage: function XpSplashScreenPage() {
    return import('./XpSplashScreenPage.js');
  },
  Dock: function Dock() {
    return import('./Dock.js');
  },
  Splash: function Splash() {
    return import('./Splash.js');
  },
  PageContainer: function PageContainer() {
    return import('./PageContainer.js');
  },
  DynamicPage: function DynamicPage() {
    return import('./DynamicPage.js');
  },
  DynamicEntry: function DynamicEntry() {
    return import('./DynamicEntry.js');
  },
  XpHomePage: function XpHomePage() {
    return import('./XpHomePage.js');
  },
  // XpPreloadPage: () => import('./components/pages/XpPreloadPage.vue'),
  XpErrorPage: XpErrorPage,
  XpFlipbookPage: function XpFlipbookPage() {
    return import('./XpFlipbookPage.js');
  },
  App: function App() {
    return import('./App.js');
  }
};
function install (Vue, opts) {
  if (!opts.router) {
    throw new Error('Core plugin needs router to initialize');
  }

  if (this.__installed) {
    return;
  }

  this.__installed = true;
  var cfg = opts.config || {}; // required plugins

  Cart.install(Vue, opts, $xp, cfg);
  History.install(Vue, opts, $xp, cfg);
  Polyglot.install(Vue, opts, $xp, cfg);
  Device.install(Vue, opts, $xp, cfg);
  Navigation.install(Vue, opts, $xp, cfg);
  Battery.install(Vue, opts, $xp, cfg);
  Wifi.install(Vue, opts, $xp, cfg);
  Media.install(Vue, opts, $xp, cfg);
  Settings.install(Vue, opts, $xp, cfg);
  Screen.install(Vue, opts, $xp, cfg);
  Network.install(Vue, opts, $xp, cfg);
  httpPlugin.install(Vue, opts, $xp, cfg);
  Content.install(Vue, opts, $xp, cfg);
  ClientSettings.install(Vue, opts, $xp, cfg); // if (cfg.enableEva) {
  //   Eva.install(Vue, opts, $xp, cfg)
  // }

  if (opts.plugins) {
    log$d('installing plugins');

    var _loop = function _loop(plugin) {
      switch (plugin) {
        case 'nfc':
          log$d('install NFC');
          Promise.resolve().then(function () { return nfc$1; }).then(function (Nfc) {
            Nfc.default.install(Vue, opts, $xp, opts.plugins[plugin]);
          });
          break;

        case 'eva':
          import('./eva.js').then(function (Eva) {
            Eva.default.install(Vue, opts, $xp, opts.plugins[plugin]);
          });
          break;

        case 'positioning':
          import('./positioning.js').then(function (Positioning) {
            Positioning.default.install(Vue, opts, $xp, opts.plugins[plugin]);
          });
          break;

        case 'tracking':
          import('./tracker.js').then(function (Tracking) {
            Tracking.default.install(Vue, opts, $xp, opts.plugins[plugin]);
          });
          break;

        default:
          throw new Error("Unknown xpedeo plugin \"".concat(plugin, "\""));
      }
    };

    for (var plugin in opts.plugins) {
      _loop(plugin);
    }
  }

  Vue.prototype.$xp = $xp;
  Vue.filter('dateString', dateString);
  Vue.filter('timeString', timeString);
  Vue.filter('formatPlayTime', formatPlayTime);
  var components = Object.assign({}, coreComponents, opts.components || {});

  for (var key in components) {
    Vue.component(key, components[key]);
  } // opts.components && Object.keys(opts.components).forEach(key => {
  //   const c = opts.components[key]
  //   if (typeof c === 'function') {
  //     Vue.component(c.options.name, c)
  //   }
  // })

}

var version$1 = '__VERSION__';
var plugin = {
  version: version$1,
  install: install
};

var log$e = src('xpedeo-core:nfc');
src.enable(process.env.VUE_APP_DEBUG);
var nfc = {
  __isEnabled: false,
  __$xp: null,
  __router: null,
  __isListenersAdded: false,
  __branches: [],
  __nfcCode: null,
  __selectedLangCode: null,
  __nfcCodeFound: false,
  __selectedBranchIds: [],
  __lastNfcRoute: null,
  __nfcData: null,

  get nfcData() {
    return this.__nfcData;
  },

  set nfcData(newValue) {
    this.__nfcData = newValue;
  },

  get lastNfcRoute() {
    return this.__lastNfcRoute;
  },

  set lastNfcRoute(newValue) {
    this.__lastNfcRoute = newValue;
  },

  get selectedBranchIds() {
    return this.__selectedBranchIds;
  },

  set selectedBranchIds(newValue) {
    this.__selectedBranchIds = newValue;
  },

  get nfcCodeFound() {
    return this.__nfcCodeFound;
  },

  set nfcCodeFound(newValue) {
    this.__nfcCodeFound = newValue;
  },

  get branches() {
    return this.__branches;
  },

  set branches(newValue) {
    this.__branches = newValue;
  },

  get selectedLangCode() {
    return this.__selectedLangCode;
  },

  set selectedLangCode(newValue) {
    this.__selectedLangCode = newValue;
  },

  get nfcCode() {
    return this.__nfcCode;
  },

  set nfcCode(newValue) {
    this.__nfcCode = newValue;
  },

  get isEnabled() {
    return this.__isEnabled;
  },

  enable: function enable() {
    var _this = this;

    log$e('nfc.enable()');

    if (this.__$xp.device.platform === 'browser') {
      log$e('nfc.enable(): nfc is not available in browser');
      return;
    }

    if (window.nfc) {
      window.nfc.enabled(function (success) {
        log$e("Nfc is enabled, ".concat(success));

        if (_this.__$xp.device.platform === 'android') {
          if (_this.__isListenersAdded) {
            log$e('listeners are already added');
            _this.__isEnabled = true;
            return;
          }

          window.nfc.addNdefListener(_this.onNfcNdef.bind(_this), function () {
            _this.__isEnabled = true;
          }, function () {
            log$e('Error in nfc.addNdefListener');
          });
          _this.__isListenersAdded = true;
        } else _this.__isEnabled = true;
      }, function (failure) {
        log$e("Failed to enable Nfc, ".concat(failure));
      });
    } else {
      log$e('NFC plugin is missing!!');
    }
  },
  disable: function disable() {
    var _this2 = this;

    log$e('nfc.disable()');

    if (this.__$xp.device.platform === 'browser') {
      log$e('nfc.disable(): nfc is not available in browser');
    } else if (this.__$xp.device.platform === 'android') {
      this.__isEnabled = false;
    } else if (this.__$xp.device.platform === 'ios' && window.nfc) {
      this.__isEnabled = false;
      window.nfc.cancelScan().then(function (success) {
        log$e("Cancelled NFC session ".concat(success));
        _this2.__isEnabled = false;
      }, function (err) {
        log$e("Error cancelling session ".concat(err));
        _this2.__isEnabled = undefined;
      });
    }
    /**
     * see https://github.com/chariotsolutions/phonegap-nfc#nfcremovendeflistener
     * Removing listeners is not recommended. Instead, consider that your callback can ignore messages you no longer need.
     */
    // window.nfc.removeNdefListener(this.onNfcNdef.bind(this), () => { this.__isEnabled = false }, () => { log('Error in nfc.removeNdefListener') })
    // if (this.__$xp.device.platform === 'ios') {
    //   window.nfc.invalidateSession(() => {}, () => { log('Error in nfc.invalidateSession') }) // eslint-disable-line
    // }

  },
  onNfcNdef: function onNfcNdef(nfcEvent) {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var tag, i, message, payload, match, code, pageId;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this3.isEnabled) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              tag = nfcEvent.tag;
              log$e('onNfcNdef: ' + JSON.stringify(tag), _this3.__$xp);

              if (!(tag.ndefMessage && tag.ndefMessage.length)) {
                _context.next = 25;
                break;
              }

              _context.t0 = regenerator.keys(tag.ndefMessage);

            case 6:
              if ((_context.t1 = _context.t0()).done) {
                _context.next = 25;
                break;
              }

              i = _context.t1.value;
              message = tag.ndefMessage[i];
              payload = window.nfc.bytesToString(message.payload);
              log$e('onNfcNdef: payload = ' + payload);
              match = payload.match(/\/#\/nfc\/(.+)$/);

              if (!match) {
                _context.next = 23;
                break;
              }

              code = match[1];
              pageId = window.localStorage.getItem('nfcPageId') || _this3.__$xp.settings.mergedSettings.nfcPageId || _this3.__$xp.settings.mergedSettings.content.nfcPageId;
              log$e('onNfcNdef: pageId = ' + pageId);

              if (!pageId) {
                pageId = _this3.__$xp.settings.getValue('content.startPageID');
                log$e('onNfcNdef: pageId not found, using startPageID = ' + pageId);
              } // const path = `/page/${pageId}?nfcCode=${code}`


              _this3.nfcCode = code;
              _this3.lastNfcRoute = pageId;
              log$e('onNfcNdef: lastNfcRoute = ' + _this3.lastNfcRoute);
              _context.next = 22;
              return _this3.startNfcNavigation();

            case 22:
              return _context.abrupt("break", 25);

            case 23:
              _context.next = 6;
              break;

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  scanNdefIos: function scanNdefIos() {
    var _this4 = this;

    if (this.__$xp.device.platform === 'ios' && this.isEnabled) {
      window.nfc.scanNdef().then(function (iTag) {
        log$e("in scanNdefIos ".concat(iTag));

        _this4.onNfcNdef({
          tag: iTag
        });

        return true;
      }, function (err) {
        log$e('Error scanning tag on iOS', err);
        return false;
      });
    }
  },
  startNfcNavigation: function startNfcNavigation() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              log$e(_this5, _this5.__router);

              if (!(_this5.__router.currentRoute && _this5.__router.currentRoute.query.nfcCode || _this5.nfcCode)) {
                _context2.next = 8;
                break;
              }

              // log('nfcCode is defined, code: ', this.$route.query.nfcCode)
              // this.nfcCode = this.__router.currentRoute.query.nfcCode
              if (_this5.__router.currentRoute && _this5.__router.currentRoute.query.nfcCode) {
                _this5.nfcCode = _this5.__router.currentRoute.query.nfcCode;
              } else if (typeof _this5.nfcCode === 'string' && parseInt(_this5.nfcCode) > 0 && parseInt(_this5.nfcCode).toString() === _this5.nfcCode) {
                log$e(_this5.nfcCode);
                log$e('parsing nfcCode');
                _this5.nfcCode = parseInt(_this5.nfcCode);
              }

              log$e('should build branches');
              _context2.next = 6;
              return _this5.buildBranches();

            case 6:
              _context2.next = 9;
              break;

            case 8:
              log$e('this.$route.query.nfcCode undefined', _this5.$route);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  setAppLang: function setAppLang(lang) {
    window.localStorage.setItem('nfcLangCode', lang.langCode);
    this.$xp.polyglot.setLanguage(lang.langCode, lang.path);
    this.selectedLangCode = lang.langCode;

    this.__router.push('/' + lang.path + 'page/' + this.pageData.ID + '?nfcCode=' + this.$route.query.nfcCode);
  },
  goToPage: function goToPage(item) {
    log$e('goToPage', item);
    var selectedBranchIds = [];
    var p = item;

    while (p.ancestorId) {
      selectedBranchIds.push(p.ancestorId);
      p = this.nfcData.ancestors[p.ancestorId];
    }

    window.localStorage.setItem('nfcSelectedBranchIds', selectedBranchIds);

    this.__router.push('/page/' + item.id);
  },
  buildBranches: function buildBranches() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      var pageId, PageData;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              pageId = window.localStorage.getItem('nfcPageId') || _this6.__$xp.settings.mergedSettings.nfcPageId || _this6.__$xp.settings.mergedSettings.content.nfcPageId;
              _this6.lastNfcRoute = pageId;
              _context3.next = 4;
              return _this6.__$xp.http.getPageData(pageId);

            case 4:
              PageData = _context3.sent;
              _this6.nfcData = PageData.nfc;
              _this6.branches = [];
              _this6.selectedBranchIds = [];

              if (_this6.nfcData && _this6.nfcData.pages) {
                if (_this6.nfcData.pages[_this6.nfcCode]) {
                  if (_this6.nfcData.pages[_this6.nfcCode].length === 1 && _this6.nfcData.autoStart) {
                    _this6.goToPage(_this6.nfcData.pages[_this6.nfcCode][0]);
                  } else {
                    _this6.nfcData.pages[_this6.nfcCode].forEach(function (item) {
                      _this6.nfcCodeFound = true;

                      _this6.addBranchItem(item);
                    });

                    if (_this6.__router.currentRoute && _this6.__router.currentRoute.path.includes("/page/".concat(pageId))) {
                      log$e('in buildBranches, replacing path', _this6.lastNfcRoute);

                      _this6.__router.replace('/page/' + _this6.lastNfcRoute + '?nfcCode=' + _this6.nfcCode);
                    } else {
                      log$e('in buildBranches, pushing path', _this6.lastNfcRoute);

                      _this6.__router.push('/page/' + _this6.lastNfcRoute + '?nfcCode=' + _this6.nfcCode);
                    }
                  }
                }
              }

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  addBranchItem: function addBranchItem(item) {
    item = Object.assign({}, item);

    if (!item.children) {
      item.children = [];
    }

    if (item.ancestorId) {
      var found = this.branches.find(function (x) {
        return x.id === item.ancestorId;
      });

      if (found) {
        found.children.push(item);
      } else if (this.nfcData.ancestors[item.ancestorId]) {
        var ancestor = this.nfcData.ancestors[item.ancestorId];
        var added = this.addBranchItem(ancestor);
        added.children.push(item);
      }
    } else {
      this.branches.push(item);
    }

    return item;
  },
  resetState: function resetState() {
    this.branches = [];
    this.nfcCode = null;
    this.selectedLangCode = null;
    this.nfcCodeFound = false;
    this.selectedBranchIds = [];
    this.lastNfcRoute = null;
    this.nfcData = null;
  },
  install: function install(Vue, opts, $xp) {
    log$e('Installing NFC Plugin');
    var router = opts.router;

    if ($xp.nfcInstalled) {
      return;
    }

    if (!opts.router) {
      throw new Error('NFC plugin needs router to initialize');
    } // to-do test in a late if nfc plugin is available
    // if (window.nfc) {
    //   log('NFC plugin is present.')
    // } else if ($xp.device.platform !== 'browser') {
    //   throw new Error('NFC plugin is missing!!')
    // }


    this.__$xp = $xp;
    this.__router = router;

    this.__router.addRoutes([{
      path: '/nfc/:nfcCode',
      redirect: function redirect(to) {
        var pageId = window.localStorage.getItem('nfcPageId') || $xp.settings.getValue('content.nfcPageId');

        if (!pageId) {
          pageId = $xp.settings.getValue('content.startPageID');
        }

        var langUrlPath = $xp.polyglot.urlPath;
        var localStorageLangCode = window.localStorage.getItem('nfcLangCode');

        if (localStorageLangCode && localStorageLangCode !== $xp.polyglot.locale) {
          var _iterator = _createForOfIteratorHelper($xp.settings.mergedSettings.content.languages),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var lang = _step.value;

              if (lang.langCode === localStorageLangCode) {
                langUrlPath = lang.path;
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        return {
          path: "/".concat(langUrlPath, "page/").concat(pageId),
          query: {
            nfcCode: to.params.nfcCode
          }
        };
      }
    }]);

    $xp.nfcInstalled = true;
    Vue.util.defineReactive($xp, 'nfc', this);
  }
};

var nfc$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': nfc
});

var entry = {
  mixins: [localPageData],
  props: {
    entryData: {
      type: Object,
      required: true
    }
  }
};

var EventHub = {
  Bus: new Vue(),
  TYPES: {
    RE_INIT_IMAGE_MAP: 're-initialize-image-map',
    START_PLAY_MEDIA: 'start-play-media',
    ANDROID_ACTIVITY_PAUSE: 'android-activity-pause',
    CLICKED_HOTSPOT_SPLASHSCREEN: 'clicked_hotspot_splashscreen'
  }
};

var vm$1 = new Vue();
var nonLangPageRedirect = function nonLangPageRedirect(to) {
  var newTo = Object.assign({}, to, {
    path: "/".concat(vm$1.$xp.polyglot.urlPath).concat(to.path).replace('//', '/')
  });
  return newTo;
};

var saveScrollValue = function saveScrollValue(appInstance, to, from) {
  if (!to.query.back) {
    var scrollTopValue = null;
    var scrollableElement = document.querySelector('div.js-page-content');

    if (scrollableElement) {
      scrollTopValue = scrollableElement.scrollTop;
      vm$1.$xp.history.setHistoryParam(from.params.id, 'lastScrollTop', scrollTopValue);
    }
  }
};

var beforeEach = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(to, from, next) {
    var currentPageData;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            vm$1.$xp.navigation.isEventConsumerEnabled = true;
            setTimeout(function () {
              vm$1.$xp.navigation.isEventConsumerEnabled = false;
            }, 60); // save scroll before leaving page

            !to.query.back && saveScrollValue(vm$1, to, from);

            if (!(to.path === '/' && !vm$1.$xp.device.isLoan && vm$1.$xp.settings.mergedSettings.content && vm$1.$xp.settings.mergedSettings.content.startPageID)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", next('/_/page/' + vm$1.$xp.settings.mergedSettings.content.startPageID));

          case 7:
            if (!(vm$1.$xp.device.platform === 'browser' && vm$1.$xp.settings.mergedSettings.content && vm$1.$xp.settings.mergedSettings.content.welcomeScreenId && to.path !== '/')) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", next({
              path: "/".concat(this.$xp.polyglot.urlPath, "page/").concat(vm$1.$xp.settings.mergedSettings.content.welcomeScreenId),
              query: {
                backToPath: to.path
              }
            }));

          case 9:
            _context.t0 = to.path;
            _context.next = _context.t0 === '/page/0' ? 12 : _context.t0 === '/_/page/0' ? 12 : _context.t0 === '/page/next-page' ? 14 : _context.t0 === '/_/page/next-page' ? 14 : _context.t0 === '/page/back' ? 15 : _context.t0 === '/_/page/back' ? 15 : _context.t0 === '/page/home' ? 17 : _context.t0 === '/_/page/home' ? 17 : 19;
            break;

          case 12:
            vm$1.$xp.history.resetHistoryState();
            return _context.abrupt("return", next(from.query.backToPath));

          case 14:
            return _context.abrupt("return", next({
              path: "/page/".concat(vm$1.$xp.history.nextPageId),
              replace: true
            }));

          case 15:
            next(false);
            return _context.abrupt("return", vm$1.$xp.history.back(true));

          case 17:
            next(false);
            return _context.abrupt("return", vm$1.$xp.history.goHome(true));

          case 19:
            if (!(to.name === 'Page')) {
              _context.next = 29;
              break;
            }

            _context.next = 22;
            return vm$1.$xp.http.loadPage(to);

          case 22:
            currentPageData = _context.sent;
            console.log('In Router should skip page', currentPageData.Title, currentPageData.Class);

            if (!(currentPageData && currentPageData.Title === 'SkipPage')) {
              _context.next = 28;
              break;
            }

            return _context.abrupt("return");

          case 28:
            return _context.abrupt("return", next());

          case 29:
            return _context.abrupt("return", next());

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function beforeEach(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var handleExternalUrl = function handleExternalUrl(url) {
  if (vm$1.$xp.device.isLoan) {
    console.log('should show dialog, device is loan and external url is clicked, this functionality is not permitted on loan devices'); // window.navigator.notification.alert(vm.$t('global.externalUrlLoanHinweis'), () => { console.log('No External Url alertOnLoan Callback.') }, vm.$t('global.error'), vm.$t('global.continue'))
  } else if (vm$1.$xp.device.platform === 'browser') {
    window.open(url, 'tab');
  } else if (vm$1.$xp.device.platform === 'android' || vm$1.$xp.device.platform === 'ios') {
    if (window.cordova && window.cordova.InAppBrowser) {
      window.cordova.InAppBrowser.open(url, '_system');
    }
  }
};
var getXpedeoPrefixUrlPageId = function getXpedeoPrefixUrlPageId(url) {
  url = url.replace('xpedeo://', '');
  var pageId = null;

  switch (url) {
    case 'LastPanoramaID':
      {
        var lastPanoramaPageId = vm$1.$xp.history.getLastPanoramaPage(vm$1.$xp.history.lastHomePage.pageId);
        var defaultPanoramaPageId = vm$1.$xp.content.pageData.Homepage ? vm$1.$xp.content.pageData.Homepage.DefaultPanoramaPageID : null;
        pageId = lastPanoramaPageId || defaultPanoramaPageId;
      }
      break;

    case 'next':
      pageId = url;
      break;

    default:
      if (url.includes('preload')) {
        pageId = url;
      }

      break;
  }

  return pageId;
}; // to-do : refactor to take care of types

var handleUrl = function handleUrl(url, router) {
  var isTab = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (typeof url === 'string' && url.startsWith('xpedeo://')) {
    var pageId = getXpedeoPrefixUrlPageId(url);

    if (pageId) {
      if (typeof pageId === 'string' && pageId.includes('preload')) {
        console.log('switch to preload page');
        var urlParts = pageId.split('/').filter(function (i) {
          return i;
        });
        console.log('urlparts ', urlParts); // preloadModules = urlParts[0]
        // console.log()

        var nextPageId = urlParts[1].replace('NID=', '');
        console.log(urlParts);
        window.localStorage.setItem('preloadNextPageId', nextPageId); // router.push('/preload/' + urlParts[0])

        console.log('isOnline', vm$1.$xp.network.isOnline);

        if (!vm$1.$xp.network.isOnline) {
          console.log('Offline, cannot preload'); // window.navigator.notification.alert(vm.$t('global.errorOffline'))
        } else {
          vm$1.$xp.content.showPreloadModal = true;
        }

        vm$1.$xp.content.preloadPath = urlParts[0];
      } else if (typeof pageId === 'string' && pageId === 'next') {
        if (vm$1.$xp.content.pageData.NextPageID) {
          router.push('/page/' + vm$1.$xp.content.pageData.NextPageID);
        } else {
          console.warn('Splash screen has no next page');
        }
      } else if (isTab) {
        !router.history.current.path.includes(pageId) && router.replace({
          path: "/page/".concat(pageId),
          query: {
            replace: true
          }
        });
      } else {
        router.push("/page/".concat(pageId));
      }
    } else {
      console.error('Cannot determine pageId from Url: ', url);
    }
  } else if (isTab) {
    if (!router.history.current.path.includes(url)) {
      vm$1.$xp.navigation.setActiveTabId(url);
      router.replace({
        path: "/page/".concat(url),
        query: {
          replace: true
        }
      });
    }
  } else if (typeof url === 'string' && url.startsWith('http')) {
    handleExternalUrl(url);
  } else if (typeof url === 'string' && (url.startsWith('/page/') || url.startsWith('#/page/'))) {
    if (url.startsWith('#/page/')) url = url.replace('#', '');
    router.push(url);
  } else if (typeof url === 'string' && url.startsWith('/lang')) {
    var urls = url.split('/'); // e.g : /lang/en_EN/en/page/xxxx

    var langIndex = url.indexOf('lang');
    var langCode = urls[langIndex + 1];
    var langPath = urls[langIndex + 2];
    var _pageId = urls[langIndex + 4];
    console.log(urls);
    window.localStorage.setItem('nfcLangCode', langCode);
    vm$1.$xp.polyglot.setLanguage(langCode, langPath);
    router.push("/page/".concat(_pageId));
  }
};

var XpBgImg = Vue.extend({
  name: 'XpBgImg',
  props: {
    tag: {
      type: String,
      required: true
    },
    src: String,
    placeholderSrc: String,
    lazyload: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      currentSrc: '',
      image: null,
      isLoading: !!this.src,
      hasError: false,
      intersectionObserver: null
    };
  },
  watch: {
    src: function src() {
      this.load();
    }
  },
  computed: {
    url: function url() {
      return this.src || undefined;
    },
    style: function style() {
      return {
        backgroundImage: 'url(' + this.currentSrc + ')'
      };
    },
    lowstyle: function lowstyle() {
      return {
        backgroundImage: 'url(' + this.placeholderSrc + ')'
      };
    }
  },
  methods: {
    __onLoad: function __onLoad() {
      this.isLoading = false;
      this.hasError = false;

      this.__updateSrc();

      this.$emit('load', this.currentSrc);
    },
    __onError: function __onError(err) {
      // console.warn(err)
      this.isLoading = false;
      this.hasError = true;
      this.currentSrc = '';
      this.$emit('error', err);
    },
    __updateSrc: function __updateSrc() {
      if (this.image !== undefined && this.isLoading === false) {
        var src = this.image.currentSrc || this.image.src;

        if (this.currentSrc !== src) {
          this.currentSrc = src; // this.$forceUpdate()
        }
      }
    },
    __load: function __load() {
      var _this = this;

      this.hasError = false;

      if (!this.src) {
        this.isLoading = false;
        this.image = undefined;
        this.currentSrc = '';
        return;
      }

      this.isLoading = true;
      var img = new Image();
      this.image = img;
      this.$xp.http.getFileUrl(this.src, undefined, false).then(function (data) {
        if (_this.destroyed === true) {
          return;
        }

        img.src = data; // if we are still rendering same image

        if (_this.image === img) {
          _this.__onLoad(img);
        }
      }).catch(function (error) {
        // if we are still rendering same image
        if (_this.image === img && _this.destroyed !== true) {
          _this.__onError(error);
        }
      });
    },
    __unload: function __unload() {
      this.image = undefined;
      this.currentSrc = '';
    }
  },
  render: function render(createElement) {
    return createElement( // Element with Low-Fi Source
    this.tag, {
      style: this.lowstyle,
      attrs: {
        'data-binary-src': this.placeholderSrc,
        'aria-hidden': true
      }
    }, [createElement( // BG-Element with optimal Source
    'div', {
      style: this.style,
      attrs: {
        'data-binary-src': this.src,
        'aria-hidden': true
      }
    })]);
  },
  beforeMount: function beforeMount() {
    if (this.placeholderSrc !== undefined) {
      var img = new Image();
      img.src = this.placeholderSrc;
    }

    this.isLoading = !(this.lazyload && window.IntersectionObserver);
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.lazyload && window.IntersectionObserver) {
      var options = {
        root: document.querySelector('.c-page-container'),
        rootMargin: '0px',
        threshold: 0
      };
      this.intersectionObserver = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio > 0) {
          _this2.__load();
        }
      }, options);
      this.intersectionObserver.observe(this.$el);
    } else {
      this.__load();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyed = true;

    if (this.intersectionObserver) {
      this.intersectionObserver.unobserve(this.$el);
      this.intersectionObserver = null;
    }

    this.isLoading && this.$xp.http.cancelRequest(this.src);
    if (this.image) this.image.src = '';
  }
});

var lipSync = {
  mounted: function mounted() {
    this.lipSyncConnection = null;
    this.player = null;
    this.lipSyncPageId = 0;
    this.maxLatency = 0;
  },
  methods: {
    startLipSync: function startLipSync(player) {
      this.player = player;
      this.isAudio = player.nodeName === 'AUDIO';
      console.log('lipsync player:', this.player);
      var maxLipsyncLatency = this.$xp.settings.mergedSettings.maxLipsyncLatency;
      this.maxLatency = this.isAudio ? maxLipsyncLatency.audio : maxLipsyncLatency.video;
      console.log('lipsync max latency: ' + this.maxLatency);
      this.lipSyncPageId = parseInt(this.$route.params.id);
      this.retryConnect = 0;
      this.connectLipSyncServer();
    },
    stopLipSync: function stopLipSync() {
      if (this.lipSyncConnection) {
        this.lipSyncConnection.close();
      }
    },
    connectLipSyncServer: function connectLipSyncServer() {
      var _this = this;

      this.ntpOffset = 9999999999;
      this.ntpCount = 0;
      this.deltaPlayPos = 0;
      this.seekLatency = this.isAudio ? 230 : 1200; // preset value

      this.seekLatencyHistory = [this.seekLatency];
      this.retryConnect++;
      var url = this.lipSyncUrl;

      if (url.match(/<servername>/)) {
        var baseUrl = this.$xp.settings.baseUrl;
        var matches = /^http.?:\/\/([^/]+)\/.*$/.exec(baseUrl);

        if (matches) {
          url = url.replace(/<servername>/, matches[1]);
        }
      }

      this.lipSyncConnection = new WebSocket(url);
      this.syncing = true;
      this.seekLatencyIgnoreFirst = true;

      this.lipSyncConnection.onopen = function (e) {
        _this.onConnectionOpen(e);
      };

      this.lipSyncConnection.onerror = function (e) {
        _this.onConnectionError(e);
      };

      this.lipSyncConnection.onmessage = function (e) {
        _this.onConnectionMessage(e);
      };

      this.lipSyncConnection.onclose = function (e) {
        _this.onConnectionClose(e);
      };
    },
    onConnectionOpen: function onConnectionOpen(error) {
      console.log(error);
      this.sendNtpReq();
    },
    onConnectionError: function onConnectionError(error) {
      var _this2 = this;

      console.log(error);

      if (this.lipSyncConnection) {
        this.lipSyncConnection.close();
        this.lipSyncConnection = null;
      }

      if (this.retryConnect < 10) {
        setTimeout(function () {
          _this2.connectLipSyncServer();
        }, 1000);
      }
    },
    sendNtpReq: function sendNtpReq() {
      var data = {
        Type: 'NTP',
        Req: Date.now(),
        PageID: parseInt(this.$route.params.id)
      };
      this.lipSyncConnection.send(JSON.stringify(data));
    },
    onConnectionMessage: function onConnectionMessage(e) {
      var data = null;

      try {
        data = JSON.parse(e.data);
      } catch (e) {
        console.log(e);
      }

      if (data) {
        switch (data.Type) {
          case 'NTP':
            this.onNtpMessage(data);
            break;

          case 'POS':
            if (!this.syncing) {
              this.onPosMessage(data);
            }

            break;
        }
      }
    },
    onNtpMessage: function onNtpMessage(data) {
      // check if this is the right page for the current video
      var currentPageId = parseInt(this.$route.params.id);

      if (currentPageId !== this.lipSyncPageId) {
        this.stopLipSync();
      } else if (data.PageID !== null && data.PageID !== this.lipSyncPageId) {
        console.log('lipsync: redirect to page ' + data.PageID);
        this.stopLipSync();
        this.$router.replace({
          path: '/page/' + data.PageID,
          query: {
            replace: true
          }
        });
      }

      var now = Date.now();
      var offset = Math.round(now - data.Timestamp + (now - data.Req) / 2);
      this.ntpCount++;

      if (offset < this.ntpOffset) {
        this.ntpOffset = offset;
        console.log('ntpOffset=' + this.ntpOffset);
      }

      if (this.ntpCount < 10) {
        this.sendNtpReq();
      } else {
        this.syncing = false;
      }
    },
    onPosMessage: function onPosMessage(data) {
      var _this3 = this;

      // check if this is the right page for the current video
      var currentPageId = parseInt(this.$route.params.id);

      if (currentPageId !== this.lipSyncPageId) {
        this.stopLipSync();
      } else if (data.PageID !== null && data.PageID !== this.lipSyncPageId) {
        this.$router.replace({
          path: '/page/' + data.PageID,
          query: {
            replace: true
          }
        });
      }

      if (!this.ready) {
        if (this.autoPlay) {
          // if (this.video) { this.video.play() } else if (this.sound) { this.sound.play() }
          this.player.play();
        }

        this.ready = true;
      }

      var now = Date.now() - this.ntpOffset;
      var currentDelta = now - this.player.currentTime * 1000;
      this.deltaPlayPos = data.DeltaPlayPos;

      if (this.player.paused || Math.abs(currentDelta - this.deltaPlayPos) > this.maxLatency) {
        this.player.currentTime = (now - this.deltaPlayPos + this.seekLatency) / 1000;
        setTimeout(function () {
          var now = Date.now() - _this3.ntpOffset;

          var currentDelta = now - _this3.player.currentTime * 1000;
          var seekLatency = currentDelta - _this3.deltaPlayPos;

          _this3.setSeekLatency(seekLatency);
        }, 400);
        console.log('SET DD:' + (currentDelta - this.deltaPlayPos) + ', deltaPlayPos:' + this.deltaPlayPos + ', currentDelta:' + currentDelta + ', latency:' + (currentDelta - this.deltaPlayPos));
      }
    },
    onConnectionClose: function onConnectionClose() {
      this.retryConnect = 0;
      this.player.pause();
    },
    setSeekLatency: function setSeekLatency(newValue) {
      if (this.seekLatencyIgnoreFirst) {
        this.seekLatencyIgnoreFirst = false;
      } else {
        if (Math.abs(newValue) < 500) {
          var seekLatency = Math.floor(newValue + this.seekLatency);
          this.seekLatencyHistory.push(seekLatency);
          if (this.seekLatencyHistory.length > 5) this.seekLatencyHistory.shift();
          var sum = 0;
          var div = 0;

          for (var i = 0; i < this.seekLatencyHistory.length; i++) {
            sum += this.seekLatencyHistory[i] * (i + 1);
            div += i + 1;
          }

          console.log('seekLatencyHistory:' + this.seekLatencyHistory);
          this.seekLatency = Math.floor(sum / div);
          console.log('correct seekLatency(' + newValue + ') => ' + this.seekLatency);
        } else {
          console.warn('seekLatency:' + (this.seekLatency + newValue));
        }
      }
    }
  }
};

export { httpPlugin as A, Battery as B, Content as C, Device as D, EventHub as E, nfc as F, Cart as G, History as H, localPageData as I, nonLangPageRedirect as J, beforeEach as K, getXpedeoPrefixUrlPageId as L, Media as M, Navigation as N, Polyglot as P, Settings as S, Wifi as W, XpBgImg as X, _asyncToGenerator as _, _typeof as a, _toConsumableArray as b, _objectSpread2 as c, debounce as d, entry as e, handleUrl as f, _createForOfIteratorHelper as g, handleExternalUrl as h, page as i, _defineProperty as j, _createClass as k, lipSync as l, _classCallCheck as m, _slicedToArray as n, _inherits as o, position as p, _createSuper as q, regenerator as r, src as s, throttle as t, _get as u, _getPrototypeOf as v, writeEvaRecord as w, plugin as x, Screen as y, Network as z };
//# sourceMappingURL=index2.js.map
